import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, ViewEncapsulation, Input, Output, ChangeDetectionStrategy, ViewChild, NgModule } from '@angular/core';
import * as i15$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i19 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import * as i15 from '@ft/core';
import { SCALE_ANIMATION, HEIGHT_ANIMATION, INPUT_TIME_FORMAT, NAIVE_DATE_FORMAT, LARGE_DIALOG, SMALL_DIALOG, DebounceSearch, MaterialModule, FtCoreModule } from '@ft/core';
import * as i10 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i5$1 from '@ngx-translate/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as i11$1 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { cloneDeep, reject, get, find, chain, map, assignIn, isNil, pick, update, findIndex, isEmpty, join, filter, forEach, first, lowerCase, every, noop, isUndefined, groupBy, isFunction, last, compact, flatten, isString, assign, isArray, has, isObject, isEqual, set, merge as merge$1, concat, reduce } from 'lodash';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i3 from '@angular/material/toolbar';
import * as i4 from '@angular/material/icon';
import * as i5 from '@angular/material/slide-toggle';
import * as i2 from '@angular/material/button';
import * as i7 from '@angular/material/sidenav';
import * as i8 from '@angular/material/list';
import * as i9 from '@angular/material/form-field';
import * as i4$1 from '@angular/material/select';
import * as i11 from '@angular/material/core';
import * as i12 from '@angular/material/datepicker';
import * as i14 from '@angular/flex-layout/flex';
import * as i18 from '@angular/material/input';
import * as i16 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import moment from 'moment';
import * as i8$1 from '@angular/material/expansion';
import * as i5$2 from '@angular/material/checkbox';
import * as i6 from '@angular/material/tooltip';
import * as i2$1 from '@angular/material-moment-adapter';
import * as i4$2 from '@angular/material/snack-bar';
import * as i9$1 from '@angular/material/radio';
import * as i14$1 from '@angular/material/button-toggle';
import * as i18$1 from '@angular/flex-layout/extended';
import { merge, BehaviorSubject } from 'rxjs';
import { startWith, tap, map as map$1, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import * as i6$1 from '@angular/material/sort';
import { MatSort } from '@angular/material/sort';
import * as i4$3 from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import * as i1$2 from '@angular/platform-browser';
import * as i12$1 from 'ng-busy';

const lang$1 = {
    'search-multi-criteria': 'Recherche multicritère',
    'invoice_number': 'N°. Facture',
    'invoice_date': 'Date',
    'invoice_beneficiary': 'Bénéficiaire',
    'taxed_amount': 'Montant TTC',
    'deadline': 'Echeance',
    'and': 'Et',
    'or': 'Ou',
    'filter': 'Filtre',
    'no_filter': 'Aucun filtre',
    'date': 'Date',
    'condition': 'opérateur',
    'next-page': 'Page suivante',
    'previous-page': 'Page précédente',
    'of': 'de',
    'select': 'Selectionner',
    'reset': 'Annuler',
    'advanced_filter': 'Recherche personnalisé',
    'value': 'Valeur',
    'applyFilter': 'Appliquer',
    'erase': 'Effacer',
    'create_new_view': 'Crée une vue',
    'save': 'Enregistrer',
    'save_filter': 'Enregistrer le filtre',
    'view_name': 'Nom',
    'choose_column': 'Choisir une colonne',
    'choose_columns': 'Choisir les colonnes',
    'available': 'Disponible',
    'selected': 'Selectionné',
    'share_with': 'Partagé avec',
    'with_no_body': 'Aucun',
    'with_all': 'Public',
    'with': 'Avec',
    'is_default': 'Par défaut',
    'save_and_exit': 'Enregistrer et quitter',
    'operator': 'Opérateur',
    'favorite': 'Favoris',
    'regroup_by': 'Regrouper',
    'save_current_search': 'Enregistrer la recherche actuel',
    'use_as_default': 'Utilisé par défaut',
    'share_with_all': 'Partagé avec tout les utilisateurs',
    'share_by_service': 'partagé par service',
    'share_by_department': 'partagé par département',
    'none': 'Privé',
    'name': 'Name',
    'service': 'Service',
    'department': 'Département',
    'search': 'Rechercher',
    'no_element_to_show': 'Aucun élément trouvé',
    'table_items_per_page_label': 'Lignes par Page',
    'table_next_page_label': 'Page suivante',
    'table_previous_page_label': 'Page précédente',
    'table_first_page_label': 'Première page',
    'table_last_page_label': 'Dernière page',
    'range_page_label_1': '0 de {{length}}',
    'range_page_label_2': '{{startIndex}} - {{endIndex}} de {{length}}',
    'clear': 'Effacer',
    'filterBy': 'Filtrer Par...',
    'apply_filter': 'Filtrer',
    'is': 'Est',
    'write_here': 'Valeur',
    'write_view_name': 'Nom',
    'equal': 'est égal à',
    'n_equal': 'est différent de',
    'after': 'est après',
    'before': 'est avant',
    'between': 'est entre',
    'exists': 'est vide',
    'n_exists': 'n’est pas vide',
    'little': 'Inférieur à',
    'greaterE': 'supérieur ou égal à',
    'littleE': 'inférieur ou égal à',
    'greater': 'Supérieur à',
    'contains': 'Contient',
    'n_contains': 'ne contient pas',
    'text_$eq': 'est',
    'text_$ne': 'est différent(e) de',
    'text_$exists': 'est vide',
    'text_$nexists': 'n’est pas vide',
    'text_$icontain': 'contient',
    'text_$ncontain': 'ne contient pas',
    'number_$eq': '==',
    'number_$ne': '≠',
    'number_$exists': 'est vide',
    'number_$nexists': 'n’est pas vide',
    'number_$between': '=< =<',
    'number_$gt': '>',
    'number_$lt': '<',
    'number_$gte': '>=',
    'number_$lte': '<=',
    'date_$eq': 'est égal à',
    'date_$ne': 'est différent de',
    'date_$exists': 'est vide',
    'date_$nexists': 'n’est pas vide',
    'date_$between': 'Compris entre',
    'date_$gt': 'est après',
    'date_$lt': 'est avant',
    'no_item_found': 'Aucun élément trouvé',
    'new_filter': 'Nouveau Filtre',
    'update_columns': 'Modifier l\'affichage',
    'new_view': 'Nouvelle Vue',
    'view': 'Vue',
    'columns_list': 'Liste des colonnes',
    'select_column': 'Selectionner un champ',
    'choose_operator': 'Condition',
    'edit_view': 'Modifier',
    'view_name_exist_error': 'Le nom de vue existe déja',
    'saved_filters': 'Filtres Enregistrés',
    'filter_name_exist': 'Nom de filtre existe déja',
    'update_filter': 'Mettre à jour le filtre',
    'clear_filter': 'Effacer le Filtre',
    'no_filter_saved': 'Aucun filter enregistré',
    'choose_date': 'Date',
    'export_excel_page_name': 'Listes',
    'style_rules': 'Règles de mise en forme',
    'style_rules_condition': 'Mettre en forme les cellules si...',
    'apply_style': 'Appliquer à',
    'formatting_style': 'Style de mise en forme',
    'apply': 'Appliquer',
    'cancel': 'Annuler',
    'is_empty': 'Est vide',
    'is_not_empty': 'N\'est pas vide',
    'is_contains': 'Le texte contient',
    'not_contains': 'Le texte ne contient pas',
    'start_with': 'Le texte commence par',
    'end_with': 'Le texte se termine par',
    'exactly': 'Le texte est exactement',
    'date_is': 'La date est',
    'is_before': 'La date est antérieure à',
    'is_after': 'La date est postérieur à',
    'time_is': 'Le temps est',
    'time_is_before': 'Le temps est antérieure à',
    'time_is_after': 'Le temps est postérieur à',
    'is_between': 'Est compris(e) entre',
    'not_between': 'N\'est pas compris(e) entre',
    'is_true': 'Est vrai',
    'is_false': 'Est faux',
    'column': 'Column',
    'row': 'Ligne',
    'show_style': 'Aperçu',
    'add_rule': 'Ajouter une règle',
    'display_mode': 'Mode d\'affichage',
    'mode_text': 'Text',
    'mode_icon': 'Icon',
    'mode_badge': 'Badge',
    'mode_boolean': 'Boolean',
    'no_rule': 'Aucune règle de style trouvée!',
    'choose_icon': 'Cliquer pour choisir une icon',
    'update_column_error': 'Le mode d\'affichage est changé, ce column n\'existe pas',
    'from_date': 'De',
    'to_date': 'À'
};

const lang = {
    'search-multi-criteria': 'Multi-criteria research',
    'invoice_number': 'Invoice N°.',
    'invoice_date': 'Date',
    'invoice_beneficiary': 'Beneficiary',
    'taxed_amount': 'TTC amount',
    'deadline': 'Due date',
    'and': 'And',
    'or': 'Or',
    'filter': 'Filter',
    'no_filter': 'No filter',
    'date': 'Date',
    'condition': 'operator',
    'next-page': 'Next page',
    'previous-page': 'Previous page',
    'of': 'of',
    'select': 'Select',
    'reset': 'Cancel',
    'advanced_filter': 'Personalized search',
    'value': 'Value',
    'applyFilter': 'Apply',
    'erase': 'Erase',
    'create_new_view': 'Create a view',
    'save': 'Save',
    'save_filter': 'Save filter',
    'view_name': 'Name',
    'choose_column': 'Choose a column',
    'choose_columns': 'Choose columns',
    'available': 'Available',
    'selected': 'Selected',
    'share_with': 'Shared with',
    'with_no_body': 'Any',
    'with_all': 'Public',
    'with': 'With',
    'is_default': 'Default',
    'save_and_exit': 'Save and exit',
    'operator': 'Operator',
    'favorite': 'Favorite',
    'regroup_by': 'Gather',
    'save_current_search': 'Save Current Search',
    'use_as_default': 'Default',
    'share_with_all': 'Shared with all users',
    'share_by_service': 'shared by service',
    'share_by_department': 'Shared by department',
    'none': 'Private',
    'name': 'Name',
    'service': 'Service',
    'department': 'Department',
    'search': 'Search',
    'no_element_to_show': 'No element found',
    'table_items_per_page_label': 'Lines per page',
    'table_next_page_label': 'Next page',
    'table_previous_page_label': 'Previous page',
    'table_first_page_label': 'First page',
    'table_last_page_label': 'Last page',
    'range_page_label_1': '0 from {{length}}',
    'range_page_label_2': '{{startIndex}} - {{endIndex}} of {{length}}',
    'clear': 'Clear',
    'filterBy': 'Filter by...',
    'apply_filter': 'Filter',
    'is': 'Is',
    'write_here': 'Value',
    'write_view_name': 'Name',
    'equal': 'is equal to',
    'n_equal': 'is different from',
    'after': 'is after',
    'before': 'is before',
    'between': 'entered',
    'exists': 'is empty',
    'n_exists': 'is not empty',
    'little': 'Less than',
    'greaterE': 'greater than or equal to',
    'littleE': 'less than or equal to',
    'greater': 'greater than',
    'contains': 'Contains',
    'n_contains': 'does not contain',
    'text_$eq': 'is',
    'text_$ne': 'is different from',
    'text_$exists': 'is empty',
    'text_$nexists': 'is not empty',
    'text_$icontain': 'contains',
    'text_$ncontain': 'does not contain',
    'number_$eq': '==',
    'number_$ne': '≠',
    'number_$exists': 'is empty',
    'number_$nexists': 'is not empty',
    'number_$between': '=< =<',
    'number_$gt': '>',
    'number_$lt': '<',
    'number_$gte': '>=',
    'number_$lte': '<=',
    'date_$eq': 'is equal to',
    'date_$ne': 'is different from',
    'date_$exists': 'is empty',
    'date_$nexists': 'is not empty',
    'date_$between': 'Between',
    'date_$gt': 'is after',
    'date_$lt': 'is before',
    'no_item_found': 'No element found',
    'new_filter': 'New filter',
    'update_columns': 'Change the display',
    'new_view': 'New view',
    'view': 'View',
    'columns_list': 'List of columns',
    'select_column': 'Select a field',
    'choose_operator': 'Condition',
    'edit_view': 'modify',
    'view_name_exist_error': 'The view name already exists',
    'saved_filters': 'Saved filters',
    'filter_name_exist': 'Filter name already exists',
    'update_filter': 'Update the filter',
    'clear_filter': 'Erase the filter',
    'no_filter_saved': 'No recorded filter',
    'choose_date': 'Date',
    'export_excel_page_name': 'Lists',
    'style_rules': 'Formatting rules',
    'style_rules_condition': 'Format the cells if ...',
    'apply_style': 'Apply to',
    'formatting_style': 'Formatting style',
    'apply': 'Apply',
    'cancel': 'Cancel',
    'is_empty': 'Is empty',
    'is_not_empty': 'Is not empty',
    'is_contains': 'The text contains',
    'not_contains': 'The text does not contain',
    'start_with': 'The text starts with',
    'end_with': 'The text ends with',
    'exactly': 'The text is exactly',
    'date_is': 'The date is',
    'is_before': 'The date is earlier than',
    'is_after': 'The date is after',
    'time_is': 'The time is',
    'time_is_before': 'Time is earlier than',
    'time_is_after': 'The time is after',
    'is_between': 'Is between',
    'not_between': 'Is not between',
    'is_true': 'Is right',
    'is_false': 'Is wrong',
    'column': 'Column',
    'row': 'Line',
    'show_style': 'Overview',
    'add_rule': 'Add a rule',
    'display_mode': 'Display mode',
    'mode_text': 'Text',
    'mode_icon': 'Icon',
    'mode_badge': 'Badge',
    'mode_boolean': 'Boolean',
    'no_rule': 'No style rule found!',
    'choose_icon': 'Click to choose an icon',
    'update_column_error': 'The display mode is changed, this column does not exist',
    'from_date': 'From',
    'to_date': 'To'
};

class FtViewService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    handleView(view) {
        let url;
        let tableView;
        tableView = cloneDeep(view);
        tableView.columns = reject(tableView.columns, { key: 'actions' });
        url = `/api/table-view/${get(tableView, 'id') ? tableView.id + '/' : ''}`;
        return this.http.post(url, tableView);
    }
    getConfig(key) {
        return this.ws.call('table.get_config', { configKey: key });
    }
    handleConfig(config) {
        let url;
        url = `/api/table-config/${get(config, 'id') ? config.id + '/' : ''}`;
        return this.http.post(url, config);
    }
    updateConfig(config) {
        let url;
        url = `/api/table-config/${get(config, 'id') ? config.id + '/' : ''}`;
        return this.http.put(url, config);
    }
    updateView(_id, data) {
        let url;
        url = `/api/table-view/${_id ? _id + '/' : ''}`;
        return this.http.put(url, data);
    }
    getView(_id) {
        let url;
        url = `/api/table-view/${_id ? _id + '/' : ''}`;
        return this.http.get(url);
    }
    handleData(model, ns, vId, q, resourceName, topic) {
        return this.ws.call(topic ? `${topic}.list` : 'table.list', {
            configKey: model,
            namespace: ns,
            viewId: vId,
            query: q,
            model_resource: resourceName
        });
    }
    generateExcelFile(model, q, excelColumns, translatedCols, _viewId, _nameSpace, resourceName, topic) {
        return this.ws.call(topic ? `${topic}.generate_excel` : 'table.generate_excel', {
            configKey: model,
            query: q,
            translated_columns: translatedCols,
            model_resource: resourceName,
            viewId: _viewId,
            nameSpace: _nameSpace,
            columns: excelColumns
        });
    }
}
FtViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtViewService, deps: [{ token: i1.HttpClient }, { token: i15.FtWsService }], target: i0.ɵɵFactoryTarget.Injectable });
FtViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtViewService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtViewService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i15.FtWsService }]; } });

const FILTER_OPERATORS = [
    {
        type: 'text',
        operators: ['$eq', '$ne', '$exists', '$nexists', '$icontain', '$ncontain']
    },
    {
        type: 'number',
        operators: ['$eq', '$ne', '$exists', '$nexists', '$between', '$gt', '$lt', '$gte', '$lte']
    },
    {
        type: 'date',
        operators: ['$eq', '$ne', '$exists', '$nexists', '$gt', '$lt', '$between']
    }
];

const STYLE_RULE_FILTER_OPERATORS = [
    {
        type: ['text', 'date', 'icon', 'badge', 'time', 'datetime'],
        /*values: [
            'is_empty', 'is_not_empty', 'is_contains',
            'not_contains', 'start_with', 'end_with', 'exactly'
        ],*/
        operators: [
            { key: 'is_empty', label: 'table.is_empty', numberTextField: 0 },
            { key: 'is_not_empty', label: 'table.is_not_empty', numberTextField: 0 }
        ]
    },
    {
        type: ['text', 'icon', 'badge'],
        operators: [
            // {key: 'is_empty', label: 'table.is_empty', numberTextField: 0},
            // {key: 'is_not_empty', label: 'table.is_not_empty', numberTextField: 0},
            { key: 'is_contains', label: 'table.is_contains', numberTextField: 1 },
            { key: 'not_contains', label: 'table.not_contains', numberTextField: 1 },
            { key: 'start_with', label: 'table.start_with', numberTextField: 1 },
            { key: 'end_with', label: 'table.end_with', numberTextField: 1 },
            { key: 'exactly', label: 'table.exactly', numberTextField: 1 }
        ]
    },
    {
        type: ['number'],
        operators: [
            { key: 'greater', label: 'table.greater', numberTextField: 1 },
            { key: 'greaterE', label: 'table.greaterE', numberTextField: 1 },
            { key: 'little', label: 'table.little', numberTextField: 1 },
            { key: 'littleE', label: 'table.littleE', numberTextField: 1 },
            { key: 'equal', label: 'table.equal', numberTextField: 1 },
            { key: 'n_equal', label: 'table.n_equal', numberTextField: 1 },
            { key: 'is_between', label: 'table.is_between', numberTextField: 2 },
            { key: 'not_between', label: 'table.not_between', numberTextField: 2 }
        ]
    },
    // TODO: add  (time  && datetime)
    {
        type: ['date', 'datetime'],
        operators: [
            { key: 'date_is', label: 'table.date_is', numberTextField: 1 },
            { key: 'is_before', label: 'table.is_before', numberTextField: 1 },
            { key: 'is_after', label: 'table.is_after', numberTextField: 1 },
        ]
    },
    {
        type: ['time'],
        operators: [
            { key: 'time_is', label: 'table.time_is', numberTextField: 1 },
            { key: 'time_is_before', label: 'table.time_is_before', numberTextField: 1 },
            { key: 'time_is_after', label: 'table.time_is_after', numberTextField: 1 },
        ]
    },
    {
        type: ['boolean'],
        operators: [
            { key: 'is_true', label: 'table.is_true', numberTextField: 0 },
            { key: 'is_false', label: 'table.is_false', numberTextField: 0 },
        ]
    }
];

function trackByFn(key) {
    return (index, item) => get(item, key, index);
}
function getOperators(type) {
    return get(find(FILTER_OPERATORS, { 'type': type }), 'operators', []);
}
function compareOperators(o1, o2) {
    return o1 === o2;
}
// columnType: ColumnType
function getOperatorsStyle(columnType) {
    return chain(STYLE_RULE_FILTER_OPERATORS)
        .filter((rule) => rule.type.find((type) => type === columnType))
        .flatMap((col) => col.operators)
        .value();
    /*return chain(STYLE_RULE_FILTER_OPERATORS)
        .filter((rule) => rule.type.includes(columnType))
        .flatMap((col) => col.operators)
        .value();*/
}
function getStyleRuleFilter(condition) {
    return chain(STYLE_RULE_FILTER_OPERATORS)
        .flatMap((rule) => rule.operators)
        .find({ key: condition })
        .value();
}
function getSelectedFilter(condition, columnType) {
    return find(getOperatorsStyle(columnType), { key: condition });
}
function minutesOfDay(v1) {
    return v1.minutes() + v1.hours() * 60;
}

const default_page_size = 10;
const default_page_options = [5, 10, 20, 50, 100];

class ViewDialogComponent {
    constructor(dialogRef, data, ftViewService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.ftViewService = ftViewService;
        this.tableView = { access: 'private', name: null, pagination: [], columns: [] };
        this.columns = [];
        this.viewColumns = [];
        this.viewNamespace = null;
        this.configKey = null;
        this.tableConfig = null;
        this.edition = false;
        this.compareOperatorsHandler = compareOperators;
        this.getOperatorsHandler = getOperators;
    }
    ngOnInit() {
        this.columns = reject(get(this.data, 'viewColumns'), { 'key': 'actions' });
        this.viewNamespace = get(this.data, 'namespace');
        this.configKey = get(this.data, 'model');
        this.tableConfig = get(this.data, 'tableConfig');
        if (get(this.data, 'viewId')) {
            this.edition = true;
            this.ftViewService.getView(get(this.data, 'viewId')).subscribe(view => {
                this.tableView = view;
                this.viewColumns = map(this.tableView.columns, (e) => {
                    return assignIn(this.getColumnHandler(e.key), this.getColumnQuery(e.key));
                });
            });
        }
    }
    handleColumn(column) {
        this.viewColumns.push(cloneDeep(column));
    }
    getColumnHandler(key) {
        return chain(this.columns).find({ key: key }).value();
    }
    getColumnQuery(key) {
        return chain(find(this.tableView.query, { key: key })).assignIn({ isFilter: true }).value();
    }
    existHandler(name) {
        return !isNil(find(this.viewColumns, { key: name }));
    }
    removeColumn(idx) {
        this.viewColumns.splice(idx, 1);
    }
    clearFilter(column) {
        column.operator = null;
        column.value = null;
        column.logical_operator = null;
    }
    handleSave() {
        this.tableView = assignIn(this.tableView, {
            pagination: [{
                    name: this.viewNamespace,
                    page_size: default_page_size,
                    page_options: default_page_options
                }],
            query: chain(this.viewColumns).filter((e) => {
                return !isNil(e.operator);
            }).map((e) => {
                return pick(e, ['key', 'logical_operator', 'operator', 'value']);
            }),
            columns: map(this.viewColumns, (e, idx) => {
                return assignIn(pick(e, ['key']), {
                    order_in: [{ name: this.viewNamespace, value: idx }],
                    show_in: [{ name: this.viewNamespace, allow: true }]
                });
            })
        });
        this.ftViewService.handleView(this.tableView).subscribe(data => {
            if (get(data, 'is_default')) {
                update(this.tableConfig.views, 'is_default', (e) => {
                    return false;
                });
            }
            if (findIndex(this.tableConfig.views, { name: this.tableView.name }) == -1) {
                this.tableConfig.views.push(data);
            }
            this.ftViewService.handleConfig(this.tableConfig).subscribe(res => this.tableConfig = res);
            this.dialogRef.close(data);
        });
    }
}
ViewDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: ViewDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: FtViewService }], target: i0.ɵɵFactoryTarget.Component });
ViewDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: ViewDialogComponent, selector: "ft-view-dialog", ngImport: i0, template: "<mat-toolbar color=\"primary\">\n    <div class=\"ft-module-icon\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-grid\"></mat-icon>\n    </div>\n    <h2 mat-dialog-title translate=\"table.view\"></h2>\n    <span fxFlex></span>\n    <mat-slide-toggle [(ngModel)]=\"tableView.is_default\">{{'table.is_default'|translate}}</mat-slide-toggle>\n\n    <button type=\"button\" mat-icon-button mat-dialog-close tabindex=\"-1\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n</mat-toolbar>\n<form novalidate #form=\"ngForm\">\n    <mat-dialog-content fxLayout=\"column\" class=\"ft-content ft-padding\">\n        <mat-drawer-container class=\"view-form-container\">\n            <mat-drawer mode=\"side\" [opened]=\"true\">\n                <mat-toolbar color=\"accent\">\n                    <div class=\"ft-module-icon\">\n                        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n                    </div>\n                    <h2>{{'table.columns_list'|translate}} </h2>\n                    <span fxFlex></span>\n                </mat-toolbar>\n                <mat-action-list role=\"list\" class=\"no-padding ft-content\">\n                    <div *ngIf=\"!columns || columns.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]>\n                        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n                        <h4 matSubheader color=\"error\">{{'table.no_item_found'|translate}}</h4>\n                    </div>\n                    <ng-container *ngFor=\"let column of columns\">\n                        <mat-list-item role=\"listitem\" [disableRipple]=\"true\">\n                        <span mat-line>\n                            <span fxFlex [title]=\"column.key\">{{column.label |translate}}</span>\n                        </span>\n                            <button type=\"button\" mat-button color=\"primary\" (click)=\"handleColumn(column)\"\n                                    *ngIf=\"!existHandler(column.key)\">\n                                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-plus-outline\"></mat-icon>\n                            </button>\n                        </mat-list-item>\n                    </ng-container>\n                </mat-action-list>\n            </mat-drawer>\n            <mat-drawer-content fxFlex>\n                <form #viewForm=\"ngForm\" class=\"ft-padding\" fxLayout=\"column\" fxFlex>\n                    <mat-form-field>\n                        <input class=\"toolbar-input\" matInput [(ngModel)]=\"tableView.name\" name=\"view_name\"\n                               ftCustomValidation=\"table.check_view_exist\"\n                               [query]=\"{ _view:tableView?.id ||null, pk:tableConfig?.id}\"\n                               #name=\"ngModel\"\n                               [placeholder]=\"'table.write_view_name'|translate\" required>\n\n                    </mat-form-field>\n                    <hr class=\"ft-sep\">\n                    <mat-list class=\"view-columns\">\n                        <ng-container *ngFor=\"let column of viewColumns; let idx=index;  let last=last;\"\n                                      [@heightAnimation]>\n                            <mat-list-item>\n                                <div fxFlex fxLayoutGap=\"6px\">\n                                    <mat-form-field fxFlex floatLabel=\"never\">\n                                        <input matInput [value]=\"column.label| translate\" name=\"name_{{idx}}\" readonly\n                                               required\n                                               [placeholder]=\"'table.select_column'|translate\">\n                                    </mat-form-field>\n                                    <mat-form-field fxFlex floatLabel=\"never\">\n                                        <mat-select [(ngModel)]=\"column.operator\"\n                                                    [compareWith]=\"compareOperatorsHandler\"\n                                                    name=\"operator_{{idx}}\"\n                                                    (valueChange)=\"!column.operator ? column.logical_operator='and':''\"\n                                                    [placeholder]=\"'table.choose_operator'|translate\">\n                                            <mat-option *ngFor=\"let operator of getOperatorsHandler(column.type)\"\n                                                        [value]=\"operator\">\n                                                {{'table.' + column.type + '_' + operator|translate}}\n                                            </mat-option>\n                                        </mat-select>\n                                    </mat-form-field>\n                                    <ng-container [ngSwitch]=\"column.type\">\n                                        <mat-form-field *ngSwitchCase=\"'text'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n\n                                        </mat-form-field>\n                                        <mat-form-field *ngSwitchCase=\"'number'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput ftNumber=\"'float'\"\n                                                   placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n                                        </mat-form-field>\n                                        <mat-form-field *ngSwitchCase=\"'date'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput ftDate [matDatepicker]=\"column_date_value\"\n                                                   placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n                                            <mat-datepicker-toggle matSuffix [for]=\"column_date_value\">\n                                                <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                          fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                            </mat-datepicker-toggle>\n                                            <mat-datepicker #column_date_value></mat-datepicker>\n                                        </mat-form-field>\n                                    </ng-container>\n                                    <div fxLayout=\"row\" class=\"ft-list-item-icon-button\">\n                                        <button type=\"button\" mat-icon-button color=\"warn\" (click)=\"removeColumn(idx)\">\n                                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-minus-circle-outline\"></mat-icon>\n                                        </button>\n                                        <button type=\"button\" [disabled]=\"!column.operator\" mat-icon-button color=\"warn\"\n                                                (click)=\"clearFilter(column)\">\n                                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-remove-outline\"></mat-icon>\n                                        </button>\n                                    </div>\n                                </div>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.logical_operator\" class=\"operator-list-item\">\n                                <button type=\"button\" mat-raised-button color=\"accent\" class=\"ft-small-raised-button\"\n\n                                        (click)=\"column.logical_operator=='and' ? column.logical_operator='or': column.logical_operator='and' \">\n                                    <!--*ngIf=\"!last && column.isFilter\"-->\n                                    <span>{{'table.' + column.logical_operator|translate}}</span>\n                                </button>\n                            </mat-list-item>\n\n                        </ng-container>\n                    </mat-list>\n                </form>\n            </mat-drawer-content>\n        </mat-drawer-container>\n    </mat-dialog-content>\n    <mat-dialog-actions>\n        <span fxFlex></span>\n        <mat-error *ngIf=\"name.errors?.exists\" matSubheader>{{'table.view_name_exist_error'| translate}}</mat-error>\n\n        <button type=\"button\" color=\"primary\" mat-raised-button tabindex=\"2\" (click)=\"handleSave()\"\n                [disabled]=\"viewForm.invalid || !tableView.name || name.errors?.exists || viewColumns.length==0\">\n            {{'table.save'|translate}}\n        </button>\n        <button type=\"button\" [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button\n                tabindex=\"-1\">{{'table.reset'|translate}}</button>\n    </mat-dialog-actions>\n</form>", styles: [".view-form-container{background-color:inherit;flex:1 1 100%;min-height:300px}.view-form-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.view-form-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.view-form-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.view-form-container .mat-drawer ::-webkit-scrollbar-track{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-button{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.view-form-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.view-form-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.view-form-container .mat-drawer{width:210px;min-width:210px}}.view-form-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.view-form-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.view-form-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.view-form-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.view-form-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon-button,.view-form-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.view-form-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.view-form-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.view-form-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.view-form-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.view-form-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.view-form-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.view-form-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.view-form-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.view-form-container .mat-toolbar>.mat-button[disabled],.view-form-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.view-form-container .mat-toolbar h2{font-size:16px;line-height:30px}.view-form-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.view-form-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.view-form-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.view-form-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.view-form-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.view-form-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.view-form-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.view-form-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.view-form-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.view-form-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.view-form-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.view-form-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.view-form-container .mat-drawer-content{display:flex}.view-form-container .mat-drawer-content.ft-content{border-radius:0}.view-form-container .view-columns{border:none}.view-form-container .view-columns .operator-list-item{padding:12px 0}.view-form-container .view-columns .mat-list-item{border:none}.view-form-container .view-columns .mat-list-item .ft-list-item-icon-button{align-items:flex-end}.view-form-container .view-columns .mat-list-item .ft-list-item-icon-button .mat-icon-button{width:25px;height:25px}\n"], components: [{ type: i3.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i5.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex", "name", "id", "labelPosition", "aria-label", "aria-labelledby", "aria-describedby", "required", "checked"], outputs: ["change", "toggleChange"], exportAs: ["matSlideToggle"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i7.MatDrawerContainer, selector: "mat-drawer-container", inputs: ["autosize", "hasBackdrop"], outputs: ["backdropClick"], exportAs: ["matDrawerContainer"] }, { type: i7.MatDrawer, selector: "mat-drawer", inputs: ["position", "mode", "disableClose", "autoFocus", "opened"], outputs: ["openedChange", "opened", "openedStart", "closed", "closedStart", "positionChanged"], exportAs: ["matDrawer"] }, { type: i8.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { type: i8.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { type: i7.MatDrawerContent, selector: "mat-drawer-content" }, { type: i9.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i12.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i12.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i5$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i19.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i19.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { type: i19.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i19.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i19.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8.MatListSubheaderCssMatStyler, selector: "[mat-subheader], [matSubheader]" }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i11.MatLine, selector: "[mat-line], [matLine]" }, { type: i15.InputDirective, selector: "input" }, { type: i18.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i19.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i15.CustomValidationDirective, selector: "[ftCustomValidation]", inputs: ["query", "watchedValue", "noWatch", "ftCustomValidation"] }, { type: i19.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i14.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { type: i15$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i15$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i15.NumberDirective, selector: "input[ftNumber]", inputs: ["min", "max", "ftNumber", "empty", "allowZero", "readonly", "fix", "ftStep"] }, { type: i15.DateDirective, selector: "input[ftDate]" }, { type: i12.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i9.MatSuffix, selector: "[matSuffix]" }, { type: i12.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i9.MatError, selector: "mat-error", inputs: ["id"] }], pipes: { "translate": i5$1.TranslatePipe }, animations: [
        SCALE_ANIMATION,
        HEIGHT_ANIMATION
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: ViewDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-view-dialog', animations: [
                        SCALE_ANIMATION,
                        HEIGHT_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n    <div class=\"ft-module-icon\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-grid\"></mat-icon>\n    </div>\n    <h2 mat-dialog-title translate=\"table.view\"></h2>\n    <span fxFlex></span>\n    <mat-slide-toggle [(ngModel)]=\"tableView.is_default\">{{'table.is_default'|translate}}</mat-slide-toggle>\n\n    <button type=\"button\" mat-icon-button mat-dialog-close tabindex=\"-1\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n</mat-toolbar>\n<form novalidate #form=\"ngForm\">\n    <mat-dialog-content fxLayout=\"column\" class=\"ft-content ft-padding\">\n        <mat-drawer-container class=\"view-form-container\">\n            <mat-drawer mode=\"side\" [opened]=\"true\">\n                <mat-toolbar color=\"accent\">\n                    <div class=\"ft-module-icon\">\n                        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n                    </div>\n                    <h2>{{'table.columns_list'|translate}} </h2>\n                    <span fxFlex></span>\n                </mat-toolbar>\n                <mat-action-list role=\"list\" class=\"no-padding ft-content\">\n                    <div *ngIf=\"!columns || columns.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]>\n                        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n                        <h4 matSubheader color=\"error\">{{'table.no_item_found'|translate}}</h4>\n                    </div>\n                    <ng-container *ngFor=\"let column of columns\">\n                        <mat-list-item role=\"listitem\" [disableRipple]=\"true\">\n                        <span mat-line>\n                            <span fxFlex [title]=\"column.key\">{{column.label |translate}}</span>\n                        </span>\n                            <button type=\"button\" mat-button color=\"primary\" (click)=\"handleColumn(column)\"\n                                    *ngIf=\"!existHandler(column.key)\">\n                                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-plus-outline\"></mat-icon>\n                            </button>\n                        </mat-list-item>\n                    </ng-container>\n                </mat-action-list>\n            </mat-drawer>\n            <mat-drawer-content fxFlex>\n                <form #viewForm=\"ngForm\" class=\"ft-padding\" fxLayout=\"column\" fxFlex>\n                    <mat-form-field>\n                        <input class=\"toolbar-input\" matInput [(ngModel)]=\"tableView.name\" name=\"view_name\"\n                               ftCustomValidation=\"table.check_view_exist\"\n                               [query]=\"{ _view:tableView?.id ||null, pk:tableConfig?.id}\"\n                               #name=\"ngModel\"\n                               [placeholder]=\"'table.write_view_name'|translate\" required>\n\n                    </mat-form-field>\n                    <hr class=\"ft-sep\">\n                    <mat-list class=\"view-columns\">\n                        <ng-container *ngFor=\"let column of viewColumns; let idx=index;  let last=last;\"\n                                      [@heightAnimation]>\n                            <mat-list-item>\n                                <div fxFlex fxLayoutGap=\"6px\">\n                                    <mat-form-field fxFlex floatLabel=\"never\">\n                                        <input matInput [value]=\"column.label| translate\" name=\"name_{{idx}}\" readonly\n                                               required\n                                               [placeholder]=\"'table.select_column'|translate\">\n                                    </mat-form-field>\n                                    <mat-form-field fxFlex floatLabel=\"never\">\n                                        <mat-select [(ngModel)]=\"column.operator\"\n                                                    [compareWith]=\"compareOperatorsHandler\"\n                                                    name=\"operator_{{idx}}\"\n                                                    (valueChange)=\"!column.operator ? column.logical_operator='and':''\"\n                                                    [placeholder]=\"'table.choose_operator'|translate\">\n                                            <mat-option *ngFor=\"let operator of getOperatorsHandler(column.type)\"\n                                                        [value]=\"operator\">\n                                                {{'table.' + column.type + '_' + operator|translate}}\n                                            </mat-option>\n                                        </mat-select>\n                                    </mat-form-field>\n                                    <ng-container [ngSwitch]=\"column.type\">\n                                        <mat-form-field *ngSwitchCase=\"'text'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n\n                                        </mat-form-field>\n                                        <mat-form-field *ngSwitchCase=\"'number'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput ftNumber=\"'float'\"\n                                                   placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n                                        </mat-form-field>\n                                        <mat-form-field *ngSwitchCase=\"'date'\" floatLabel=\"never\" fxFlex>\n                                            <input matInput ftDate [matDatepicker]=\"column_date_value\"\n                                                   placeholder=\"{{'table.write_here'|translate}}\"\n                                                   readonly=\"{{!column.operator}}\"\n                                                   [(ngModel)]=\"column.value\" name=\"value_{{idx}}\">\n                                            <mat-datepicker-toggle matSuffix [for]=\"column_date_value\">\n                                                <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                          fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                            </mat-datepicker-toggle>\n                                            <mat-datepicker #column_date_value></mat-datepicker>\n                                        </mat-form-field>\n                                    </ng-container>\n                                    <div fxLayout=\"row\" class=\"ft-list-item-icon-button\">\n                                        <button type=\"button\" mat-icon-button color=\"warn\" (click)=\"removeColumn(idx)\">\n                                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-minus-circle-outline\"></mat-icon>\n                                        </button>\n                                        <button type=\"button\" [disabled]=\"!column.operator\" mat-icon-button color=\"warn\"\n                                                (click)=\"clearFilter(column)\">\n                                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-remove-outline\"></mat-icon>\n                                        </button>\n                                    </div>\n                                </div>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.logical_operator\" class=\"operator-list-item\">\n                                <button type=\"button\" mat-raised-button color=\"accent\" class=\"ft-small-raised-button\"\n\n                                        (click)=\"column.logical_operator=='and' ? column.logical_operator='or': column.logical_operator='and' \">\n                                    <!--*ngIf=\"!last && column.isFilter\"-->\n                                    <span>{{'table.' + column.logical_operator|translate}}</span>\n                                </button>\n                            </mat-list-item>\n\n                        </ng-container>\n                    </mat-list>\n                </form>\n            </mat-drawer-content>\n        </mat-drawer-container>\n    </mat-dialog-content>\n    <mat-dialog-actions>\n        <span fxFlex></span>\n        <mat-error *ngIf=\"name.errors?.exists\" matSubheader>{{'table.view_name_exist_error'| translate}}</mat-error>\n\n        <button type=\"button\" color=\"primary\" mat-raised-button tabindex=\"2\" (click)=\"handleSave()\"\n                [disabled]=\"viewForm.invalid || !tableView.name || name.errors?.exists || viewColumns.length==0\">\n            {{'table.save'|translate}}\n        </button>\n        <button type=\"button\" [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button\n                tabindex=\"-1\">{{'table.reset'|translate}}</button>\n    </mat-dialog-actions>\n</form>", styles: [".view-form-container{background-color:inherit;flex:1 1 100%;min-height:300px}.view-form-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.view-form-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.view-form-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.view-form-container .mat-drawer ::-webkit-scrollbar-track{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-button{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.view-form-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.view-form-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.view-form-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.view-form-container .mat-drawer{width:210px;min-width:210px}}.view-form-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.view-form-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.view-form-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.view-form-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.view-form-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon-button,.view-form-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.view-form-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.view-form-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.view-form-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.view-form-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.view-form-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.view-form-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.view-form-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.view-form-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.view-form-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.view-form-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.view-form-container .mat-toolbar>.mat-button[disabled],.view-form-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.view-form-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.view-form-container .mat-toolbar h2{font-size:16px;line-height:30px}.view-form-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.view-form-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.view-form-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.view-form-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.view-form-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.view-form-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.view-form-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.view-form-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.view-form-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.view-form-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.view-form-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.view-form-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.view-form-container .mat-drawer-content{display:flex}.view-form-container .mat-drawer-content.ft-content{border-radius:0}.view-form-container .view-columns{border:none}.view-form-container .view-columns .operator-list-item{padding:12px 0}.view-form-container .view-columns .mat-list-item{border:none}.view-form-container .view-columns .mat-list-item .ft-list-item-icon-button{align-items:flex-end}.view-form-container .view-columns .mat-list-item .ft-list-item-icon-button .mat-icon-button{width:25px;height:25px}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: FtViewService }];
    } });

class FilterDialogComponent {
    constructor(dialogRef, data, ftViewService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.ftViewService = ftViewService;
        this.name = null;
    }
    ngOnInit() {
    }
    handleFilter() {
        this.dialogRef.close(this.name);
    }
    getNamePattern() {
        return !isEmpty(this.data.names) ? `^(?!((${join(this.data.names, '|')})$)).*` : '';
    }
}
FilterDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FilterDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: FtViewService }], target: i0.ɵɵFactoryTarget.Component });
FilterDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: FilterDialogComponent, selector: "ft-filter-dialog", ngImport: i0, template: "<div mat-dialog-content fxLayout=\"column\" >\n    <mat-form-field floatLabel=\"never\" fxFlex>\n        <input matInput [placeholder]=\"'table.name'|translate\" [(ngModel)]=\"name\" #filterName=\"ngModel\" required ftAutoFocus=\"true\"\n               [pattern]=\"getNamePattern()\">\n        <mat-error *ngIf=\"filterName?.errors?.pattern\">{{'table.filter_name_exist'|translate}}</mat-error>\n    </mat-form-field>\n\n    <span matSubheader color=\"warn\" *ngIf=\"data.names.includes(name)\">{{'table.no_item_found'|translate}}</span>\n</div>\n<div mat-dialog-actions>\n    <button type=\"button\" mat-raised-button color=\"primary\" (click)=\"handleFilter()\" [disabled]=\"!name || data.names.includes(name)\">\n        <span>{{'table.save'|translate}}</span>\n    </button>\n    <button type=\"button\" mat-raised-button color=\"warn\" [mat-dialog-close]=\"name\" cdkFocusInitial>\n        <span>{{'table.reset'|translate}}</span>\n    </button>\n</div>", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}\n"], components: [{ type: i9.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i15.InputDirective, selector: "input" }, { type: i18.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i19.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i19.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i15.AutoFocusDirective, selector: "[ftAutoFocus]", inputs: ["ftAutoFocus"] }, { type: i19.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i19.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i19.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i9.MatError, selector: "mat-error", inputs: ["id"] }, { type: i8.MatListSubheaderCssMatStyler, selector: "[mat-subheader], [matSubheader]" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }], pipes: { "translate": i5$1.TranslatePipe }, animations: [
        HEIGHT_ANIMATION,
        SCALE_ANIMATION
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FilterDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-filter-dialog', animations: [
                        HEIGHT_ANIMATION,
                        SCALE_ANIMATION
                    ], template: "<div mat-dialog-content fxLayout=\"column\" >\n    <mat-form-field floatLabel=\"never\" fxFlex>\n        <input matInput [placeholder]=\"'table.name'|translate\" [(ngModel)]=\"name\" #filterName=\"ngModel\" required ftAutoFocus=\"true\"\n               [pattern]=\"getNamePattern()\">\n        <mat-error *ngIf=\"filterName?.errors?.pattern\">{{'table.filter_name_exist'|translate}}</mat-error>\n    </mat-form-field>\n\n    <span matSubheader color=\"warn\" *ngIf=\"data.names.includes(name)\">{{'table.no_item_found'|translate}}</span>\n</div>\n<div mat-dialog-actions>\n    <button type=\"button\" mat-raised-button color=\"primary\" (click)=\"handleFilter()\" [disabled]=\"!name || data.names.includes(name)\">\n        <span>{{'table.save'|translate}}</span>\n    </button>\n    <button type=\"button\" mat-raised-button color=\"warn\" [mat-dialog-close]=\"name\" cdkFocusInitial>\n        <span>{{'table.reset'|translate}}</span>\n    </button>\n</div>", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: FtViewService }];
    } });

// export declare type ColumnType = 'text' | 'number' | 'date' | 'boolean';
const STYLIZED_COLUMN_TYPE = ['text', 'number', 'boolean', 'date', 'time', 'datetime', 'icon', 'badge'];
/*export interface EmittedStyleRules {
    validate: boolean;
    styleRules: ConditionalFormattingStyle[];
}*/
/*export interface FormattingStyle {
    type: 'column' | 'row';
    // fontWeight: 'normal' | 'bold';
    // fontStyle: 'normal' | 'italic';
    // textDecoration?: 'underline' | 'line-through' | 'underline line-through';
    isUnderline: boolean;
    isStrikethrough: boolean;
    // color?: any;
    // background?: any;
    style: CssStyle;
    /// isBold: boolean;
    /// isItalic: boolean;
}*/

const ICONS = [
    'mdi-ab-testing',
    'mdi-abjad-arabic',
    'mdi-abjad-hebrew',
    'mdi-abugida-devanagari',
    'mdi-abugida-thai',
    'mdi-access-point',
    'mdi-access-point-network',
    'mdi-access-point-network-off',
    'mdi-account',
    'mdi-account-alert',
    'mdi-account-alert-outline',
    'mdi-account-arrow-left',
    'mdi-account-arrow-left-outline',
    'mdi-account-arrow-right',
    'mdi-account-arrow-right-outline',
    'mdi-account-box',
    'mdi-account-box-multiple',
    'mdi-account-box-multiple-outline',
    'mdi-account-box-outline',
    'mdi-account-cancel',
    'mdi-account-cancel-outline',
    'mdi-account-cash',
    'mdi-account-cash-outline',
    'mdi-account-check',
    'mdi-account-check-outline',
    'mdi-account-child',
    'mdi-account-child-circle',
    'mdi-account-child-outline',
    'mdi-account-circle',
    'mdi-account-circle-outline',
    'mdi-account-clock',
    'mdi-account-clock-outline',
    'mdi-account-cog',
    'mdi-account-cog-outline',
    'mdi-account-convert',
    'mdi-account-convert-outline',
    'mdi-account-cowboy-hat',
    'mdi-account-details',
    'mdi-account-details-outline',
    'mdi-account-edit',
    'mdi-account-edit-outline',
    'mdi-account-group',
    'mdi-account-group-outline',
    'mdi-account-hard-hat',
    'mdi-account-heart',
    'mdi-account-heart-outline',
    'mdi-account-key',
    'mdi-account-key-outline',
    'mdi-account-lock',
    'mdi-account-lock-outline',
    'mdi-account-minus',
    'mdi-account-minus-outline',
    'mdi-account-multiple',
    'mdi-account-multiple-check',
    'mdi-account-multiple-check-outline',
    'mdi-account-multiple-minus',
    'mdi-account-multiple-minus-outline',
    'mdi-account-multiple-outline',
    'mdi-account-multiple-plus',
    'mdi-account-multiple-plus-outline',
    'mdi-account-multiple-remove',
    'mdi-account-multiple-remove-outline',
    'mdi-account-music',
    'mdi-account-music-outline',
    'mdi-account-network',
    'mdi-account-network-outline',
    'mdi-account-off',
    'mdi-account-off-outline',
    'mdi-account-outline',
    'mdi-account-plus',
    'mdi-account-plus-outline',
    'mdi-account-question',
    'mdi-account-question-outline',
    'mdi-account-remove',
    'mdi-account-remove-outline',
    'mdi-account-search',
    'mdi-account-search-outline',
    'mdi-account-settings',
    'mdi-account-settings-outline',
    'mdi-account-star',
    'mdi-account-star-outline',
    'mdi-account-supervisor',
    'mdi-account-supervisor-circle',
    'mdi-account-supervisor-outline',
    'mdi-account-switch',
    'mdi-account-switch-outline',
    'mdi-account-tie',
    'mdi-account-tie-outline',
    'mdi-account-tie-voice',
    'mdi-account-tie-voice-off',
    'mdi-account-tie-voice-off-outline',
    'mdi-account-tie-voice-outline',
    'mdi-account-voice',
    'mdi-adjust',
    'mdi-adobe',
    'mdi-adobe-acrobat',
    'mdi-air-conditioner',
    'mdi-air-filter',
    'mdi-air-horn',
    'mdi-air-humidifier',
    'mdi-air-humidifier-off',
    'mdi-air-purifier',
    'mdi-airbag',
    'mdi-airballoon',
    'mdi-airballoon-outline',
    'mdi-airplane',
    'mdi-airplane-landing',
    'mdi-airplane-off',
    'mdi-airplane-takeoff',
    'mdi-airport',
    'mdi-alarm',
    'mdi-alarm-bell',
    'mdi-alarm-check',
    'mdi-alarm-light',
    'mdi-alarm-light-outline',
    'mdi-alarm-multiple',
    'mdi-alarm-note',
    'mdi-alarm-note-off',
    'mdi-alarm-off',
    'mdi-alarm-plus',
    'mdi-alarm-snooze',
    'mdi-album',
    'mdi-alert',
    'mdi-alert-box',
    'mdi-alert-box-outline',
    'mdi-alert-circle',
    'mdi-alert-circle-check',
    'mdi-alert-circle-check-outline',
    'mdi-alert-circle-outline',
    'mdi-alert-decagram',
    'mdi-alert-decagram-outline',
    'mdi-alert-minus',
    'mdi-alert-minus-outline',
    'mdi-alert-octagon',
    'mdi-alert-octagon-outline',
    'mdi-alert-octagram',
    'mdi-alert-octagram-outline',
    'mdi-alert-outline',
    'mdi-alert-plus',
    'mdi-alert-plus-outline',
    'mdi-alert-remove',
    'mdi-alert-remove-outline',
    'mdi-alert-rhombus',
    'mdi-alert-rhombus-outline',
    'mdi-alien',
    'mdi-alien-outline',
    'mdi-align-horizontal-center',
    'mdi-align-horizontal-left',
    'mdi-align-horizontal-right',
    'mdi-align-vertical-bottom',
    'mdi-align-vertical-center',
    'mdi-align-vertical-top',
    'mdi-all-inclusive',
    'mdi-allergy',
    'mdi-alpha',
    'mdi-alpha-a',
    'mdi-alpha-a-box',
    'mdi-alpha-a-box-outline',
    'mdi-alpha-a-circle',
    'mdi-alpha-a-circle-outline',
    'mdi-alpha-b',
    'mdi-alpha-b-box',
    'mdi-alpha-b-box-outline',
    'mdi-alpha-b-circle',
    'mdi-alpha-b-circle-outline',
    'mdi-alpha-c',
    'mdi-alpha-c-box',
    'mdi-alpha-c-box-outline',
    'mdi-alpha-c-circle',
    'mdi-alpha-c-circle-outline',
    'mdi-alpha-d',
    'mdi-alpha-d-box',
    'mdi-alpha-d-box-outline',
    'mdi-alpha-d-circle',
    'mdi-alpha-d-circle-outline',
    'mdi-alpha-e',
    'mdi-alpha-e-box',
    'mdi-alpha-e-box-outline',
    'mdi-alpha-e-circle',
    'mdi-alpha-e-circle-outline',
    'mdi-alpha-f',
    'mdi-alpha-f-box',
    'mdi-alpha-f-box-outline',
    'mdi-alpha-f-circle',
    'mdi-alpha-f-circle-outline',
    'mdi-alpha-g',
    'mdi-alpha-g-box',
    'mdi-alpha-g-box-outline',
    'mdi-alpha-g-circle',
    'mdi-alpha-g-circle-outline',
    'mdi-alpha-h',
    'mdi-alpha-h-box',
    'mdi-alpha-h-box-outline',
    'mdi-alpha-h-circle',
    'mdi-alpha-h-circle-outline',
    'mdi-alpha-i',
    'mdi-alpha-i-box',
    'mdi-alpha-i-box-outline',
    'mdi-alpha-i-circle',
    'mdi-alpha-i-circle-outline',
    'mdi-alpha-j',
    'mdi-alpha-j-box',
    'mdi-alpha-j-box-outline',
    'mdi-alpha-j-circle',
    'mdi-alpha-j-circle-outline',
    'mdi-alpha-k',
    'mdi-alpha-k-box',
    'mdi-alpha-k-box-outline',
    'mdi-alpha-k-circle',
    'mdi-alpha-k-circle-outline',
    'mdi-alpha-l',
    'mdi-alpha-l-box',
    'mdi-alpha-l-box-outline',
    'mdi-alpha-l-circle',
    'mdi-alpha-l-circle-outline',
    'mdi-alpha-m',
    'mdi-alpha-m-box',
    'mdi-alpha-m-box-outline',
    'mdi-alpha-m-circle',
    'mdi-alpha-m-circle-outline',
    'mdi-alpha-n',
    'mdi-alpha-n-box',
    'mdi-alpha-n-box-outline',
    'mdi-alpha-n-circle',
    'mdi-alpha-n-circle-outline',
    'mdi-alpha-o',
    'mdi-alpha-o-box',
    'mdi-alpha-o-box-outline',
    'mdi-alpha-o-circle',
    'mdi-alpha-o-circle-outline',
    'mdi-alpha-p',
    'mdi-alpha-p-box',
    'mdi-alpha-p-box-outline',
    'mdi-alpha-p-circle',
    'mdi-alpha-p-circle-outline',
    'mdi-alpha-q',
    'mdi-alpha-q-box',
    'mdi-alpha-q-box-outline',
    'mdi-alpha-q-circle',
    'mdi-alpha-q-circle-outline',
    'mdi-alpha-r',
    'mdi-alpha-r-box',
    'mdi-alpha-r-box-outline',
    'mdi-alpha-r-circle',
    'mdi-alpha-r-circle-outline',
    'mdi-alpha-s',
    'mdi-alpha-s-box',
    'mdi-alpha-s-box-outline',
    'mdi-alpha-s-circle',
    'mdi-alpha-s-circle-outline',
    'mdi-alpha-t',
    'mdi-alpha-t-box',
    'mdi-alpha-t-box-outline',
    'mdi-alpha-t-circle',
    'mdi-alpha-t-circle-outline',
    'mdi-alpha-u',
    'mdi-alpha-u-box',
    'mdi-alpha-u-box-outline',
    'mdi-alpha-u-circle',
    'mdi-alpha-u-circle-outline',
    'mdi-alpha-v',
    'mdi-alpha-v-box',
    'mdi-alpha-v-box-outline',
    'mdi-alpha-v-circle',
    'mdi-alpha-v-circle-outline',
    'mdi-alpha-w',
    'mdi-alpha-w-box',
    'mdi-alpha-w-box-outline',
    'mdi-alpha-w-circle',
    'mdi-alpha-w-circle-outline',
    'mdi-alpha-x',
    'mdi-alpha-x-box',
    'mdi-alpha-x-box-outline',
    'mdi-alpha-x-circle',
    'mdi-alpha-x-circle-outline',
    'mdi-alpha-y',
    'mdi-alpha-y-box',
    'mdi-alpha-y-box-outline',
    'mdi-alpha-y-circle',
    'mdi-alpha-y-circle-outline',
    'mdi-alpha-z',
    'mdi-alpha-z-box',
    'mdi-alpha-z-box-outline',
    'mdi-alpha-z-circle',
    'mdi-alpha-z-circle-outline',
    'mdi-alphabet-aurebesh',
    'mdi-alphabet-cyrillic',
    'mdi-alphabet-greek',
    'mdi-alphabet-latin',
    'mdi-alphabet-piqad',
    'mdi-alphabet-tengwar',
    'mdi-alphabetical',
    'mdi-alphabetical-off',
    'mdi-alphabetical-variant',
    'mdi-alphabetical-variant-off',
    'mdi-altimeter',
    'mdi-amazon',
    'mdi-amazon-alexa',
    'mdi-ambulance',
    'mdi-ammunition',
    'mdi-ampersand',
    'mdi-amplifier',
    'mdi-amplifier-off',
    'mdi-anchor',
    'mdi-android',
    'mdi-android-auto',
    'mdi-android-debug-bridge',
    'mdi-android-messages',
    'mdi-android-studio',
    'mdi-angle-acute',
    'mdi-angle-obtuse',
    'mdi-angle-right',
    'mdi-angular',
    'mdi-angularjs',
    'mdi-animation',
    'mdi-animation-outline',
    'mdi-animation-play',
    'mdi-animation-play-outline',
    'mdi-ansible',
    'mdi-antenna',
    'mdi-anvil',
    'mdi-apache-kafka',
    'mdi-api',
    'mdi-api-off',
    'mdi-apple',
    'mdi-apple-airplay',
    'mdi-apple-finder',
    'mdi-apple-icloud',
    'mdi-apple-ios',
    'mdi-apple-keyboard-caps',
    'mdi-apple-keyboard-command',
    'mdi-apple-keyboard-control',
    'mdi-apple-keyboard-option',
    'mdi-apple-keyboard-shift',
    'mdi-apple-safari',
    'mdi-application',
    'mdi-application-export',
    'mdi-application-import',
    'mdi-approximately-equal',
    'mdi-approximately-equal-box',
    'mdi-apps',
    'mdi-apps-box',
    'mdi-arch',
    'mdi-archive',
    'mdi-archive-arrow-down',
    'mdi-archive-arrow-down-outline',
    'mdi-archive-arrow-up',
    'mdi-archive-arrow-up-outline',
    'mdi-archive-outline',
    'mdi-arm-flex',
    'mdi-arm-flex-outline',
    'mdi-arrange-bring-forward',
    'mdi-arrange-bring-to-front',
    'mdi-arrange-send-backward',
    'mdi-arrange-send-to-back',
    'mdi-arrow-all',
    'mdi-arrow-bottom-left',
    'mdi-arrow-bottom-left-bold-outline',
    'mdi-arrow-bottom-left-thick',
    'mdi-arrow-bottom-right',
    'mdi-arrow-bottom-right-bold-outline',
    'mdi-arrow-bottom-right-thick',
    'mdi-arrow-collapse',
    'mdi-arrow-collapse-all',
    'mdi-arrow-collapse-down',
    'mdi-arrow-collapse-horizontal',
    'mdi-arrow-collapse-left',
    'mdi-arrow-collapse-right',
    'mdi-arrow-collapse-up',
    'mdi-arrow-collapse-vertical',
    'mdi-arrow-decision',
    'mdi-arrow-decision-auto',
    'mdi-arrow-decision-auto-outline',
    'mdi-arrow-decision-outline',
    'mdi-arrow-down',
    'mdi-arrow-down-bold',
    'mdi-arrow-down-bold-box',
    'mdi-arrow-down-bold-box-outline',
    'mdi-arrow-down-bold-circle',
    'mdi-arrow-down-bold-circle-outline',
    'mdi-arrow-down-bold-hexagon-outline',
    'mdi-arrow-down-bold-outline',
    'mdi-arrow-down-box',
    'mdi-arrow-down-circle',
    'mdi-arrow-down-circle-outline',
    'mdi-arrow-down-drop-circle',
    'mdi-arrow-down-drop-circle-outline',
    'mdi-arrow-down-thick',
    'mdi-arrow-expand',
    'mdi-arrow-expand-all',
    'mdi-arrow-expand-down',
    'mdi-arrow-expand-horizontal',
    'mdi-arrow-expand-left',
    'mdi-arrow-expand-right',
    'mdi-arrow-expand-up',
    'mdi-arrow-expand-vertical',
    'mdi-arrow-horizontal-lock',
    'mdi-arrow-left',
    'mdi-arrow-left-bold',
    'mdi-arrow-left-bold-box',
    'mdi-arrow-left-bold-box-outline',
    'mdi-arrow-left-bold-circle',
    'mdi-arrow-left-bold-circle-outline',
    'mdi-arrow-left-bold-hexagon-outline',
    'mdi-arrow-left-bold-outline',
    'mdi-arrow-left-box',
    'mdi-arrow-left-circle',
    'mdi-arrow-left-circle-outline',
    'mdi-arrow-left-drop-circle',
    'mdi-arrow-left-drop-circle-outline',
    'mdi-arrow-left-right',
    'mdi-arrow-left-right-bold',
    'mdi-arrow-left-right-bold-outline',
    'mdi-arrow-left-thick',
    'mdi-arrow-right',
    'mdi-arrow-right-bold',
    'mdi-arrow-right-bold-box',
    'mdi-arrow-right-bold-box-outline',
    'mdi-arrow-right-bold-circle',
    'mdi-arrow-right-bold-circle-outline',
    'mdi-arrow-right-bold-hexagon-outline',
    'mdi-arrow-right-bold-outline',
    'mdi-arrow-right-box',
    'mdi-arrow-right-circle',
    'mdi-arrow-right-circle-outline',
    'mdi-arrow-right-drop-circle',
    'mdi-arrow-right-drop-circle-outline',
    'mdi-arrow-right-thick',
    'mdi-arrow-split-horizontal',
    'mdi-arrow-split-vertical',
    'mdi-arrow-top-left',
    'mdi-arrow-top-left-bold-outline',
    'mdi-arrow-top-left-bottom-right',
    'mdi-arrow-top-left-bottom-right-bold',
    'mdi-arrow-top-left-thick',
    'mdi-arrow-top-right',
    'mdi-arrow-top-right-bold-outline',
    'mdi-arrow-top-right-bottom-left',
    'mdi-arrow-top-right-bottom-left-bold',
    'mdi-arrow-top-right-thick',
    'mdi-arrow-up',
    'mdi-arrow-up-bold',
    'mdi-arrow-up-bold-box',
    'mdi-arrow-up-bold-box-outline',
    'mdi-arrow-up-bold-circle',
    'mdi-arrow-up-bold-circle-outline',
    'mdi-arrow-up-bold-hexagon-outline',
    'mdi-arrow-up-bold-outline',
    'mdi-arrow-up-box',
    'mdi-arrow-up-circle',
    'mdi-arrow-up-circle-outline',
    'mdi-arrow-up-down',
    'mdi-arrow-up-down-bold',
    'mdi-arrow-up-down-bold-outline',
    'mdi-arrow-up-drop-circle',
    'mdi-arrow-up-drop-circle-outline',
    'mdi-arrow-up-thick',
    'mdi-arrow-vertical-lock',
    'mdi-artstation',
    'mdi-aspect-ratio',
    'mdi-assistant',
    'mdi-asterisk',
    'mdi-at',
    'mdi-atlassian',
    'mdi-atm',
    'mdi-atom',
    'mdi-atom-variant',
    'mdi-attachment',
    'mdi-audio-video',
    'mdi-audio-video-off',
    'mdi-augmented-reality',
    'mdi-auto-download',
    'mdi-auto-fix',
    'mdi-auto-upload',
    'mdi-autorenew',
    'mdi-av-timer',
    'mdi-aws',
    'mdi-axe',
    'mdi-axis',
    'mdi-axis-arrow',
    'mdi-axis-arrow-info',
    'mdi-axis-arrow-lock',
    'mdi-axis-lock',
    'mdi-axis-x-arrow',
    'mdi-axis-x-arrow-lock',
    'mdi-axis-x-rotate-clockwise',
    'mdi-axis-x-rotate-counterclockwise',
    'mdi-axis-x-y-arrow-lock',
    'mdi-axis-y-arrow',
    'mdi-axis-y-arrow-lock',
    'mdi-axis-y-rotate-clockwise',
    'mdi-axis-y-rotate-counterclockwise',
    'mdi-axis-z-arrow',
    'mdi-axis-z-arrow-lock',
    'mdi-axis-z-rotate-clockwise',
    'mdi-axis-z-rotate-counterclockwise',
    'mdi-babel',
    'mdi-baby',
    'mdi-baby-bottle',
    'mdi-baby-bottle-outline',
    'mdi-baby-buggy',
    'mdi-baby-carriage',
    'mdi-baby-carriage-off',
    'mdi-baby-face',
    'mdi-baby-face-outline',
    'mdi-backburger',
    'mdi-backspace',
    'mdi-backspace-outline',
    'mdi-backspace-reverse',
    'mdi-backspace-reverse-outline',
    'mdi-backup-restore',
    'mdi-bacteria',
    'mdi-bacteria-outline',
    'mdi-badge-account',
    'mdi-badge-account-alert',
    'mdi-badge-account-alert-outline',
    'mdi-badge-account-horizontal',
    'mdi-badge-account-horizontal-outline',
    'mdi-badge-account-outline',
    'mdi-badminton',
    'mdi-bag-carry-on',
    'mdi-bag-carry-on-check',
    'mdi-bag-carry-on-off',
    'mdi-bag-checked',
    'mdi-bag-personal',
    'mdi-bag-personal-off',
    'mdi-bag-personal-off-outline',
    'mdi-bag-personal-outline',
    'mdi-baguette',
    'mdi-balloon',
    'mdi-ballot',
    'mdi-ballot-outline',
    'mdi-ballot-recount',
    'mdi-ballot-recount-outline',
    'mdi-bandage',
    'mdi-bandcamp',
    'mdi-bank',
    'mdi-bank-minus',
    'mdi-bank-outline',
    'mdi-bank-plus',
    'mdi-bank-remove',
    'mdi-bank-transfer',
    'mdi-barcode',
    'mdi-barcode-off',
    'mdi-barcode-scan',
    'mdi-barley',
    'mdi-barley-off',
    'mdi-barn',
    'mdi-barrel',
    'mdi-baseball',
    'mdi-baseball-bat',
    'mdi-bash',
    'mdi-basket',
    'mdi-basket-fill',
    'mdi-basket-outline',
    'mdi-basket-unfill',
    'mdi-basketball',
    'mdi-basketball-hoop',
    'mdi-basketball-hoop-outline',
    'mdi-bat',
    'mdi-battery',
    'mdi-battery-10',
    'mdi-battery-10-bluetooth',
    'mdi-battery-20',
    'mdi-battery-20-bluetooth',
    'mdi-battery-30',
    'mdi-battery-30-bluetooth',
    'mdi-battery-40',
    'mdi-battery-40-bluetooth',
    'mdi-battery-50',
    'mdi-battery-50-bluetooth',
    'mdi-battery-60',
    'mdi-battery-60-bluetooth',
    'mdi-battery-70',
    'mdi-battery-70-bluetooth',
    'mdi-battery-80',
    'mdi-battery-80-bluetooth',
    'mdi-battery-90',
    'mdi-battery-90-bluetooth',
    'mdi-battery-alert',
    'mdi-battery-alert-bluetooth',
    'mdi-battery-alert-variant',
    'mdi-battery-alert-variant-outline',
    'mdi-battery-bluetooth',
    'mdi-battery-bluetooth-variant',
    'mdi-battery-charging',
    'mdi-battery-charging-10',
    'mdi-battery-charging-100',
    'mdi-battery-charging-20',
    'mdi-battery-charging-30',
    'mdi-battery-charging-40',
    'mdi-battery-charging-50',
    'mdi-battery-charging-60',
    'mdi-battery-charging-70',
    'mdi-battery-charging-80',
    'mdi-battery-charging-90',
    'mdi-battery-charging-high',
    'mdi-battery-charging-low',
    'mdi-battery-charging-medium',
    'mdi-battery-charging-outline',
    'mdi-battery-charging-wireless',
    'mdi-battery-charging-wireless-10',
    'mdi-battery-charging-wireless-20',
    'mdi-battery-charging-wireless-30',
    'mdi-battery-charging-wireless-40',
    'mdi-battery-charging-wireless-50',
    'mdi-battery-charging-wireless-60',
    'mdi-battery-charging-wireless-70',
    'mdi-battery-charging-wireless-80',
    'mdi-battery-charging-wireless-90',
    'mdi-battery-charging-wireless-alert',
    'mdi-battery-charging-wireless-outline',
    'mdi-battery-heart',
    'mdi-battery-heart-outline',
    'mdi-battery-heart-variant',
    'mdi-battery-high',
    'mdi-battery-low',
    'mdi-battery-medium',
    'mdi-battery-minus',
    'mdi-battery-negative',
    'mdi-battery-off',
    'mdi-battery-off-outline',
    'mdi-battery-outline',
    'mdi-battery-plus',
    'mdi-battery-positive',
    'mdi-battery-unknown',
    'mdi-battery-unknown-bluetooth',
    'mdi-battlenet',
    'mdi-beach',
    'mdi-beaker',
    'mdi-beaker-alert',
    'mdi-beaker-alert-outline',
    'mdi-beaker-check',
    'mdi-beaker-check-outline',
    'mdi-beaker-minus',
    'mdi-beaker-minus-outline',
    'mdi-beaker-outline',
    'mdi-beaker-plus',
    'mdi-beaker-plus-outline',
    'mdi-beaker-question',
    'mdi-beaker-question-outline',
    'mdi-beaker-remove',
    'mdi-beaker-remove-outline',
    'mdi-bed',
    'mdi-bed-double',
    'mdi-bed-double-outline',
    'mdi-bed-empty',
    'mdi-bed-king',
    'mdi-bed-king-outline',
    'mdi-bed-outline',
    'mdi-bed-queen',
    'mdi-bed-queen-outline',
    'mdi-bed-single',
    'mdi-bed-single-outline',
    'mdi-bee',
    'mdi-bee-flower',
    'mdi-beehive-off-outline',
    'mdi-beehive-outline',
    'mdi-beer',
    'mdi-beer-outline',
    'mdi-bell',
    'mdi-bell-alert',
    'mdi-bell-alert-outline',
    'mdi-bell-cancel',
    'mdi-bell-cancel-outline',
    'mdi-bell-check',
    'mdi-bell-check-outline',
    'mdi-bell-circle',
    'mdi-bell-circle-outline',
    'mdi-bell-minus',
    'mdi-bell-minus-outline',
    'mdi-bell-off',
    'mdi-bell-off-outline',
    'mdi-bell-outline',
    'mdi-bell-plus',
    'mdi-bell-plus-outline',
    'mdi-bell-remove',
    'mdi-bell-remove-outline',
    'mdi-bell-ring',
    'mdi-bell-ring-outline',
    'mdi-bell-sleep',
    'mdi-bell-sleep-outline',
    'mdi-beta',
    'mdi-betamax',
    'mdi-biathlon',
    'mdi-bicycle',
    'mdi-bicycle-basket',
    'mdi-bike',
    'mdi-bike-fast',
    'mdi-billboard',
    'mdi-billiards',
    'mdi-billiards-rack',
    'mdi-binoculars',
    'mdi-bio',
    'mdi-biohazard',
    'mdi-bitbucket',
    'mdi-bitcoin',
    'mdi-black-mesa',
    'mdi-blender',
    'mdi-blender-software',
    'mdi-blinds',
    'mdi-blinds-open',
    'mdi-block-helper',
    'mdi-blogger',
    'mdi-blood-bag',
    'mdi-bluetooth',
    'mdi-bluetooth-audio',
    'mdi-bluetooth-connect',
    'mdi-bluetooth-off',
    'mdi-bluetooth-settings',
    'mdi-bluetooth-transfer',
    'mdi-blur',
    'mdi-blur-linear',
    'mdi-blur-off',
    'mdi-blur-radial',
    'mdi-bolnisi-cross',
    'mdi-bolt',
    'mdi-bomb',
    'mdi-bomb-off',
    'mdi-bone',
    'mdi-book',
    'mdi-book-account',
    'mdi-book-account-outline',
    'mdi-book-alphabet',
    'mdi-book-cross',
    'mdi-book-information-variant',
    'mdi-book-lock',
    'mdi-book-lock-open',
    'mdi-book-minus',
    'mdi-book-minus-multiple',
    'mdi-book-minus-multiple-outline',
    'mdi-book-multiple',
    'mdi-book-multiple-outline',
    'mdi-book-music',
    'mdi-book-open',
    'mdi-book-open-outline',
    'mdi-book-open-page-variant',
    'mdi-book-open-variant',
    'mdi-book-outline',
    'mdi-book-play',
    'mdi-book-play-outline',
    'mdi-book-plus',
    'mdi-book-plus-multiple',
    'mdi-book-plus-multiple-outline',
    'mdi-book-remove',
    'mdi-book-remove-multiple',
    'mdi-book-remove-multiple-outline',
    'mdi-book-search',
    'mdi-book-search-outline',
    'mdi-book-variant',
    'mdi-book-variant-multiple',
    'mdi-bookmark',
    'mdi-bookmark-check',
    'mdi-bookmark-check-outline',
    'mdi-bookmark-minus',
    'mdi-bookmark-minus-outline',
    'mdi-bookmark-multiple',
    'mdi-bookmark-multiple-outline',
    'mdi-bookmark-music',
    'mdi-bookmark-music-outline',
    'mdi-bookmark-off',
    'mdi-bookmark-off-outline',
    'mdi-bookmark-outline',
    'mdi-bookmark-plus',
    'mdi-bookmark-plus-outline',
    'mdi-bookmark-remove',
    'mdi-bookmark-remove-outline',
    'mdi-bookshelf',
    'mdi-boom-gate',
    'mdi-boom-gate-alert',
    'mdi-boom-gate-alert-outline',
    'mdi-boom-gate-down',
    'mdi-boom-gate-outline',
    'mdi-boom-gate-up',
    'mdi-boom-gate-up-outline',
    'mdi-boombox',
    'mdi-boomerangootstrap',
    'mdi-border-all',
    'mdi-border-all-variant',
    'mdi-border-bottom-variant',
    'mdi-border',
    'mdi-border-horizontal',
    'mdi-border-inside',
    'mdi-border-left',
    'mdi-border-left-variant',
    'mdi-border-none',
    'mdi-border-none-variant',
    'mdi-border-outside',
    'mdi-border-right',
    'mdi-border-right-variant',
    'mdi-style',
    'mdi-border-top',
    'mdi-border-top-variant',
    'mdi-border-vertical',
    'mdi-bottle-soda',
    'mdi-bottle-soda-classic',
    'mdi-bottle-soda-classic-outline',
    'mdi-bottle-soda-outline',
    'mdi-bottle-tonic',
    'mdi-bottle-tonic-outline',
    'mdi-bottle-tonic-plus',
    'mdi-bottle-tonic-plus-outline',
    'mdi-bottle-tonic-skull',
    'mdi-bottle-tonic-skull-outline',
    'mdi-bottle-wine',
    'mdi-bottle-wine-outline',
    'mdi-bow-tie',
    'mdi-bowl',
    'mdi-bowl-mix',
    'mdi-bowl-mix-outline',
    'mdi-bowl-outline',
    'mdi-bowling',
    'mdi-box',
    'mdi-box-cutter',
    'mdi-box-cutter-off',
    'mdi-box-shadow',
    'mdi-boxing-glove',
    'mdi-brain',
    'mdi-bread-slice',
    'mdi-bread-slice-outline',
    'mdi-bridge',
    'mdi-briefcase',
    'mdi-briefcase-account',
    'mdi-briefcase-outline',
    'mdi-briefcase-check',
    'mdi-briefcase-check-outline',
    'mdi-briefcase-clock',
    'mdi-briefcase-clock-outline',
    'mdi-briefcase-download',
    'mdi-briefcase-download-outline',
    'mdi-briefcase-edit',
    'mdi-briefcase-edit-outline',
    'mdi-briefcase-minus',
    'mdi-briefcase-minus-outline',
    'mdi-briefcase-outline',
    'mdi-briefcase-plus',
    'mdi-briefcase-plus-outline',
    'mdi-briefcase-remove',
    'mdi-briefcase-remove-outline',
    'fcase-search',
    'mdi-briefcase-search',
    'mdi-briefcase-upload',
    'mdi-se-upload-outline',
    'mdi-briefcase-variant',
    'mdi-briefcase-variant-outline',
    'mdi-brightness-1',
    'mdi-brightness-2',
    'mdi-brightness-3',
    'mdi-brightness-4',
    'mdi-brightness-5',
    'mdi-brightness-6',
    'mdi-brightness-7',
    'mdi-brightness-auto',
    'mdi-brightness-percent',
    'mdi-mdi-brush',
    'mdi-bucket',
    'mdi-bucket-outline',
    'mdi-buddhism',
    'mdi-buffer',
    'mdi-buffet',
    'mdi-bug',
    'mdi-bug-check',
    'mdi-bug-check-outline',
    'mdi-bug-outline',
    'mdi-bugle',
    'mdi-bulldozer',
    'mdi-bullet',
    'mdi-bulletin-board',
    'mdi-bullhorn',
    'mdi--outline',
    'mdi-bullseyeullseye-arrow',
    'mdi-bulma',
    'mdi-bunk-bed',
    'mdi-bunk-bed-outline',
    'mdi-bus',
    'mdi-bus-alert',
    'mdi-bus-articulated-end',
    'mdi-bus-articulated-front',
    'mdi-bus-clock',
    'mdi-bus-double-decker',
    'mdi-bus-marker',
    'mdi-bus-multiple',
    'mdi-bus-school',
    'mdi-bus mdi-bus-stop',
    'mdi-bus-stop-covered',
    'mdi-bus-stop-uncovered',
    'mdi-cable-data',
    'mdi-cached',
    'mdi-cactus',
    'mdi-cake',
    'mdi-cake-layered',
    'mdi-cake-variant',
    'mdi-calculator',
    'mdi-calculator-variant',
    'mdi-calendar',
    'ndar-account',
    'mdi-calendar-account-outline',
    'mdi-calendar-alert',
    'mdi-calendar-arrow-left',
    'mdi-calendar-arrow',
    'mdi-calendar-blank',
    'ndar-blank-multiple',
    'mdi-calendar-blank-outline',
    'mdi-calendar-check',
    'mdi-calendar-check-outlinealendar-clock',
    'mdi-calendar-edit',
    'mdi-calendar-export',
    'mdi-calendar-import',
    'mdi-calendar-minus',
    'mdi-calendar-month',
    'mdi-calendar-month-outline',
    'mdi-calendar-multiple',
    'mdi-calendar-multiple-check',
    'mdi-calendar-multiselect',
    'mdi-calendar-plus',
    'mdi-calendar-question',
    'mdi-calendar-range',
    'mdi-calendar-range-outline',
    'mdi-r-refresh',
    'mdi--refresh-outline',
    'mdi-calendar-remove',
    'mdi-calendar-remove-outline',
    'mdi-calendar-search',
    'mdi-calendar-sync',
    'mdi-calendar-sync-outline',
    'mdi-calendar-text',
    'mdi-calendar-text ',
    'mdi-calendar-today',
    'mdi-calendar-week',
    'mdi-calendar-week-begin',
    'mdi-calendar-weekend',
    'mdi-call-missed',
    'mdi-call-split',
    'mdi-camcorder',
    'mdi-camcorder-off',
    'mdi-camera-account',
    'mdi-camera-burst',
    'mdi-camera-control',
    'mdi-camera-enhance',
    'mdi-camera-enhance-outline',
    'mdi-camera-front',
    'mdi-camera-front-variant',
    'mdi-camera-gopro',
    'mdi-camera-image',
    'mdi-camera-iris',
    'mdi-camera-metering-center',
    'mdi-camera-metering-matrix',
    'mdi-camera-metering-partial',
    'mdi-camera-metering-spot',
    'mdi-camera-offamera-outline',
    'mdi-camera-party-modeamera-plus',
    'mdi-camera-plus-outline',
    'mdi-camera-rear',
    'mdi-camera-rear-variant',
    'mdi-camera-retake',
    'mdi-camera-switch',
    'mdi-camera-switch-outline',
    'mdi-camera-timer',
    'mdi-camera-wireless',
    'mdi-camera-wireless-outline',
    'mdi-campfire',
    'mdi-cancel',
    'mdi-candle',
    'mdi-candycane',
    'mdi-cannabis',
    'mdi-caps-lock',
    'mdi-car',
    'mdi-car-2-plus',
    'mdi-car-3-plus',
    'mdi-car arrow-left',
    'mdi-car-arrow-right',
    'mdi-car-back',
    'mdi-car-battery',
    'mdi-car-brake-abs',
    'mdi-car-brake-alert',
    'mdi-car-brake-hold',
    'mdi-car brake-parking',
    'mdi-car-brake-retarder',
    'mdi-car-child-seat',
    'mdi-car-clutch',
    'mdi-car-cog',
    'mdi-car-connected',
    'mdi-car-convertible',
    'mdi-car-coolant-level',
    'mdi-car-cruise-control',
    'mdi-car-defrost-rear',
    'mdi-car-door',
    'mdi-car-door-lock',
    'mdi-car-electric',
    'mdi-car-esp',
    'mdi-car-estate',
    'mdi-car-hatchback',
    'mdi-car-info',
    'mdi-car-key',
    'mdi-car-light-dimmed',
    'mdi-car-light-fo',
    'mdi-car-light-high',
    'mdi-car-limousine',
    'mdi-car-multiple',
    'mdi-car-off',
    'mdi-car-parking-lights',
    'mdi-car-pickup',
    'mdi-car-seat',
    'mdi-car-seat-cooler',
    'mdi-ca-seat-heater',
    'mdi-car-settings',
    'mdi-car-shift-pattern',
    'mdi-car-side',
    'mdi-car-sports',
    'mdi-car-tire-alert',
    'mdi-car-traction-control',
    'mdi-car-turbocharger',
    'mdi-car-wash',
    'mdi-car-windshield',
    'mdi-car-windshield-outline',
    'mdi-carabiner',
    'mdi-caravan',
    'mdi-card',
    'mdi-card-account-details',
    'mdi-card-account-details-outline',
    'mdi-card-account-details-star',
    'mdi-card-accoun-details-star-outline',
    'mdi-card-account-mail',
    'mdi-card-account-mail-outline',
    'mdi-card-account-phone',
    'mdi-card-account-phone-outline',
    'mdi-card-bulleted',
    'mdi-card-bulleted-off',
    'mdi-card-bulleted-off-outline',
    'mdi-card-bulleted-outline',
    'mdi-card-bulleted-settings',
    'mdi-card-bulleted-settings-outline',
    'mdi-card-outline',
    'mdi-card-plus',
    'mdi-card-plus-outline',
    'mdi-card-search',
    'mdi-card-search-outline',
    'mdi-card-text',
    'mdi-card-text-outline',
    'mdi-cards',
    'mdi-cards-club',
    'mdi-cards-diamond',
    'mdi-cards-diamond-outline',
    'mdi-cards heart',
    'mdi-cards-outline',
    'mdi-cards-playing-outline',
    'mdi-cards-spade',
    'mdi-cards-variant',
    'mdi-carrot',
    'mdi-cart',
    'mdi-cart-arrow-down',
    'mdi-cart-arrow-right',
    'mdi-cart-arrow-up',
    'mdi-cart-minus',
    'mdi-cart-off',
    'mdi-cart-outline',
    'mdi-cart-plus',
    'mdi-cart-remove',
    'mdi-case-sensitive-alt',
    'mdi-cash',
    'mdi-cash-100',
    'mdi-cash-marker',
    'mdi-cash-minus',
    'mdi-cash-multiple',
    'mdi-cash-plus',
    'mdi-cash-refund',
    'mdi-cash-register',
    'mdi-cash-remove',
    'mdi-cash-usd',
    'mdi-cash-usd-outline',
    'mdi-cassette',
    'mdi-cast',
    'mdi-cast-audio',
    'mdi-cast-connected',
    'mdi-cast-education',
    'mdi-cast-off',
    'mdi-castle',
    'mdi-cat',
    'mdi-cctv',
    'mdi-ceiling-light',
    'mdi-cellphone',
    'mdi-cellphone-android',
    'mdi-cellphone-arrow-down',
    'mdi-cellphone-basic',
    'mdi-cellphone-charging',
    'mdi-cellphone-cog',
    'mdi-cellphone-dock',
    'mdi-cellphone-erase',
    'mdi-cellphone-information',
    'mdi-cellphone-iphone',
    'mdi-cellphone-key',
    'mdi-cellphone-link',
    'mdi-cellphone-link-off',
    'mdi-cellphone-lock',
    'mdi-cellphone-message',
    'mdi-cellphone-message-off',
    'mdi-cellphone-nfc',
    'mdi-cellphone-nfc-off',
    'mdi-cellphone-off',
    'mdi-cellphone-play',
    'mdi-cellphone-screenshot',
    'mdi-cellphone-settings',
    'mdi-cellphone-sound',
    'mdi-cellphone-text',
    'mdi-cellphone-wireless',
    'mdi-celtic-cross',
    'mdi-centos',
    'mdi-certificate',
    'mdi-certificate-outline',
    'mdi-chair-rolling',
    'mdi-chair-school',
    'mdi-charity',
    'mdi-chart-arc',
    'mdi-chart-areaspline',
    'mdi-chart-areaspline-variant',
    'mdi-chart-bar',
    'mdi-chart-bar-stacked',
    'mdi-chart-bell-curve',
    'mdi-chart-bell-curve-cumulative',
    'mdi-chart-bubble',
    'mdi-chart-donut',
    'mdi-chart-donut-variant',
    'mdi-chart-gantt',
    'mdi-chart-histogram',
    'mdi-chart-line',
    'mdi-chart-line-stacked',
    'mdi-chart-line-variant',
    'mdi-chart-multiline',
    'mdi-chart-multiple',
    'mdi-chart-pie',
    'mdi-chart-ppf',
    'mdi-chart-sankey',
    'mdi-chart-sankey-variant',
    'mdi-chart-scatter-plot',
    'mdi-chart-scatter-plot-hexbin',
    'mdi-chart-timeline',
    'mdi-chart-timeline-variant',
    'mdi-chart-tree',
    'mdi-chat',
    'mdi-chat-alert',
    'mdi-chat-alert-outline',
    'mdi-chat-minus',
    'mdi-chat-minus-outline',
    'mdi-chat-outline',
    'mdi-chat-plus',
    'mdi-chat-plus-outline',
    'mdi-chat-processing',
    'mdi-chat-processing-outline',
    'mdi-chat-remove',
    'mdi-chat-remove-outline',
    'mdi-chat-sleep',
    'mdi-chat-sleep-outline',
    'mdi-check',
    'mdi-check-all',
    'mdi-check-bold',
    'mdi-check-box-multiple-outline',
    'mdi-check-box-outline',
    'mdi-check-circle',
    'mdi-check-circle-outline',
    'mdi-check-decagram',
    'mdi-check-network',
    'mdi-check-network-outline',
    'mdi-check-outline',
    'mdi-check-underline',
    'mdi-check-underline-circle',
    'mdi-check-underline-circle-outline',
    'mdi-checkbook',
    'mdi-checkbox-blank',
    'mdi-checkbox-blank-circle',
    'mdi-checkbox-blank-circle-outline',
    'mdi-checkbox-blank-off',
    'mdi-checkbox-blank-off-outline',
    'mdi-checkbox-blank-outline',
    'mdi-checkbox-intermediate',
    'mdi-checkbox-marked',
    'mdi-checkbox-marked-circle',
    'mdi-checkbox-marked-circle-outline',
    'mdi-checkbox-marked-outline',
    'mdi-checkbox-multiple-blank',
    'mdi-checkbox-multiple-blank-circle',
    'mdi-checkbox-multiple-blank-circle-outline',
    'mdi-checkbox-multiple-blank-outline',
    'mdi-checkbox-multiple-marked',
    'mdi-checkbox-multiple-marked-circle',
    'mdi-checkbox-multiple-marked-circle-outline',
    'mdi-checkbox-multiple-marked-outline',
    'mdi-checkerboard',
    'mdi-checkerboard-minus',
    'mdi-checkerboard-plus',
    'mdi-checkerboard-remove',
    'mdi-cheese',
    'mdi-cheese-off',
    'mdi-chef-hat',
    'mdi-chemical-weapon',
    'mdi-chess-bishop',
    'mdi-chess-king',
    'mdi-chess-knight',
    'mdi-chess-pawn',
    'mdi-chess-queen',
    'mdi-chess-rook',
    'mdi-chevron-double-down',
    'mdi-chevron-double-left',
    'mdi-chevron-double-right',
    'mdi-chevron-double-up',
    'mdi-chevron-down',
    'mdi-chevron-down-box',
    'mdi-chevron-down-box-outline',
    'mdi-chevron-down-circle',
    'mdi-chevron-down-circle-outline',
    'mdi-chevron-left',
    'mdi-chevron-left-box',
    'mdi-chevron-left-box-outline',
    'mdi-chevron-left-circle',
    'mdi-chevron-left-circle-outline',
    'mdi-chevron-right',
    'mdi-chevron-right-box',
    'mdi-chevron-right-box-outline',
    'mdi-chevron-right-circle',
    'mdi-chevron-right-circle-outline',
    'mdi-chevron-triple-down',
    'mdi-chevron-triple-left',
    'mdi-chevron-triple-right',
    'mdi-chevron-triple-up',
    'mdi-chevron-up',
    'mdi-chevron-up-box',
    'mdi-chevron-up-box-outline',
    'mdi-chevron-up-circle',
    'mdi-chevron-up-circle-outline',
    'mdi-chili-hot',
    'mdi-chili-medium',
    'mdi-chili-mild',
    'mdi-chili-off',
    'mdi-chip',
    'mdi-christianity',
    'mdi-christianity-outline',
    'mdi-church',
    'mdi-cigar',
    'mdi-cigar-off',
    'mdi-circle',
    'mdi-circle-double',
    'mdi-circle-edit-outline',
    'mdi-circle-expand',
    'mdi-circle-half',
    'mdi-circle-half-full',
    'mdi-circle-medium',
    'mdi-circle-multiple',
    'mdi-circle-multiple-outline',
    'mdi-circle-off-outline',
    'mdi-circle-outline',
    'mdi-circle-slice-1',
    'mdi-circle-slice-2',
    'mdi-circle-slice-3',
    'mdi-circle-slice-4',
    'mdi-circle-slice-5',
    'mdi-circle-slice-6',
    'mdi-circle-slice-7',
    'mdi-circle-slice-8',
    'mdi-circle-small',
    'mdi-circular-saw',
    'mdi-city',
    'mdi-city-variant',
    'mdi-city-variant-outline',
    'mdi-clipboard',
    'mdi-clipboard-account',
    'mdi-clipboard-account-outline',
    'mdi-clipboard-alert',
    'mdi-clipboard-alert-outline',
    'mdi-clipboard-arrow-down',
    'mdi-clipboard-arrow-down-outline',
    'mdi-clipboard-arrow-left',
    'mdi-clipboard-arrow-left-outline',
    'mdi-clipboard-arrow-right',
    'mdi-clipboard-arrow-right-outline',
    'mdi-clipboard-arrow-up',
    'mdi-clipboard-arrow-up-outline',
    'mdi-clipboard-check',
    'mdi-clipboard-check-multiple',
    'mdi-clipboard-check-multiple-outline',
    'mdi-clipboard-check-outline',
    'mdi-clipboard-file',
    'mdi-clipboard-file-outline',
    'mdi-clipboard-flow',
    'mdi-clipboard-flow-outline',
    'mdi-clipboard-list',
    'mdi-clipboard-list-outline',
    'mdi-clipboard-multiple',
    'mdi-clipboard-multiple-outline',
    'mdi-clipboard-outline',
    'mdi-clipboard-play',
    'mdi-clipboard-play-multiple',
    'mdi-clipboard-play-multiple-outline',
    'mdi-clipboard-play-outline',
    'mdi-clipboard-plus',
    'mdi-clipboard-plus-outline',
    'mdi-clipboard-pulse',
    'mdi-clipboard-pulse-outline',
    'mdi-clipboard-text',
    'mdi-clipboard-text-multiple',
    'mdi-clipboard-text-multiple-outline',
    'mdi-clipboard-text-outline',
    'mdi-clipboard-text-play',
    'mdi-clipboard-text-play-outline',
    'mdi-clippy',
    'mdi-clock',
    'mdi-clock-alert',
    'mdi-clock-alert-outline',
    'mdi-clock-check',
    'mdi-clock-check-outline',
    'mdi-clock-digital',
    'mdi-clock-end',
    'mdi-clock-fast',
    'mdi-clock-in',
    'mdi-clock-out',
    'mdi-clock-outline',
    'mdi-clock-start',
    'mdi-clock-time-eight',
    'mdi-clock-time-eight-outline',
    'mdi-clock-time-eleven',
    'mdi-clock-time-eleven-outline',
    'mdi-clock-time-five',
    'mdi-clock-time-five-outline',
    'mdi-clock-time-four',
    'mdi-clock-time-four-outline',
    'mdi-clock-time-nine',
    'mdi-clock-time-nine-outline',
    'mdi-clock-time-one',
    'mdi-clock-time-one-outline',
    'mdi-clock-time-seven',
    'mdi-clock-time-seven-outline',
    'mdi-clock-time-six',
    'mdi-clock-time-six-outline',
    'mdi-clock-time-ten',
    'mdi-clock-time-ten-outline',
    'mdi-clock-time-three',
    'mdi-clock-time-three-outline',
    'mdi-clock-time-twelve',
    'mdi-clock-time-twelve-outline',
    'mdi-clock-time-two',
    'mdi-clock-time-two-outline',
    'mdi-close',
    'mdi-close-box',
    'mdi-close-box-multiple',
    'mdi-close-box-multiple-outline',
    'mdi-close-box-outline',
    'mdi-close-circle',
    'mdi-close-circle-multiple',
    'mdi-close-circle-multiple-outline',
    'mdi-close-circle-outline',
    'mdi-close-network',
    'mdi-close-network-outline',
    'mdi-close-octagon',
    'mdi-close-octagon-outline',
    'mdi-close-outline',
    'mdi-close-thick',
    'mdi-closed-caption',
    'mdi-closed-caption-outline',
    'mdi-cloud',
    'mdi-cloud-alert',
    'mdi-cloud-braces',
    'mdi-cloud-check',
    'mdi-cloud-check-outline',
    'mdi-cloud-circle',
    'mdi-cloud-download',
    'mdi-cloud-download-outline',
    'mdi-cloud-lock',
    'mdi-cloud-lock-outline',
    'mdi-cloud-off-outline',
    'mdi-cloud-outline',
    'mdi-cloud-print',
    'mdi-cloud-print-outline',
    'mdi-cloud-question',
    'mdi-cloud-refresh',
    'mdi-cloud-search',
    'mdi-cloud-search-outline',
    'mdi-cloud-sync',
    'mdi-cloud-sync-outline',
    'mdi-cloud-tags',
    'mdi-cloud-upload',
    'mdi-cloud-upload-outline',
    'mdi-clover',
    'mdi-coach-lamp',
    'mdi-coat-rack',
    'mdi-code-array',
    'mdi-code-braces',
    'mdi-code-braces-box',
    'mdi-code-brackets',
    'mdi-code-equal',
    'mdi-code-greater-than',
    'mdi-code-greater-than-or-equal',
    'mdi-code-json',
    'mdi-code-less-than',
    'mdi-code-less-than-or-equal',
    'mdi-code-not-equal',
    'mdi-code-not-equal-variant',
    'mdi-code-parentheses',
    'mdi-code-parentheses-box',
    'mdi-code-string',
    'mdi-code-tags',
    'mdi-code-tags-check',
    'mdi-codepen',
    'mdi-coffee',
    'mdi-coffee-maker',
    'mdi-coffee-off',
    'mdi-coffee-off-outline',
    'mdi-coffee-outline',
    'mdi-coffee-to-go',
    'mdi-coffee-to-go-outline',
    'mdi-coffin',
    'mdi-cog',
    'mdi-cog-box',
    'mdi-cog-clockwise',
    'mdi-cog-counterclockwise',
    'mdi-cog-off',
    'mdi-cog-off-outline',
    'mdi-cog-outline',
    'mdi-cog-refresh',
    'mdi-cog-refresh-outline',
    'mdi-cog-sync',
    'mdi-cog-sync-outline',
    'mdi-cog-transfer',
    'mdi-cog-transfer-outline',
    'mdi-cogs',
    'mdi-collage',
    'mdi-collapse-all',
    'mdi-collapse-all-outline',
    'mdi-color-helper',
    'mdi-comma',
    'mdi-comma-box',
    'mdi-comma-box-outline',
    'mdi-comma-circle',
    'mdi-comma-circle-outline',
    'mdi-comment',
    'mdi-comment-account',
    'mdi-comment-account-outline',
    'mdi-comment-alert',
    'mdi-comment-alert-outline',
    'mdi-comment-arrow-left',
    'mdi-comment-arrow-left-outline',
    'mdi-comment-arrow-right',
    'mdi-comment-arrow-right-outline',
    'mdi-comment-check',
    'mdi-comment-check-outline',
    'mdi-comment-edit',
    'mdi-comment-edit-outline',
    'mdi-comment-eye',
    'mdi-comment-eye-outline',
    'mdi-comment-multiple',
    'mdi-comment-multiple-outline',
    'mdi-comment-outline',
    'mdi-comment-plus',
    'mdi-comment-plus-outline',
    'mdi-comment-processing',
    'mdi-comment-processing-outline',
    'mdi-comment-question',
    'mdi-comment-question-outline',
    'mdi-comment-quote',
    'mdi-comment-quote-outline',
    'mdi-comment-remove',
    'mdi-comment-remove-outline',
    'mdi-comment-search',
    'mdi-comment-search-outline',
    'mdi-comment-text',
    'mdi-comment-text-multiple',
    'mdi-comment-text multiple-outline',
    'mdi-comment-text-outline',
    'mdi-compare',
    'mdi-compare-horizontal',
    'mdi-compare-vertical',
    'mdi-compass',
    'mdi-compass-off',
    'mdi-compas-off-outline',
    'mdi-compass-outline',
    'mdi-compass-rose',
    'mdi-concourse-ci',
    'mdi-console',
    'mdi-console-line',
    'mdi-console-network',
    'mdi-console-network-outline',
    'mdi-consolidate',
    'mdi-contactless-payment',
    'mdi-contactless-payment-circle',
    'mdi-contactless-payment-circle outline',
    'mdi-contacts',
    'mdi-contacts-outline',
    'mdi-contain',
    'mdi-contain-end',
    'mdi-contain-start',
    'mdi-content-copy',
    'mdi-content-cut',
    'mdi-content-duplicate',
    'mdi-content-paste',
    'mdi-content-save',
    'mdi-content-save-alert',
    'mdi-content-save-alert-outline',
    'mdi-content-save-all',
    'mdi-content-save-all-outline',
    'mdi-content-save-cog',
    'mdi-content-save-cog-outline',
    'mdi-content-save-edit',
    'mdi-content-save-edit-outline',
    'mdi-content-save-move',
    'mdi-content-save-move-outline',
    'mdi-content-save-outline',
    'mdi-content-save-settings',
    'mdi-content-save-settings-outline',
    'mdi-contrast',
    'mdi-contrast-box',
    'mdi-contrast-circle',
    'mdi-controller-classic',
    'mdi-controller-classic-outline',
    'mdi-cookie',
    'mdi-coolant-temperature',
    'mdi-copyright',
    'mdi-cordova',
    'mdi-corn',
    'mdi-corn-off',
    'mdi-cosine-wave',
    'mdi-counter',
    'mdi-cow',
    'mdi-cpu-32-bit',
    'mdi-cpu-64-bit',
    'mdi-crane',
    'mdi-creation',
    'mdi-creative-commons',
    'mdi-credit-card',
    'mdi-credit-card-check',
    'mdi-credit-car-check-outline',
    'mdi-credit-card-clock',
    'mdi-credit-card-clock-outline',
    'mdi-credit-card-marker',
    'mdi-credit-card-marker-outline',
    'mdi-credit-card-minus',
    'mdi-credit-card-minus-outline',
    'mdi-credit-card multiple',
    'mdi-credit-card-multiple-outline',
    'mdi-credit-card-off',
    'mdi-credit-card-off-outline',
    'mdi-credit-card-outline',
    'mdi-credit-card-plus',
    'mdi-credit-card-plus-outline',
    'mdi-credit-card-refund',
    'mdi-credit-card-refund-outline',
    'mdi-credit-card-remove',
    'mdi-credit-card-remove-outline',
    'mdi-credit-card-scan',
    'mdi-credit-card-scan-outline',
    'mdi-credit-card-setting',
    'mdi-credit-card-settings-outline',
    'mdi-credit-card-wireless',
    'mdi-credit-card-wireless-off',
    'mdi-credit-card-wireless-off-outline',
    'mdi-credit-card-wireless-outline',
    'mdi-cricket',
    'mdi-crop',
    'mdi-crop-free',
    'mdi-crop-landscape',
    'mdi-crop-portrait',
    'mdi-crop-rotate',
    'mdi-crop-square',
    'mdi-crosshairs',
    'mdi-crosshairs gps',
    'mdi-crosshairs-off',
    'mdi-crosshairs-question',
    'mdi-crown',
    'mdi-crown-outline',
    'mdi-cryengine',
    'mdi-crystal-ball',
    'mdi-cube',
    'mdi-cube-off',
    'mdi-cube-off-outline',
    'mdi-cube-outline',
    'mdi-cube-scan',
    'mdi-cube-send',
    'mdi-cube-unfolded',
    'mdi-cup',
    'mdi-cup-off',
    'mdi-cup-off-outline',
    'mdi-cup-outline',
    'mdi-cup-water',
    'mdi-cupboard',
    'mdi-cupboard-outline',
    'mdi-cupcake',
    'mdi-curling',
    'mdi-currency-bdt',
    'mdi-currency-brl',
    'mdi-currency-btc',
    'mdi-currency-cny',
    'mdi-currency-eth',
    'mdi-currency-eur',
    'mdi-currency-eur-off',
    'mdi-currency-gbp',
    'mdi-currency-ils',
    'mdi-currency-inr',
    'mdi-currency-jpy',
    'mdi-currency-krw',
    'mdi-currency-kzt',
    'mdi-currency-ngn',
    'mdi-currency-php',
    'mdi-currency-rial',
    'mdi-currency-rub',
    'mdi-currency-sign',
    'mdi-currency-try',
    'mdi-currenc-twd',
    'mdi-currency-usd',
    'mdi-currency-usd-circle',
    'mdi-currency-usd-circle-outline',
    'mdi-currency-usd-off',
    'mdi-current-ac',
    'mdi-current-dc',
    'mdi-cursor-default',
    'mdi-cursor-default-click',
    'mdi-cursor-default-click-outline',
    'mdi-cursor-default-gesture',
    'mdi-cursor-default-gesture-outline',
    'mdi-cursor-default-outline',
    'mdi-cursor-move',
    'mdi-cursor-pointer',
    'mdi-cursor-text',
    'mdi-database',
    'mdi-database-check',
    'mdi-database-edit',
    'mdi-database-export',
    'mdi-database-import ',
    'mdi-database-lock',
    'mdi-database-marker',
    'mdi-database-minus',
    'mdi-database-plus',
    'mdi-database-refresh',
    'mdi-database-remove',
    'mdi-database-search',
    'mdi-database-settings',
    'mdi-database-sync',
    'mdi-death-star',
    'mdi-death-star-variant',
    'mdi-deathly-hallows',
    'mdi-debian',
    'mdi-debug-step-into',
    'mdi-debug-step-out',
    'mdi-debug-step-over',
    'mdi-decagram',
    'mdi-decagram-outline',
    'mdi-decimal',
    'mdi-decimal-comma',
    'mdi-decimal-comma-decrease',
    'mdi-decimal-comma-increase',
    'mdi-decimal-decrease',
    'mdi-decimal-increase',
    'mdi-delete',
    'mdi-delete-alert',
    'mdi-delete-alert-outline',
    'mdi-delete-circle',
    'mdi-delete-circle-outline',
    'mdi-delete-empty',
    'mdi-delete-empty-outline',
    'mdi-delete-forever',
    'mdi-delete-forever-outline',
    'mdi-delete-off',
    'mdi-delete-off-outline',
    'mdi-delete-outline',
    'mdi-delete-restore',
    'mdi-delete-sweep',
    'mdi-delete-sweep-outline',
    'mdi-delete-variant',
    'mdi-delta',
    'mdi-desk',
    'mdi-desk-lamp',
    'mdi-deskphone',
    'mdi-desktop-classic',
    'mdi-desktop-mac',
    'mdi-desktop-mac-dashboard',
    'mdi-desktop-tower',
    'mdi-desktop-tower-monitor',
    'mdi-details',
    'mdi-dev-to',
    'mdi-developer-board',
    'mdi-deviantart',
    'mdi-devices',
    'mdi-diabetes',
    'mdi-dialpad',
    'mdi-diameter',
    'mdi-diameter-outline',
    'mdi-diameter-variant',
    'mdi-diamond',
    'mdi-diamond-outline',
    'mdi-diamond-stone',
    'mdi-dice-1',
    'mdi-dice-1-outline',
    'mdi-dice-2',
    'mdi-dice-2-outline',
    'mdi-dice-3',
    'mdi-dice-3-outline',
    'mdi-dice-4',
    'mdi-dice-4-outline',
    'mdi-dice-5',
    'mdi-dice-5-outline',
    'mdi-dice-6',
    'mdi-dice-6-outline',
    'mdi-dice-d10',
    'mdi-dice-d10-outline',
    'mdi-dice-d12',
    'mdi-dice-d12-outline',
    'mdi-dice-d20',
    'mdi-dice-d20-outline',
    'mdi-dice-d4',
    'mdi-dice-d4-outline',
    'mdi-dice-d6',
    'mdi-dice-d6-outline',
    'mdi-dice-d8',
    'mdi-dice-d8-outline',
    'mdi-dice-multiple',
    'mdi-dice-multiple-outline',
    'mdi-digital-ocean',
    'mdi-dip-switch',
    'mdi-directions',
    'mdi-directions-fork',
    'mdi-disc',
    'mdi-disc-alert',
    'mdi-disc-player',
    'mdi-discord',
    'mdi-dishwasher',
    'mdi-dishwasher-alert',
    'mdi-dishwasher-off',
    'mdi-disqus',
    'mdi-distribute-horizontal-center',
    'mdi-distribute-horizontal-left',
    'mdi-distribute-horizontal-right',
    'mdi-distribute-vertical-bottom',
    'mdi-distribute-vertical-center',
    'mdi-distribute-vertical-top',
    'mdi-diving-flippers',
    'mdi-diving-helmet',
    'mdi-diving-scuba',
    'mdi-divingscuba-flag',
    'mdi-diving-scuba-tank',
    'mdi-diving-scuba-tank-multiple',
    'mdi-diving-snorkel',
    'mdi-division',
    'mdi-division-box',
    'mdi-dlna',
    'mdi-dna',
    'mdi-dns',
    'mdi-dns-outline',
    'mdi-do-not-disturb',
    'mdi-do-not-disturb-off',
    'mdi-dock-bottom',
    'mdi-dock-left',
    'mdi-dock-right',
    'mdi-dock-window',
    'mdi-docker',
    'mdi-doctor',
    'mdi-dog',
    'mdi-dog-service',
    'mdi-dog-side',
    'mdi-dolby',
    'mdi-dolly',
    'mdi-domain',
    'mdi-domain-off',
    'mdi-domain-plus',
    'mdi-domain-remove',
    'mdi-dome-light',
    'mdi-domino-mask',
    'mdi-donkey',
    'mdi-door',
    'mdi-door-closed',
    'mdi-door-closed-lock',
    'mdi-door-open',
    'mdi-doorbell',
    'mdi-doorbell-video',
    'mdi-dot-net',
    'mdi-dots-horizontal',
    'mdi-dots-horizontal-circle',
    'mdi-dot-horizontal-circle-outline',
    'mdi-dots-vertical',
    'mdi-dots-vertical-circle',
    'mdi-dots-vertical-circle-outline',
    'mdi-douban',
    'mdi-download',
    'mdi-download-box',
    'mdi-download-box-outline',
    'mdi-download-circle',
    'mdi-download-circle-outline',
    'mdi-download-lock',
    'mdi-download-lock-outline',
    'mdi-download-multiple',
    'mdi-download-network',
    'mdi-download-network-outline',
    'mdi-download-off',
    'mdi-download-off-outline',
    'mdi-download-outline',
    'mdi-drag',
    'mdi-drag-horizontal',
    'mdi-drag-horizontal-variant',
    'mdi-drag-variant',
    'mdi-drag-vertical',
    'mdi-drag-vertical-variant',
    'mdi-drama-masks',
    'mdi-draw',
    'mdi-drawing',
    'mdi-drawing-box',
    'mdi-dresser',
    'mdi-dresser-outline',
    'mdi-drone',
    'mdi-dropbox',
    'mdi-drupal',
    'mdi-duck',
    'mdi-dumbbell',
    'mdi-dump-truck',
    'mdi-ear-hearing',
    'mdi-ear-hearing-off',
    'mdi-earth',
    'mdi-earth-arrow-right',
    'mdi-earth-box',
    'mdi-earth-box-minus',
    'mdi-earth-box-off',
    'mdi-earth-box-plus',
    'mdi-earth-box-remove',
    'mdi-earth-minus                                                ',
    'mdi-earth-off',
    'mdi-earth-plus',
    'mdi-earth-remove',
    'mdi-egg',
    'mdi-egg-easter',
    'mdi-egg-off',
    'mdi-egg-off-outline',
    'mdi-egg-outline',
    'mdi-eight-track',
    'mdi-eject',
    'mdi-eject-outline',
    'mdi-electric-switch',
    'mdi-electric-switch-closed',
    'mdi-electron-framework',
    'mdi-elephant',
    'mdi-elevation-decline',
    'mdi-elevation-rise',
    'mdi-elevator',
    'mdi-elevator-down',
    'mdi-elevator-passenger',
    'mdi-elevator-up',
    'mdi-ellipse',
    'mdi-ellipse-outline',
    'mdi-email',
    'mdi-email-alert',
    'mdi-email-alert-outline',
    'mdi-email-box',
    'mdi-email-check',
    'mdi-email-check-outline',
    'mdi-email-edit',
    'mdi-email edit-outline',
    'mdi-email lock',
    'mdi-email-mark-as-unread',
    'mdi-email-minus',
    'mdi-email-minus-outline',
    'mdi-email-multiple',
    'mdi-email-multiple-outline',
    'mdi-email-newsletter',
    'mdi-email-off',
    'mdi-email-off-outline',
    'mdi-email-open',
    'mdi-email-open-multiple',
    'mdi-email-open-multiple-outline',
    'mdi-email-open-outline                                                                ',
    'mdi-email-outline',
    'mdi-email-plus',
    'mdi-email-plus-outline',
    'mdi-email-receive',
    'mdi-email-receive-outline',
    'mdi-email-search',
    'mdi-email-search-outline',
    'mdi-email-send',
    'mdi-email-send-outline',
    'mdi-email-sync',
    'mdi-email-sync-outline',
    'mdi-email-variant',
    'mdi-ember',
    'mdi-emby',
    'mdi-emoticon',
    'mdi-emoticon-angry',
    'mdi-emoticon-angry-outline',
    'mdi-emoticon-confused',
    'mdi-emoticon-confused-outline',
    'mdi-emoticon-cool',
    'mdi-emoticon-cool outline',
    'mdi-emoticon-cry',
    'mdi-emoticon-cry-outline',
    'mdi-emoticon-dead',
    'mdi-emoticon-dead-outline',
    'mdi-emoticon-devil',
    'mdi-emoticon-devil-outline',
    'mdi-emoticon-excited',
    'mdi-emoticon-excited-outline',
    'mdi-emoticon-frown',
    'mdi-emoticon-frown-outline',
    'mdi-emoticon-happy',
    'mdi-emoticon-happy-outline',
    'mdi-emoticon-kiss',
    'mdi-emoticon-kiss-outline',
    'mdi-emoticon-lol',
    'mdi-emoticon-lol-outline',
    'mdi-emoticon-neutral',
    'mdi-emoticon-neutral-outline',
    'mdi-emoticon-outline',
    'mdi-emoticon-poop',
    'mdi-emoticon-poop-outline',
    'mdi-emoticon-sad',
    'mdi-emoticon sad-outline',
    'mdi-emoticon-tongue',
    'mdi-emoticon-tongue-outline',
    'mdi-emoticon-wink',
    'mdi-emoticon-wink-outline',
    'mdi-engine',
    'mdi-engine-off',
    'mdi-engine-off-outline',
    'mdi-engine-outline',
    'mdi-epsilon',
    'mdi-equal',
    'mdi-equal-box',
    'mdi-equalize',
    'mdi-equalizer-outline',
    'mdi-eraser',
    'mdi-eraser-variant',
    'mdi-escalator',
    'mdi-escalator-box',
    'mdi-escalator-down',
    'mdi-escalator-up',
    'mdi-eslint',
    'mdi-et',
    'mdi-ethereum',
    'mdi-ethernet',
    'mdi-ethernet-cable',
    'mdi-ethernet-cable-off',
    'mdi-ev-station',
    'mdi-evernote',
    'mdi-excavator',
    'mdi-exclamation',
    'mdi-exclamation-thick',
    'mdi-exit-run',
    'mdi-exit-to-app',
    'mdi-expand-all',
    'mdi-expand-all-outline',
    'mdi-expansion-card',
    'mdi-expansion-card-variant',
    'mdi-exponent',
    'mdi-exponent-box',
    'mdi-export',
    'mdi-export-variant',
    'mdi-eye',
    'mdi-eye-check',
    'mdi-eye-check-outline',
    'mdi-eye-circle',
    'mdi-eye-circle-outline',
    'mdi-eye-minus',
    'mdi-eye-minus-outline',
    'mdi-eye-off',
    'mdi-eye-off-outline',
    'mdi-eye-outline',
    'mdi-eye-plus',
    'mdi-eye-plus-outline',
    'mdi-eye-settings',
    'mdi-eye-settings-outline',
    'mdi-eyedropper',
    'mdi-eyedropper-minus',
    'mdi-eyedropper-off',
    'mdi-eyedropper-plus',
    'mdi-eyedropper-remove',
    'mdi-eyedropper-variant',
    'mdi-face',
    'mdi-face-agent',
    'mdi-face-outline',
    'mdi-face-profile',
    'mdi-face-profile-woman',
    'mdi-face-recognition',
    'mdi-face-woman',
    'mdi-face-woman-outline',
    'mdi-facebook',
    'mdi-facebook-messenger',
    'mdi-facebook-workplace',
    'mdi-factory',
    'mdi-fan',
    'mdi-fan-alert',
    'mdi-fan-chevron-down',
    'mdi-fan-chevron-up',
    'mdi-fan-minus',
    'mdi-fan-off',
    'mdi-fan-plus',
    'mdi-fan-remove',
    'mdi-fan-speed-1',
    'mdi-fan-speed-2',
    'mdi-fan-speed-3',
    'mdi-fast-forward',
    'mdi-fast-forward-10',
    'mdi-fast-forward-30',
    'mdi-fast-forward-5',
    'mdi-fast-forward-outline',
    'mdi-fax',
    'mdi-feather',
    'mdi-feature-search',
    'mdi-feature-search-outline',
    'mdi-fedora',
    'mdi-fencing',
    'mdi-ferris-wheel',
    'mdi-ferry',
    'mdi-file',
    'mdi-file-account',
    'mdi-file-account-outline',
    'mdi-file-alert',
    'mdi-file-alert-outline',
    'mdi-file-cabinet',
    'mdi-file-cad',
    'mdi-file-cad-box',
    'mdi-file-cancel',
    'mdi-file-cancel-outline',
    'mdi-file-certificate',
    'mdi-file-certificate-outline',
    'mdi-file-chart',
    'mdi-file-chart-outline',
    'mdi-file-check',
    'mdi-file-check-outline',
    'mdi-file-clock',
    'mdi-file-clock-outline',
    'mdi-file-cloud',
    'mdi-file-cloud-outline',
    'mdi-file-code',
    'mdi-file-code-outline',
    'mdi-file-cog',
    'mdi-file-cog-outline',
    'mdi-file-compare',
    'mdi-file-delimited',
    'mdi-file-delimited-outline',
    'mdi-file-document',
    'mdi-file-document-edit',
    'mdi-file-document edit-outline',
    'mdi-file-document-outline',
    'mdi-file-download',
    'mdi-file-download-outline',
    'mdi-file-edit',
    'mdi-file-edit-outline',
    'mdi-file-excel',
    'mdi-file-excel-box',
    'mdi-file-excel-box-outline',
    'mdi-file-excel-outline',
    'mdi-file-export',
    'mdi-file-export-outline',
    'mdi-file-eye',
    'mdi-file-eye-outline',
    'mdi-file-find',
    'mdi-fil-find-outline',
    'mdi-file-hidden',
    'mdi-file-image',
    'mdi-file-image-outline',
    'mdi-file-import ',
    'mdi-file-import-outline',
    'mdi-file-key',
    'mdi-file-key-outline',
    'mdi-file-link',
    'mdi-file-link-outline',
    'mdi-file-lock',
    'mdi-file-lock-outline',
    'mdi-file-move',
    'mdi-file-move-outline',
    'mdi-file-multiple',
    'mdi-file-multiple-outline',
    'mdi-file-music',
    'mdi-file-music-outline',
    'mdi-file-outline',
    'mdi-file-pdf',
    'mdi-file-pdf box',
    'mdi-file-pdf-box-outline',
    'mdi-file-pdf-outline',
    'mdi-file-percent',
    'mdi-file-percent-outline',
    'mdi-file-phone',
    'mdi-file-phone-outline',
    'mdi-file-plus',
    'mdi-file-plus-outline',
    'mdi-file-powerpoint',
    'mdi-file-powerpoint-box',
    'mdi-file-powerpoint-box-outline',
    'mdi-file-powerpoint-outline',
    'mdi-file-presentation-box',
    'mdi-file-question',
    'mdi-file-question-outline',
    'mdi-file-refresh',
    'mdi-file-refresh-outline',
    'mdi-file-remove',
    'mdi-file-remove-outline',
    'mdi-file-replace',
    'mdi-file-replace-outline',
    'mdi-file-restore',
    'mdi-file-restore-outline',
    'mdi-file-search',
    'mdi-file-search-outline',
    'mdi-file-send',
    'mdi-file-send-outline',
    'mdi-file-settings',
    'mdi-file-settings-outline',
    'mdi-file-star',
    'mdi-file-star-outline',
    'mdi-file-swap',
    'mdi-file-swap-outline',
    'mdi-file-sync',
    'mdi-file-sync-outline',
    'mdi-file-table',
    'mdi-file-table-box',
    'mdi-file-table-box-multiple',
    'mdi-file-table-box-multiple-outline',
    'mdi-file-table-box-outline',
    'mdi-file-table-outline',
    'mdi-file-tree',
    'mdi-file-tree-outline',
    'mdi-file-undo',
    'mdi-file-undo-outline',
    'mdi-file-upload',
    'mdi-file-upload-outline',
    'mdi-file-video',
    'mdi-file-video-outline',
    'mdi-file-word',
    'mdi-file-word-box',
    'mdi-file-word-box-outline',
    'mdi-file-word-outline',
    'mdi-film',
    'mdi-filmstrip',
    'mdi-filmstrip-box',
    'mdi-filmstrip-box-multiple',
    'mdi-filmstrip-off',
    'mdi-filter',
    'mdi-filter-menu',
    'mdi-filter-menu-outline',
    'mdi-filter-minus',
    'mdi-filter-minus-outline',
    'mdi-filter-outline',
    'mdi-filter-plus',
    'mdi-filter-plus-outline',
    'mdi-filter-remove',
    'mdi-filter-remove-outline',
    'mdi-filter-variant',
    'mdi-filter-variant-minus',
    'mdi-filter-variant-plus',
    'mdi-filter-variant-remove',
    'mdi-finance',
    'mdi-find-replace',
    'mdi-fingerprint',
    'mdi-fingerprint-off',
    'mdi-fire',
    'mdi-fire-extinguisher',
    'mdi-fire-hydrant',
    'mdi-fire-hydrant-alert',
    'mdi-fire-hydrant-off',
    'mdi-fire-truck',
    'mdi-firebase',
    'mdi-firefox',
    'mdi-fireplace',
    'mdi-fireplace-off',
    'mdi-firework',
    'mdi-fish',
    'mdi-fish-off',
    'mdi-fishbowl',
    'mdi-fishbowl-outline',
    'mdi-fit-to-page',
    'mdi-fi-to-page-outline',
    'mdi-flag',
    'mdi-flag-checkered',
    'mdi-flag-minus',
    'mdi-flag-minus-outline',
    'mdi-flag-outline',
    'mdi-flag-plus',
    'mdi-flag-plus-outline',
    'mdi-flag-remove',
    'mdi-flag-remove-outline',
    'mdi-flag-triangle',
    'mdi-flag-variant',
    'mdi-flag-variant-outline',
    'mdi-flare',
    'mdi-flash',
    'mdi-flash-alert',
    'mdi-flash-alert-outline',
    'mdi-flash-auto',
    'mdi-flash-circle',
    'mdi-flash-off',
    'mdi-flash-outline',
    'mdi-flash-red-eye',
    'mdi-flashlight',
    'mdi-flashlight-off',
    'mdi-flask',
    'mdi-flask-empty',
    'mdi-flask-empty-minus',
    'mdi-flask-empty-minus-outline',
    'mdi-flask-empty-off',
    'mdi-flask-empty-off-outline',
    'mdi-flask-empty-outline',
    'mdi-flask-empty-plus',
    'mdi-flask-empty-plus-outline',
    'mdi-flask-empty-remove',
    'mdi-flask-empty-remove-outline',
    'mdi-flask-minus',
    'mdi-flask-minus-outline',
    'mdi-flask-off',
    'mdi-flask-off-outline',
    'mdi-flask-outline',
    'mdi-flask-plus',
    'mdi-flask-plus-outline',
    'mdi-flask-remove',
    'mdi-flask-remove-outline',
    'mdi-flask-round-bottom',
    'mdi-flask-round-bottom-empty',
    'mdi-flask-round-bottom-empty-outline',
    'mdi-flask-round-bottom-outline',
    'mdi-fleur-de-lis',
    'mdi-flip-horizontal',
    'mdi-flip-to-back',
    'mdi-flip-to-front',
    'mdi-flip-vertical',
    'mdi-floor-lamp',
    'mdi-floor-lamp-dual',
    'mdi-floor-lamp-variant',
    'mdi-floor-plan',
    'mdi-floppy',
    'mdi-floppy-variant',
    'mdi-flower',
    'mdi-flower-outline',
    'mdi-flower-poppy',
    'mdi-flower-tulip',
    'mdi-flower-tulip-outline',
    'mdi-focus-auto',
    'mdi-focus-field',
    'mdi-focus-field-horizontal',
    'mdi-focus-field-vertical',
    'mdi-folder',
    'mdi-folder-account',
    'mdi-folder-account-outline',
    'mdi-folder-alert',
    'mdi-folder-alert-outline',
    'mdi-folder-clock',
    'mdi-folder-clock-outline',
    'mdi-folder-cog',
    'mdi-folder-cog-outline',
    'mdi-folder-download',
    'mdi-folder-download-outline',
    'mdi-folder-edit',
    'mdi-folder-edit-outline',
    'mdi-folder-google-drive',
    'mdi-folder-heart',
    'mdi-folder-heart-outline',
    'mdi-folder-home',
    'mdi-folder-home-outline',
    'mdi-folder-image',
    'mdi-folder-information',
    'mdi-folder-information-outline',
    'mdi-folder-key',
    'mdi-folder-key-network',
    'mdi-folder-key-network-outline',
    'mdi-folder-key-outline',
    'mdi-folder-lock',
    'mdi-folder-lock-open',
    'mdi-folder-marker',
    'mdi-folder-marker-outline',
    'mdi-folder-move',
    'mdi-folder-move-outline',
    'mdi-folder-multiple',
    'mdi-folder-multiple-image',
    'mdi-folder-multiple-outline',
    'mdi-folder-multiple-plus',
    'mdi-folder-multiple-plus-outline',
    'mdi-folder-music',
    'mdi-folder-music-outline',
    'mdi-folder-network',
    'mdi-folder-network-outline',
    'mdi-folder-open',
    'mdi-folder-open-outline',
    'mdi-folder-outline',
    'mdi-folder-plus',
    'mdi-folder-plus-outline',
    'mdi-folder-pound',
    'mdi-folder-pound-outline',
    'mdi-folder-refresh',
    'mdi-folder-refresh-outline',
    'mdi-folder-remove',
    'mdi-folder-remove-outline',
    'mdi-folder-search',
    'mdi-folder-search-outline',
    'mdi-folder-settings',
    'mdi-folder-settings-outline',
    'mdi-folder-star',
    'mdi-folder-star-multiple',
    'mdi-folder-star-multiple-outline',
    'mdi-folder-star-outline',
    'mdi-folder-swap',
    'mdi-folder-swap-outline',
    'mdi-folder-sync',
    'mdi-folder-sync-outline',
    'mdi-folder-table',
    'mdi-folder-table-outline',
    'mdi-folder-text',
    'mdi-folder-text-outline',
    'mdi-folder-upload',
    'mdi-folder-upload-outline',
    'mdi-folder-zip',
    'mdi-folder-zip-outline',
    'mdi-font-awesome',
    'mdi-food',
    'mdi-food-apple',
    'mdi-food-apple-outline',
    'mdi-food-croissant',
    'mdi-food-drumstick',
    'mdi-food-drumstick-off',
    'mdi-food-drumstick-off-outline',
    'mdi-food-drumstick-outline',
    'mdi-food-fork-drink',
    'mdi-food-off',
    'mdi-food-steak',
    'mdi-food-steak-off',
    'mdi-food-variant',
    'mdi-food-variant-off',
    'mdi-foot-print',
    'mdi-football',
    'mdi-football-australian',
    'mdi-football-helmet',
    'mdi-forklift',
    'mdi-form-dropdown',
    'mdi-form-select',
    'mdi-form-textarea',
    'mdi-form-textbox',
    'mdi-form-textbox-lock',
    'mdi-form-textbox-password',
    'mdi-format-align-bottom',
    'mdi-format-align-center',
    'mdi-format-align-justify',
    'mdi-format-align-left',
    'mdi-format-align-middle',
    'mdi-format-align-right',
    'mdi-format-align-top',
    'mdi-format-annotation-minus',
    'mdi-format-annotation-plus',
    'mdi-format-bold',
    'mdi-format-clear',
    'mdi-format-color-fill',
    'mdi-format-color-highlight',
    'mdi-format-color-marker-cancel',
    'mdi-format-color-text',
    'mdi-format-columns',
    'mdi-format-float-center',
    'mdi-format-float-left',
    'mdi-format-float-none',
    'mdi-format-float-right',
    'mdi-format-font',
    'mdi-format-font-size-decrease',
    'mdi-format-font-size-increase',
    'mdi-format-header-1',
    'mdi-format-header-2',
    'mdi-format-header-3',
    'mdi-format-header-4',
    'mdi-format-header-5',
    'mdi-format-header-6',
    'mdi-format-header-decrease',
    'mdi-format-header-equal',
    'mdi-format-header-increase',
    'mdi-format-header-pound',
    'mdi-format-horizontal-align-center',
    'mdi-format-horizontal-align-left',
    'mdi-format-horizontal-align-right',
    'mdi-format-indent-decrease',
    'mdi-format-indent-increase',
    'mdi-format-italic',
    'mdi-format-letter-case',
    'mdi-format-letter-case-lower',
    'mdi-format-letter-case-upper',
    'mdi-format-letter-ends-with',
    'mdi-format-letter-matches',
    'mdi-format-letter-starts-with',
    'mdi-format-line-spacing',
    'mdi-format-line-style',
    'mdi-format-line-weight',
    'mdi-format-list-bulleted',
    'mdi-format-list-bulleted-square',
    'mdi-format-list-bulleted-triangle',
    'mdi-format-list-bulleted-type',
    'mdi-format-list-checkbox',
    'mdi-format-list-checks',
    'mdi-format-list-numbered',
    'mdi-format-list-numbered-rtl',
    'mdi-format-list-text',
    'mdi-format-overline',
    'mdi-format-page-break',
    'mdi-format-paint',
    'mdi-format-paragraph',
    'mdi-format-pilcrow',
    'mdi-format-quote-close',
    'mdi-format-quote-close-outline',
    'mdi-format-quote-open',
    'mdi-format-quote-open-outline',
    'mdi-format-rotate-90',
    'mdi-format-section',
    'mdi-format-size',
    'mdi-format-strikethrough',
    'mdi-format-strikethrough-variant',
    'mdi-format-subscript',
    'mdi-format-superscript',
    'mdi-format-text',
    'mdi-format-text-rotation-angle-down',
    'mdi-format-text-rotation-angle-up',
    'mdi-format-text-rotation-down',
    'mdi-format-text-rotation-down-vertical',
    'mdi-format-text-rotation-none',
    'mdi-format-text-rotation-up',
    'mdi-format-text-rotation-vertical',
    'mdi-format-text-variant',
    'mdi-format-text-wrapping-clip',
    'mdi-format-text-wrapping-overflow',
    'mdi-format-text-wrapping-wrap',
    'mdi-format-textbox',
    'mdi-format-textdirection-l-to-r',
    'mdi-format-textdirection-r-to-l',
    'mdi-format-title',
    'mdi-format-underline',
    'mdi-format-vertical-align-bottom',
    'mdi-format-vertical-align-center',
    'mdi-format-vertical-align-top',
    'mdi-format-wrap-inline',
    'mdi-format-wrap-square',
    'mdi-format-wrap-tight',
    'mdi-format-wrap-top-bottom',
    'mdi-forum',
    'mdi-forum-outline',
    'mdi-forward',
    'mdi-forwardburger',
    'mdi-fountain',
    'mdi-fountain-pen',
    'mdi-fountain-pen-tip',
    'mdi-freebsd',
    'mdi-frequently-asked-questions',
    'mdi-fridge',
    'mdi-fridge-alert',
    'mdi-fridge-alert-outline',
    'mdi-fridge-bottom',
    'mdi-fridge-off',
    'mdi-fridge-off-outline',
    'mdi-fridge-outline',
    'mdi-fridge-top',
    'mdi-fruit-cherries',
    'mdi-fruit-cherries-off',
    'mdi-fruit-citrus',
    'mdi-fruit-citrus-off',
    'mdi-fruit-grapes',
    'mdi-fruit-grapes-outline',
    'mdi-fruit-pineapple',
    'mdi-fruit-watermelon',
    'mdi-fuel',
    'mdi-fullscreen',
    'mdi-fullscreen-exit',
    'mdi-function',
    'mdi-function-variant',
    'mdi-furigana-horizontal',
    'mdi-furigana-vertical',
    'mdi-fuse',
    'mdi-fuse-alert',
    'mdi-fuse-blade',
    'mdi-fuse-off',
    'mdi-gamepad',
    'mdi-gamepad-circle',
    'mdi-gamepad-circle-down',
    'mdi-gamepad-circle-left',
    'mdi-gamepad-circle-outline',
    'mdi-gamepad-circle-right',
    'mdi-gamepad-circle-up',
    'mdi-gamepad-down',
    'mdi-gamepad-left',
    'mdi-gamepad-right',
    'mdi-gamepad-round',
    'mdi-gamepad-round-down',
    'mdi-gamepad-round-left',
    'mdi-gamepad-round-outline',
    'mdi-gamepad-round-right',
    'mdi-gamepad-round-up',
    'mdi-gamepad-square',
    'mdi-gamepad-square-outline',
    'mdi-gamepad-up',
    'mdi-gamepad-variant',
    'mdi-gamepad-variant-outline',
    'mdi-gamma',
    'mdi-gantry-crane',
    'mdi-garage',
    'mdi-garage-alert',
    'mdi-garage-alert-variant',
    'mdi-garage-open',
    'mdi-garage-open-variant',
    'mdi-garage-variant',
    'mdi-gas-cylinder',
    'mdi-gas-station',
    'mdi-gas-station-off',
    'mdi-gas-station-off-outline',
    'mdi-gas-station-outline',
    'mdi-gate',
    'mdi-gate-and',
    'mdi-gate-arrow-right',
    'mdi-gate-nand',
    'mdi-gate-nor',
    'mdi-gate-not',
    'mdi-gate-open',
    'mdi-gate-or',
    'mdi-gate-xnor',
    'mdi-gate-xor',
    'mdi-gatsby',
    'mdi-gauge',
    'mdi-gauge-empty',
    'mdi-gauge-full',
    'mdi-gauge-low',
    'mdi-gavel',
    'mdi-gender-female',
    'mdi-gender-male',
    'mdi-gender-male-female',
    'mdi-gender-male-female-variant',
    'mdi-gender-non-binary',
    'mdi-gender-transgender',
    'mdi-gentoo',
    'mdi-gesture',
    'mdi-gesture-double-tap',
    'mdi-gesture-pinch',
    'mdi-gesture-spread',
    'mdi-gesture-swipe',
    'mdi-gesture-swipe-down',
    'mdi-gesture-swipe-horizontal',
    'mdi-gesture-swipe-left',
    'mdi-gesture-swipe-right',
    'mdi-gesture-swipe-up',
    'mdi-gesture-swipe-vertical',
    'mdi-gesture-tap',
    'mdi-gesture-tap-box',
    'mdi-gesture-tap-button',
    'mdi-gesture-tap-hold',
    'mdi-gesture-two-double-tap',
    'mdi-gesture-two-tap',
    'mdi-ghost',
    'mdi-ghost-off',
    'mdi-gif',
    'mdi-gift',
    'mdi-gift-outline',
    'mdi-git',
    'mdi-github',
    'mdi-gitlab',
    'mdi-glass-cocktail',
    'mdi-glass-flute',
    'mdi-glass-mug',
    'mdi-glass-mug-variant',
    'mdi-glass-pint-outline',
    'mdi-glass-stange',
    'mdi-glass-tulip',
    'mdi-glass-wine',
    'mdi-glasses',
    'mdi-globe-light',
    'mdi-globe-model',
    'mdi-gmail',
    'mdi-gnome',
    'mdi-go-kart',
    'mdi-go-kart-track',
    'mdi-gog',
    'mdi-gold',
    'mdi-golf',
    'mdi-golf-cart',
    'mdi-golf-tee',
    'mdi-gondola',
    'mdi-goodreads',
    'mdi-google',
    'mdi-google-ads',
    'mdi-google-analytics',
    'mdi-google-assistant',
    'mdi-google-cardboard',
    'mdi-google-chrome',
    'mdi-google-circles',
    'mdi-google-circles-communities',
    'mdi-google-circles-extended',
    'mdi-google-circles-group',
    'mdi-google-classroom',
    'mdi-google-cloud',
    'mdi-google-controller',
    'mdi-google-controller-of',
    'mdi-google-downasaur',
    'mdi-google-drive',
    'mdi-google-earth',
    'mdi-google-fit',
    'mdi-google-glass',
    'mdi-google-hangouts',
    'mdi-google-home',
    'mdi-google-keep',
    'mdi-google-lens',
    'mdi-google-maps',
    'mdi-google-my-business',
    'mdi-google-nearby',
    'mdi-google-photos',
    'mdi-google-play',
    'mdi-google-plus',
    'mdi-google-podcast',
    'mdi-google-spreadsheet',
    'mdi-google-street-view',
    'mdi-google-translate',
    'mdi-gradient',
    'mdi-grai',
    'mdi-graph',
    'mdi-graph-outline',
    'mdi-graphql',
    'mdi-grave-stone',
    'mdi-grease-pencil',
    'mdi-greater-than',
    'mdi-greater-than-or-equal',
    'mdi-grid',
    'mdi-grid-large',
    'mdi-grid-off',
    'mdi-grill',
    'mdi-grill-outline',
    'mdi-group',
    'mdi-guitar-acoustic',
    'mdi-guitar-electric',
    'mdi-guitar-pick',
    'mdi-guitar-pick-outline',
    'mdi-guy-fawkes-mask',
    'mdi-hail',
    'mdi-hair-dryer',
    'mdi-hair-dryer-outline',
    'mdi-halloween',
    'mdi-hamburger',
    'mdi-hammer',
    'mdi-hammer-screwdriver',
    'mdi-hammer-wrench',
    'mdi-hand',
    'mdi-hand-heart',
    'mdi-hand-left',
    'mdi-hand-oka',
    'mdi-hand-peace',
    'mdi-hand-peace-variant',
    'mdi-hand-pointing-down',
    'mdi-hand-pointing-left',
    'mdi-hand-pointing-right',
    'mdi-hand-pointing-up',
    'mdi-hand-right',
    'mdi-hand-saw',
    'mdi-hand-water',
    'mdi-handball',
    'mdi-handcuffs',
    'mdi-handshake',
    'mdi-hanger',
    'mdi-hard-hat',
    'mdi-harddisk',
    'mdi-harddisk-plus',
    'mdi-harddisk-remove',
    'mdi-hat-fedora',
    'mdi-hazard-lights',
    'mdi-hdr',
    'mdi-hdr-off',
    'mdi-head',
    'mdi-head-alert',
    'mdi-head-alert-outline',
    'mdi-head-check',
    'mdi-head-check-outline',
    'mdi-head-cog',
    'mdi-head-cog-outline',
    'mdi-head-dots-horizontal',
    'mdi-head-dots-horizontal-outline',
    'mdi-head-flash',
    'mdi-head-flash-outline',
    'mdi-head-heart',
    'mdi-head-heart-outline',
    'mdi-head-lightbulb',
    'mdi-head-lightbulb-outline',
    'mdi-head-minus',
    'mdi-head-minus-outline',
    'mdi-head-outline',
    'mdi-head-plus',
    'mdi-head-plus-outline',
    'mdi-head-question',
    'mdi-head-question-outline',
    'mdi-head-remove',
    'mdi-head-remove-outline',
    'mdi-head-snowflake',
    'mdi-head-snowflake-outline',
    'mdi-head-sync',
    'mdi-head-sync-outline',
    'mdi-headphones',
    'mdi-headphones-bluetooth',
    'mdi-headphones-box',
    'mdi-headphones-off',
    'mdi-headphones-settings',
    'mdi-headset',
    'mdi-headset-dock',
    'mdi-headset-off',
    'mdi-heart',
    'mdi-heart-box',
    'mdi-heart-box-outline',
    'mdi-heart-broken',
    'mdi-heart-broken-outline',
    'mdi-heart-circle',
    'mdi-heart-circle-outline',
    'mdi-heart-flash',
    'mdi-heart-half',
    'mdi-heart-half-full',
    'mdi-heart-half-outline',
    'mdi-heart-minus',
    'mdi-heart-minus-outline',
    'mdi-heart-multiple',
    'mdi-heart-multiple-outline',
    'mdi-heart-off',
    'mdi-heart-off-outline',
    'mdi-heart-outline',
    'mdi-heart-plus',
    'mdi-heart-plus-outline',
    'mdi-heart-pulse',
    'mdi-heart-remove',
    'mdi-heart-remove-outline',
    'mdi-helicopter',
    'mdi-help',
    'mdi-help-box',
    'mdi-help-circle',
    'mdi-help-circle-outline',
    'mdi-help-network',
    'mdi-help-network-outline',
    'mdi-help-rhombus',
    'mdi-help-rhombus-outline',
    'mdi-hexadecimal',
    'mdi-hexagon',
    'mdi-hexagon-multiple',
    'mdi-hexagon-multiple-outline',
    'mdi-hexagon-outline',
    'mdi-hexagon-slice-1',
    'mdi-hexagon-slice-2',
    'mdi-hexagon-slice-3',
    'mdi-hexagon-slice-4',
    'mdi-hexagon-slice-5',
    'mdi-hexagon-slice-6',
    'mdi-hexagram',
    'mdi-hexagram-outline',
    'mdi-high-definition',
    'mdi-high-definition-box',
    'mdi-highway',
    'mdi-hiking',
    'mdi-hinduism',
    'mdi-history',
    'mdi-hockey-puck',
    'mdi-hockey-sticks',
    'mdi-hololens',
    'mdi-home',
    'mdi-home-account',
    'mdi-home-alert',
    'mdi-home-analytics',
    'mdi-home-assistant',
    'mdi-home-automation',
    'mdi-home-circle',
    'mdi-home-circle-outline',
    'mdi-home-city',
    'mdi-home-city-outline',
    'mdi-home-currency-usd',
    'mdi-home-edit',
    'mdi-home-edit-outline',
    'mdi-home-export-outline',
    'mdi-home-flood',
    'mdi-home-floor-0',
    'mdi-home-floor-1',
    'mdi-home-floor-2',
    'mdi-home-floor-3',
    'mdi-home-floor-a',
    'mdi-home-floor-b',
    'mdi-home-floor-g',
    'mdi-home-floor-l',
    'mdi-home-floor-negative-1',
    'mdi-home-group',
    'mdi-home-heart',
    'mdi-home-import-outline',
    'mdi-home-lightbulb',
    'mdi-home-lightbulb-outline',
    'mdi-home-lock',
    'mdi-home-lock-open',
    'mdi-home-map-marker',
    'mdi-home-minus',
    'mdi-home-minus-outline',
    'mdi-home-modern',
    'mdi-home-outline',
    'mdi-home-plus',
    'mdi-home-plus-outline',
    'mdi-home-remove',
    'mdi-home-remove-outline',
    'mdi-home-roof',
    'mdi-home-search',
    'mdi-home-search-outline',
    'mdi-home-thermometer',
    'mdi-home-thermometer-outline',
    'mdi-home-variant',
    'mdi-home-variant-outline',
    'mdi-hook',
    'mdi-hook-off',
    'mdi-hops',
    'mdi-horizontal-rotate-clockwise',
    'mdi-horizontal-rotate-counterclockwise',
    'mdi-horseshoe',
    'mdi-hospital',
    'mdi-hospital-box',
    'mdi-hospital-box-outline',
    'mdi-hospital-building',
    'mdi-hospital-marker',
    'mdi-hot-tub',
    'mdi-hours-24',
    'mdi-hubspot',
    'mdi-hulu',
    'mdi-human',
    'mdi-human-baby-changing-table',
    'mdi-human-child',
    'mdi-human-female',
    'mdi-human-female-boy',
    'mdi-human-female-female',
    'mdi-human-female-girl',
    'mdi-human-greeting',
    'mdi-human-handsdown',
    'mdi-human-handsup',
    'mdi-human-male',
    'mdi-human-male-boy',
    'mdi-human-male-child',
    'mdi-human-male-female',
    'mdi-human-male-girl',
    'mdi-human-male-height',
    'mdi-human-male-height-variant',
    'mdi-human-male-male',
    'mdi-human-pregnant',
    'mdi-human-wheelchair',
    'mdi-humble-bundle',
    'mdi-hvac',
    'mdi-hydraulic-oil-level',
    'mdi-hydraulic-oil-temperature',
    'mdi-hydro-power',
    'mdi-ice-cream',
    'mdi-ice-cream-off',
    'mdi-ice-pop',
    'mdi-id-card',
    'mdi-identifier',
    'mdi-ideogram-cjk',
    'mdi-ideogram-cjk-variant',
    'mdi-iframe',
    'mdi-iframe-array',
    'mdi-iframe-array-outline',
    'mdi-iframe-braces',
    'mdi-iframe-braces-outline',
    'mdi-iframe-outline',
    'mdi-iframe-parentheses',
    'mdi-iframe-parentheses-outline',
    'mdi-iframe-variable',
    'mdi-iframe-variable-outline',
    'mdi-image',
    'mdi-image-album',
    'mdi-image-area',
    'mdi-image-area-close',
    'mdi-image-auto-adjust',
    'mdi-image-broken',
    'mdi-image-broken-variant',
    'mdi-image-edit',
    'mdi-image-edit-outline',
    'mdi-image-filter-black-white',
    'mdi-image-filter-center-focus',
    'mdi-image-filter-center-focus-strong',
    'mdi-image-filter-center-focus-strong-outline',
    'mdi-image-filter-center-focus-weak',
    'mdi-image-filter-drama',
    'mdi-image-filter-frames',
    'mdi-image-filter-hdr',
    'mdi-image-filter-none',
    'mdi-image-filter-tilt-shift',
    'mdi-image-filter-vintage',
    'mdi-image-frame',
    'mdi-image-minus',
    'mdi-image-move',
    'mdi-image-multiple',
    'mdi-image-multiple-outline',
    'mdi-image-off',
    'mdi-image-off-outline',
    'mdi-image-outline',
    'mdi-image-plus',
    'mdi-image-remove',
    'mdi-image-search',
    'mdi-image-search-outline',
    'mdi-image-size-select-actual',
    'mdi-image-size-select-large',
    'mdi-image-size-select-small',
    'mdi-import',
    'mdi-inbox',
    'mdi-inbox-arrow-down',
    'mdi-inbox-arrow-down-outline',
    'mdi-inbox-arrow-up',
    'mdi-inbox-arrow-up-outline',
    'mdi-inbox-full',
    'mdi-inbox-full-outline',
    'mdi-inbox-multiple',
    'mdi-inbox-multiple-outline',
    'mdi-inbox-outline',
    'mdi-incognito',
    'mdi-incognito-circle',
    'mdi-incognito-circle-of',
    'mdi-incognito-off',
    'mdi-infinity',
    'mdi-information',
    'mdi-information-outline',
    'mdi-information-variant',
    'mdi-instagram',
    'mdi-instrument-triangle',
    'mdi-invert-colors',
    'mdi-invert-color-off',
    'mdi-iobroker',
    'mdi-ip',
    'mdi-ip-network',
    'mdi-ip-network-outline',
    'mdi-ipod',
    'mdi-islam',
    'mdi-island',
    'mdi-iv-bag',
    'mdi-jabber',
    'mdi-jeepney',
    'mdi-jellyfish',
    'mdi-jellyfish-outline',
    'mdi-jira',
    'mdi-jquery',
    'mdi-jsfiddle',
    'mdi-judaism',
    'mdi-jump-rope',
    'mdi-kabaddi',
    'mdi-karate',
    'mdi-keg',
    'mdi-kettle',
    'mdi-kettle-alert',
    'mdi-kettle-alert-outline',
    'mdi-kettle-off',
    'mdi-kettle-off outline',
    'mdi-kettle-outline',
    'mdi-kettle-steam',
    'mdi-kettle-steam-outline',
    'mdi-kettlebell',
    'mdi-key',
    'mdi-key-arrow-right',
    'mdi-key-change',
    'mdi-key-link',
    'mdi-key-minus',
    'mdi-key-outline',
    'mdi-key-plus',
    'mdi-key-remove',
    'mdi-key-star',
    'mdi-key-variant',
    'mdi-key-wireless',
    'mdi-keyboard',
    'mdi-keyboard-backspace',
    'mdi-keyboard-caps',
    'mdi-keyboard-close',
    'mdi-keyboard-es',
    'mdi-keyboard-f1',
    'mdi-keyboard-f10',
    'mdi-keyboard-f11',
    'mdi-keyboard-f12',
    'mdi-keyboard-f2',
    'mdi-keyboard-f3',
    'mdi-keyboard-f4',
    'mdi-keyboard-f5',
    'mdi-keyboard-f6',
    'mdi-keyboard-f7',
    'mdi-keyboard-f8',
    'mdi-keyboard-f9',
    'mdi-keyboard-off',
    'mdi-keyboard-off-outline',
    'mdi-keyboard-outline',
    'mdi-keyboard-return',
    'mdi-keyboard-settings',
    'mdi-keyboard-settings-outline',
    'mdi-keyboard-space',
    'mdi-keyboard-ta',
    'mdi-keyboard-variant',
    'mdi-khanda',
    'mdi-kickstarter',
    'mdi-klingon',
    'mdi-knife',
    'mdi-knife-military',
    'mdi-kod',
    'mdi-kubernetes',
    'mdi-label',
    'mdi-label-multiple',
    'mdi-label-multiple-outline',
    'mdi-label-off',
    'mdi-label-off-outline',
    'mdi-label-outline',
    'mdi-label-percent',
    'mdi-label-percent-outline',
    'mdi-label-variant',
    'mdi-label-variant-outline',
    'mdi-ladybug',
    'mdi-lambda',
    'mdi-lamp',
    'mdi-lan',
    'mdi-lan-check',
    'mdi-lan-connect',
    'mdi-lan-disconnect',
    'mdi-lan-pending',
    'mdi-language-c',
    'mdi-language-cpp',
    'mdi-language-csharp',
    'mdi-language-css3',
    'mdi-language-fortran',
    'mdi-language-go',
    'mdi-language-haskell',
    'mdi-language-html5',
    'mdi-language-java',
    'mdi-language-javascript',
    'mdi-language-kotlin',
    'mdi-language-lua',
    'mdi-language-markdown',
    'mdi-language-markdown-outline',
    'mdi-language-php',
    'mdi-language-python',
    'mdi-language-r',
    'mdi-language-ruby',
    'mdi-language-ruby-on-rails',
    'mdi-language-swift',
    'mdi-language-typescript',
    'mdi-language-xaml',
    'mdi-laptop',
    'mdi-laptop-chromebook',
    'mdi-laptop-mac',
    'mdi-laptop-off',
    'mdi-laptop-windows',
    'mdi-laravel',
    'mdi-laser-pointer',
    'mdi-lasso',
    'mdi-lastpass',
    'mdi-latitude',
    'mdi-launch',
    'mdi-lava-lamp',
    'mdi-layers',
    'mdi-layers-minus',
    'mdi-layers-off',
    'mdi-layers-off-outline',
    'mdi-layers-outline',
    'mdi-layer-plus',
    'mdi-layers-remove',
    'mdi-layers-search',
    'mdi-layers-search-outline',
    'mdi-layers-triple',
    'mdi-layers-triple-outline',
    'mdi-lead-pencil',
    'mdi-leaf',
    'mdi-leaf-maple',
    'mdi-leaf-maple-off',
    'mdi-leaf-off',
    'mdi-leak',
    'mdi-leak-off',
    'mdi-led-off',
    'mdi-led-on',
    'mdi-led outline',
    'mdi-led-strip',
    'mdi-led-strip-variant',
    'mdi-led-variant-off',
    'mdi-led-variant-on',
    'mdi-led-variant-outline',
    'mdi-leek',
    'mdi-less-than',
    'mdi-less-than-or-equal',
    'mdi-library',
    'mdi-library-shelves',
    'mdi-license',
    'mdi-lifebuoy',
    'mdi-light-switch',
    'mdi-lightbulb',
    'mdi-lightbulb-cfl',
    'mdi-lightbulb-cfl-off',
    'mdi-lightbulb-cfl-spiral',
    'mdi-lightbulb-cfl-spiral-off',
    'mdi-lightbulb-group',
    'mdi-lightbulb-group-off',
    'mdi-lightbulb-group-off-outline',
    'mdi-lightbulb-group-outline',
    'mdi-lightbulb-multiple',
    'mdi-lightbulb-multiple-off',
    'mdi-lightbulb-multiple-off-outline',
    'mdi-lightbulb-multiple-outline',
    'mdi-lightbulb-off',
    'mdi-lightbulb-off-outline',
    'mdi-lightbulb-on',
    'mdi-lightbulb-on-outline',
    'mdi-lightbulb-outline',
    'mdi-lighthouse',
    'mdi-lighthouse-on',
    'mdi-lightning-bolt',
    'mdi-lightning-bolt-outline',
    'mdi-lingerie',
    'mdi-link',
    'mdi-link-box',
    'mdi-link-box-outline',
    'mdi-link-box-variant',
    'mdi-link-box-variant-outline',
    'mdi-link-lock',
    'mdi-link-off',
    'mdi-link-plus',
    'mdi-link-variant',
    'mdi-link-variant-minus',
    'mdi-link-variant-off',
    'mdi-link-variant-plus',
    'mdi-link-variant-remove',
    'mdi-linkedin',
    'mdi-linux',
    'mdi-linux-mint',
    'mdi-lipstick',
    'mdi-litecoin',
    'mdi-loading',
    'mdi-location-enter',
    'mdi-location-exit',
    'mdi-lock',
    'mdi-lock-alert',
    'mdi-lock-check',
    'mdi-lock-clock',
    'mdi-lock-open',
    'mdi-lock-open-alert',
    'mdi-lock-open-check',
    'mdi-lock-open-outline',
    'mdi-lock-open-variant',
    'mdi-lock-open-variant-outline',
    'mdi-lock-outline',
    'mdi-lock-pattern',
    'mdi-lock-plus',
    'mdi-lock-question',
    'mdi-lock-reset',
    'mdi-lock-smart',
    'mdi-locker',
    'mdi-locker-multiple',
    'mdi-login',
    'mdi-login-variant',
    'mdi-logout',
    'mdi-logout-variant',
    'mdi-longitude',
    'mdi-looks',
    'mdi-loupe',
    'mdi-lumx',
    'mdi-lungs',
    'mdi-magnet',
    'mdi-magnet-on',
    'mdi-magnify',
    'mdi-magnify-close',
    'mdi-magnify-minus',
    'mdi-magnify-minus-cursor',
    'mdi-magnify-minus-outline',
    'mdi-magnify-plus',
    'mdi-magnify-plus-cursor',
    'mdi-magnify-plus-outline',
    'mdi-magnify-remove-cursor',
    'mdi-magnify-remove-outline',
    'mdi-magnify-scan',
    'mdi-mail',
    'mdi-mailbox',
    'mdi-mailbox-open',
    'mdi-mailbox-open-outline',
    'mdi-mailbox-open-up',
    'mdi-mailbox-open-up-outline',
    'mdi-mailbox-outline',
    'mdi-mailbox-up',
    'mdi-mailbox-up-outline',
    'mdi-map',
    'mdi-map-check',
    'mdi-map-check-outline',
    'mdi-map-clock',
    'mdi-map-clock-outline',
    'mdi-map-legend',
    'mdi-map-marker',
    'mdi-map-marker-alert',
    'mdi-map-marker-alert-outline',
    'mdi-map-marker-check',
    'mdi-map-marker-check-outline',
    'mdi-map-marker-circle',
    'mdi-map-marker-distance',
    'mdi-map-marker-down',
    'mdi-map-marker-left',
    'mdi-map-marker-left-outline',
    'mdi-map-marker-minus',
    'mdi-map-marker-minus-outline',
    'mdi-map-marker-multiple',
    'mdi-map-marker-multiple-outline',
    'mdi-map-marker-off',
    'mdi-map-marker-off-outline',
    'mdi-map-marker-outline',
    'mdi-map-marker-path',
    'mdi-map-marker-plus',
    'mdi-map-marker-plus-outline',
    'mdi-map-marker-question',
    'mdi-map-marker-question-outline',
    'mdi-map-marker-radius',
    'mdi-map-marker-radius-outline',
    'mdi-map-marker-remove',
    'mdi-map-marker-remove-outline',
    'mdi-map-marker-remove-variant',
    'mdi-map-marker-right',
    'mdi-map-marker-right-outline',
    'mdi-map-marker-up',
    'mdi-map-minus',
    'mdi-map-outline',
    'mdi-map-plus',
    'mdi-map-search',
    'mdi-map-search-outline',
    'mdi-mapbox',
    'mdi-margin',
    'mdi-marker',
    'mdi-marker-cancel',
    'mdi-marker-check',
    'mdi-mastodon',
    'mdi-material-design',
    'mdi-material-ui',
    'mdi-math-compass',
    'mdi-math-cos',
    'mdi-math-integral',
    'mdi-math-integral-box',
    'mdi-math-log',
    'mdi-math-norm',
    'mdi-math-norm-box',
    'mdi-math-sin',
    'mdi-math-tan',
    'mdi-matrix',
    'mdi-medal',
    'mdi-medal-outline',
    'mdi-medical-bag',
    'mdi-meditation',
    'mdi-memory',
    'mdi-menu',
    'mdi-menu-down',
    'mdi-menu-down-outline',
    'mdi-menu-left',
    'mdi-menu-left-outline',
    'mdi-menu-open',
    'mdi-menu-right',
    'mdi-menu-right-outline',
    'mdi-menu-swap',
    'mdi-menu-swap-outline',
    'mdi-menu-up',
    'mdi-menu-up-outline',
    'mdi-merge',
    'mdi-message',
    'mdi-message-alert',
    'mdi-message-alert-outline',
    'mdi-message-arrow-left',
    'mdi-message-arrow-left-outline',
    'mdi-message-arrow-right',
    'mdi-message-arrow-right-outline',
    'mdi-message-bulleted',
    'mdi-message-bulleted-off',
    'mdi-message-cog',
    'mdi-message-cog-outline',
    'mdi-message-draw',
    'mdi-message-image',
    'mdi-message-image-outline',
    'mdi-message-lock',
    'mdi-message-lock-outline',
    'mdi-message-minus',
    'mdi-message-minus-outline',
    'mdi-message-outline',
    'mdi-message-plus',
    'mdi-message-plus-outline',
    'mdi-message-processing',
    'mdi-message processing-outline',
    'mdi-message-reply',
    'mdi-message-reply-tex',
    'mdi-message-settings',
    'mdi-message-settings-outline',
    'mdi-message-text',
    'mdi-message-text-clock',
    'mdi-message-text-clock-outline',
    'mdi-message-text-loc',
    'mdi-message-text-lock-outline',
    'mdi-message-text-outline',
    'mdi-message-video',
    'mdi-meteor',
    'mdi-metronome',
    'mdi-metronome-tick',
    'mdi-micro sd',
    'mdi-microphone',
    'mdi-microphone-minus',
    'mdi-microphone-off',
    'mdi-microphone-outline',
    'mdi-microphone-plus',
    'mdi-microphone-settings',
    'mdi-microphone-variant',
    'mdi-microphone-variant-off',
    'mdi-microscope',
    'mdi-microsoft',
    'mdi-microsoft-access',
    'mdi-microsoft-azure',
    'mdi-microsoft-azure-devops',
    'mdi-microsoft-bing',
    'mdi-microsoft-dynamics-365',
    'mdi-microsoft-edge',
    'mdi-microsoft-edge-legacy',
    'mdi-microsoft-excel',
    'mdi-microsoft-internet-explorer',
    'mdi-microsoft-office',
    'mdi-microsoft-onedrive',
    'mdi-microsoft-onenote',
    'mdi-microsoft-outlook',
    'mdi-microsoft-powerpoint',
    'mdi-microsoft-sharepoint',
    'mdi-microsoft-teams',
    'mdi-microsoft-visual-studio',
    'mdi-microsoft-visual-studio-code',
    'mdi-microsoft-windows',
    'mdi-microsoft-windows classic',
    'mdi-microsoft-word',
    'mdi-microsoft-xbox',
    'mdi-microsoft-xbox-controller',
    'mdi-microsoft-xbox-controller-battery-alert',
    'mdi-microsoft-xbox controller-battery-charging',
    'mdi-microsoft-xbo-controller-battery-empty',
    'mdi-microsoft-xbox-controller-battery-full',
    'mdi-microsoft-xbox-controller-battery-low',
    'mdi-microsoft-xbox-controller-battery-medium',
    'mdi-microsoft-xbox-controller-battery-unknown',
    'mdi-microsoft-xbox-controller-menu',
    'mdi-microsoft-xbox-controller-off',
    'mdi-microsoft-xbox-controller-view',
    'mdi-microsoft-yammer',
    'mdi-microwave',
    'mdi-microwave-off',
    'mdi-middleware',
    'mdi-middleware-outline',
    'mdi-midi',
    'mdi-midi-port',
    'mdi-mine',
    'mdi-minecraft',
    'mdi-mini-sd',
    'mdi-minidisc',
    'mdi-minus',
    'mdi-minus-box',
    'mdi-minus-box-multiple',
    'mdi-minus-box-multiple-outline',
    'mdi-minus-box-outline',
    'mdi-minus-circle',
    'mdi-minus-circle-multiple',
    'mdi-minus-circle-multipl-outline',
    'mdi-minus-circle-off',
    'mdi-minus-circle-off-outline',
    'mdi-minus-circle-outline',
    'mdi-minus-network',
    'mdi-minus-network-outline',
    'mdi-mirror',
    'mdi-mixed-martial-arts',
    'mdi-mixed-reality',
    'mdi-mixer',
    'mdi-molecule',
    'mdi-molecule-co',
    'mdi-molecule-co2',
    'mdi-monitor',
    'mdi-monitor-cellphone',
    'mdi-monitor-cellphone-star',
    'mdi-monitor-clean',
    'mdi-monitor-dashboard',
    'mdi-monitor-edit',
    'mdi-monitor-eye',
    'mdi-monitor-lock',
    'mdi-monitor-multiple',
    'mdi-monitor-off',
    'mdi-monitor-screenshot',
    'mdi-monitor-share',
    'mdi-monitor-speaker',
    'mdi-monitor-speaker-off',
    'mdi-monitor-star',
    'mdi-moon-first-quarter',
    'mdi-moon-full',
    'mdi-moon-last-quarter',
    'mdi-moon-new',
    'mdi-moon-waning-crescent',
    'mdi-moon-waning-gibbous',
    'mdi-moon-waxing-crescent',
    'mdi-moon-waxing-gibbous',
    'mdi-moped',
    'mdi-more',
    'mdi-mother-heart',
    'mdi-mother-nurse',
    'mdi-motion-sensor',
    'mdi-motion-sensor-off',
    'mdi-motorbike',
    'mdi-mouse',
    'mdi-mouse-bluetooth',
    'mdi-mouse-off',
    'mdi-mouse-variant',
    'mdi-mouse-variant-off',
    'mdi-move-resize',
    'mdi-move-resize-variant',
    'mdi-movie',
    'mdi-movie-edit',
    'mdi-movie-edit-outline',
    'mdi-movie-filter',
    'mdi-movie-filter-outline',
    'mdi-movie-open',
    'mdi-movie-open-outline',
    'mdi-movie-outline',
    'mdi-movie-roll',
    'mdi-movie-search',
    'mdi-movie-search-outline',
    'mdi-muffin',
    'mdi-multiplication',
    'mdi-multiplication-box',
    'mdi-mushroom',
    'mdi-mushroom-off',
    'mdi-mushroom-off-outline',
    'mdi-mushroom-outline',
    'mdi-music',
    'mdi-music-accidental-double-flat',
    'mdi-music-accidental-double-sharp',
    'mdi-music-accidental-flat',
    'mdi-music-accidental-natural',
    'mdi-music-accidental-sharp',
    'mdi-music-box',
    'mdi-music-box-multiple',
    'mdi-music-box-multiple-outline',
    'mdi-music-box-outline',
    'mdi-music-circle',
    'mdi-music-circle-outline',
    'mdi-music-clef-alto',
    'mdi-music-clef-bass',
    'mdi-music-clef-treble',
    'mdi-music-note',
    'mdi-music-note-bluetooth',
    'mdi-musi-note-bluetooth-off',
    'mdi-music-note-eighth',
    'mdi-music-note-eighth-dotted',
    'mdi-music-note-half',
    'mdi-music-note-half-dotted',
    'mdi-music-note-off',
    'mdi-music-note-off-outline',
    'mdi-music-note-outline',
    'mdi-music-note-plus',
    'mdi-music-note-quarter',
    'mdi-music-note-quarter-dotted',
    'mdi-musi-note-sixteenth',
    'mdi-music-note-sixteenth-dotted',
    'mdi-music-note-whole',
    'mdi-music-note-whole-dotted',
    'mdi-music-off',
    'mdi-music-rest-eighth',
    'mdi-music-rest-half',
    'mdi-music rest-quarter',
    'mdi-music-rest-sixteenth',
    'mdi-music-rest-whole',
    'mdi-nail',
    'mdi-nas',
    'mdi-nativescript',
    'mdi-nature',
    'mdi-nature-people',
    'mdi-navigation',
    'mdi-near-me',
    'mdi-necklace',
    'mdi-needle',
    'mdi-netflix',
    'mdi-network',
    'mdi-network-off',
    'mdi-network-off-outline',
    'mdi-network-outline',
    'mdi-network-strength-1',
    'mdi-network-strength-1-alert',
    'mdi-network-strength-2',
    'mdi-network-strength-2-alert',
    'mdi-network-strength-3',
    'mdi-network-strength-3-alert',
    'mdi-network-strength-4',
    'mdi-network-strength-4-alert',
    'mdi-network-strength-off',
    'mdi-network-strength-off-outline',
    'mdi-network-strength-outline',
    'mdi-new-box',
    'mdi-newspaper',
    'mdi-newspaper-minus',
    'mdi-newspaper-plus',
    'mdi-newspaper-variant',
    'mdi-newspaper-variant-multiple',
    'mdi-newspaper-variant-multiple-outline',
    'mdi-newspaper-variant-outline',
    'mdi-nfc',
    'mdi-nfc-search-variant',
    'mdi-nfc-tap',
    'mdi-nfc-variant',
    'mdi-nfc-variant-off',
    'mdi-ninja',
    'mdi-nintendo-game-boy',
    'mdi-nintendo-switch',
    'mdi-nintendo-wii',
    'mdi-nintendo-wiiu',
    'mdi-nix',
    'mdi-nodejs',
    'mdi-noodles',
    'mdi-not-equal',
    'mdi-not-equal-variant',
    'mdi-note',
    'mdi-note-multiple',
    'mdi-note-multiple-outline',
    'mdi-note-outline',
    'mdi-note-plus',
    'mdi-note-plus-outlin',
    'mdi-note-text',
    'mdi-note-text-outline',
    'mdi-notebook',
    'mdi-notebook-multiple',
    'mdi-notebook-outline',
    'mdi-notification-clear-all',
    'mdi-npm',
    'mdi-nuke',
    'mdi-null',
    'mdi-numeric',
    'mdi-numeric-0',
    'mdi-numeric-0-box',
    'mdi-numeric-0-box-multiple',
    'mdi-numeric-0-box-multiple-outline',
    'mdi-numeric-0-box-outline',
    'mdi-numeric-0-circle',
    'mdi-numeric-0-circle-outline',
    'mdi-numeric-1',
    'mdi-numeric-1-box',
    'mdi-numeric-1-box-multiple',
    'mdi-numeric-1-box-multiple-outline',
    'mdi-numeric-1-box-outline',
    'mdi-numeric-1-circle',
    'mdi-numeric-1-circle-outline',
    'mdi-numeric-10',
    'mdi-numeric-10-box',
    'mdi-numeric-10-box-multiple',
    'mdi-numeric-10-box-multiple-outline',
    'mdi-numeric-10-box-outline',
    'mdi-numeric-10-circle',
    'mdi-numeric-10-circle-outline',
    'mdi-numeric-2',
    'mdi-numeric-2-box',
    'mdi-numeric-2-box-multiple',
    'mdi-numeric-2-box-multiple-outline',
    'mdi-numeric-2-box-outline',
    'mdi-numeric-2-circle',
    'mdi-numeric-2-circle-outline',
    'mdi-numeric-3',
    'mdi-numeric-3-box',
    'mdi-numeric-3-box-multiple',
    'mdi-numeric-3-box-multiple-outline',
    'mdi-numeric-3-box-outline',
    'mdi-numeric-3-circle',
    'mdi-numeric-3-circle-outline',
    'mdi-numeric-4',
    'mdi-numeric-4-box',
    'mdi-numeric-4-box-multiple',
    'mdi-numeric-4-box-multiple-outline',
    'mdi-numeric-4-box-outline',
    'mdi-numeric-4-circle',
    'mdi-numeric-4-circle-outline',
    'mdi-numeric-5',
    'mdi-numeric-5-box',
    'mdi-numeric-5-box-multiple',
    'mdi-numeric-5-box-multiple-outline',
    'mdi-numeric-5-box-outline',
    'mdi-numeric-5-circle',
    'mdi-numeric-5-circle-outline',
    'mdi-numeric-6',
    'mdi-numeric-6-box',
    'mdi-numeric-6-box-multiple',
    'mdi-numeric-6-box-multiple-outline',
    'mdi-numeric-6-box-outline',
    'mdi-numeric-6-circle',
    'mdi-numeric-6-circle-outline',
    'mdi-numeric-7',
    'mdi-numeric-7-box',
    'mdi-numeric-7-box-multiple',
    'mdi-numeric-7-box-multiple-outline',
    'mdi-numeric-7-box-outline',
    'mdi-numeric-7-circle',
    'mdi-numeric-7-circle-outline',
    'mdi-numeric-8',
    'mdi-numeric-8-box',
    'mdi-numeric-8-box-multiple',
    'mdi-numeric-8-box-multiple-outline',
    'mdi-numeric-8-box-outline',
    'mdi-numeric-8-circle',
    'mdi-numeric-8-circle-outline',
    'mdi-numeric-9',
    'mdi-numeric-9-box',
    'mdi-numeric-9-box-multiple',
    'mdi-numeric-9-box-multiple-outline',
    'mdi-numeric-9-box-outline',
    'mdi-numeric-9-circle',
    'mdi-numeric-9-circle-outline',
    'mdi-numeric-9-plus',
    'mdi-numeric-9-plus-box',
    'mdi-numeric-9-plus-box-multiple',
    'mdi-numeric-9-plus-box-multiple-outline',
    'mdi-numeric-9-plus-box-outline',
    'mdi-numeric-9-plus-circle',
    'mdi-numeric-9-plus-circle-outline',
    'mdi-numeric-negative-1',
    'mdi-nut',
    'mdi-nutrition',
    'mdi-nuxt',
    'mdi-oar',
    'mdi-ocarina',
    'mdi-oci',
    'mdi-ocr',
    'mdi-octagon',
    'mdi-octagon-outline',
    'mdi-octagram',
    'mdi-octagram-outline',
    'mdi-odnoklassniki',
    'mdi-offer',
    'mdi-office-building',
    'mdi-oil',
    'mdi-oil-lamp',
    'mdi-oil-level',
    'mdi-oil-temperature',
    'mdi-omega',
    'mdi-one-up',
    'mdi-onepassword',
    'mdi-opacity',
    'mdi-open-in-app',
    'mdi-open-in-new',
    'mdi-open-source-initiative',
    'mdi-openid',
    'mdi-opera',
    'mdi-orbit',
    'mdi-order-alphabetical-ascending',
    'mdi-order-alphabetical-descending',
    'mdi-order-bool-ascending',
    'mdi-order-bool-ascending-variant',
    'mdi-order-bool-descending',
    'mdi-order-bool-descending-varian',
    'mdi-order-numeric-ascending',
    'mdi-order-numeric-descending',
    'mdi-origin',
    'mdi-ornament',
    'mdi-ornament-variant',
    'mdi-outdoor-lamp',
    'mdi-overscan',
    'mdi-owl',
    'mdi-pac-man',
    'mdi-package',
    'mdi-package-down',
    'mdi-package-up',
    'mdi-package-variant',
    'mdi-package-variant-closed',
    'mdi-page-first',
    'mdi-page-last',
    'mdi-page-layout-body',
    'mdi-page-layout-footer',
    'mdi-page-layout-header',
    'mdi-page-layout-header-footer',
    'mdi-page-layout-sidebar-left',
    'mdi-page-layout-sidebar-right',
    'mdi-page-next',
    'mdi-page-next-outline',
    'mdi-page-previous',
    'mdi-page-previous-outline',
    'mdi-pail',
    'mdi-pail-minus',
    'mdi-pail-minus-outline',
    'mdi-pail-off',
    'mdi-pail-off-outline',
    'mdi-pail-outline',
    'mdi-pail-plus',
    'mdi-pail-plus-outline',
    'mdi-pail-remove',
    'mdi-pail-remove-outline',
    'mdi-palette',
    'mdi-palette-advanced',
    'mdi-palette-outline',
    'mdi-palette-swatch',
    'mdi-palette-swatch-outline',
    'mdi-palm-tree',
    'mdi-pan',
    'mdi-pan-bottom-left',
    'mdi-pan-bottom-right',
    'mdi-pan-down',
    'mdi-pan-horizontal',
    'mdi-pan-left',
    'mdi-pan-right',
    'mdi-pan-top-left',
    'mdi-pan-top-right',
    'mdi-pan-up',
    'mdi-pan-vertical',
    'mdi-panda',
    'mdi-pandora',
    'mdi-panorama',
    'mdi-panorama-fisheye',
    'mdi-panorama-horizontal',
    'mdi-panorama-vertical',
    'mdi-panorama-wide-angle',
    'mdi-paper-cut-vertical',
    'mdi-paper-roll',
    'mdi-paper-roll-outline',
    'mdi-paperclip',
    'mdi-parachute',
    'mdi-parachute-outline',
    'mdi-parking',
    'mdi-party-popper',
    'mdi-passport',
    'mdi-passport-biometric',
    'mdi-pasta',
    'mdi-patio-heater',
    'mdi-patreon',
    'mdi-pause',
    'mdi-pause-circle',
    'mdi-pause-circle-outline',
    'mdi-pause-octagon',
    'mdi-pause-octagon-outline',
    'mdi-paw',
    'mdi-paw-off',
    'mdi-pdf-box',
    'mdi-peace',
    'mdi-peanut',
    'mdi-peanut-off',
    'mdi-peanut-off-outline',
    'mdi-peanut-outline',
    'mdi-pen',
    'mdi-pen lock',
    'mdi-pen-minus',
    'mdi-pen-off',
    'mdi-pen-plus',
    'mdi-pen-remove',
    'mdi-pencil',
    'mdi-pencil-box',
    'mdi-pencil-box-multiple',
    'mdi-pencil-box-multiple-outline',
    'mdi-pencil-box-outline',
    'mdi-pencil-circle',
    'mdi-pencil-circle-outline',
    'mdi-pencil-lock',
    'mdi-pencil-lock-outline',
    'mdi-pencil-minus',
    'mdi-pencil-minus-outline',
    'mdi-pencil-off',
    'mdi-pencil-off-outline',
    'mdi-pencil-outline',
    'mdi-pencil-plus',
    'mdi-pencil-plus-outline',
    'mdi-pencil-remove',
    'mdi-pencil-remove-outline',
    'mdi-pencil-ruler',
    'mdi-penguin',
    'mdi-pentagon',
    'mdi-pentagon-outline',
    'mdi-percent',
    'mdi-percent-outline',
    'mdi-periodic-table',
    'mdi-perspective-less',
    'mdi-perspective-more',
    'mdi-pharmacy',
    'mdi-phone',
    'mdi-phone-alert',
    'mdi-phone-alert-outline',
    'mdi-phone-bluetooth',
    'mdi-phone-bluetooth-outline',
    'mdi-phone-cancel',
    'mdi-phone-cancel-outline',
    'mdi-phone-check',
    'mdi-phone-check-outline',
    'mdi-phone-classic',
    'mdi-phone-classic-off',
    'mdi-phone-forward',
    'mdi-phone-forward-outline',
    'mdi-phone-hangup',
    'mdi-phone-hangup-outline',
    'mdi-phone-in-talk',
    'mdi-phone-in-talk-outline',
    'mdi-phone-incoming',
    'mdi-phone-incoming-outline',
    'mdi-phone-lock',
    'mdi-phone-lock-outline',
    'mdi-phone-log',
    'mdi-phone-log-outline',
    'mdi-phone-message',
    'mdi-phone-message-outline',
    'mdi-phone-minus',
    'mdi-phone-minus-outline',
    'mdi-phone-missed',
    'mdi-phone-missed-outline',
    'mdi-phone-off',
    'mdi-phone-off-outline',
    'mdi-phone-outgoing',
    'mdi-phone-outgoing-outline',
    'mdi-phone-outline',
    'mdi-phone-paused',
    'mdi-phone-paused-outline',
    'mdi-phone-plus',
    'mdi-phone-plus-outline',
    'mdi-phone-return',
    'mdi-phone-return-outline',
    'mdi-phone-ring',
    'mdi-phone-ring-outline',
    'mdi-phone-rotate-landscape',
    'mdi-phone-rotate-portrait',
    'mdi-phone-settings',
    'mdi-phone settings-outline',
    'mdi-phone-voip',
    'mdi-pi',
    'mdi-pi-box',
    'mdi-pi-hole',
    'mdi-piano',
    'mdi-pickaxe',
    'mdi-picture-in-picture-bottom-right',
    'mdi-picture-in-picture-bottom-right-outline',
    'mdi-picture-in-picture-top-right',
    'mdi-picture-in-picture-top-right-outline',
    'mdi-pier',
    'mdi-pier-crane',
    'mdi-pig',
    'mdi-pig-variant',
    'mdi-piggy-bank',
    'mdi-pill',
    'mdi-pillar',
    'mdi-pin',
    'mdi-pin-off',
    'mdi-pin-off-outline',
    'mdi-pin-outline',
    'mdi-pine-tree',
    'mdi-pine-tree-box',
    'mdi-pine-tree-fire',
    'mdi-pinterest',
    'mdi-pinwheel',
    'mdi-pinwheel-outline',
    'mdi-pipe',
    'mdi-pipe-disconnected',
    'mdi-pipe-leak',
    'mdi-pipe-wrench',
    'mdi-pirate',
    'mdi-pistol',
    'mdi-piston',
    'mdi-pizza',
    'mdi-play',
    'mdi-play-box',
    'mdi-play-box-multiple',
    'mdi-play-box-multiple-outline',
    'mdi-play-box-outline',
    'mdi-play-circle',
    'mdi-play-circle-outline',
    'mdi-play-network',
    'mdi-play-network-outline',
    'mdi-play-outline',
    'mdi-play-pause',
    'mdi-play-protected-content',
    'mdi-play-speed',
    'mdi-playlist-check',
    'mdi-playlist-edit',
    'mdi-playlist-minus',
    'mdi-playlist-music',
    'mdi-playlist-music-outline',
    'mdi-playlist-play',
    'mdi-playlist-plus',
    'mdi-playlist-remove',
    'mdi-playlist-star',
    'mdi-plex',
    'mdi-plus',
    'mdi-plus-box',
    'mdi-plus-box-multiple',
    'mdi-plus-box-multiple-outline',
    'mdi-plus-box-outline',
    'mdi-plus-circle',
    'mdi-plus-circle-multiple',
    'mdi-plus-circle-multiple-outline',
    'mdi-plus-circle-outline',
    'mdi-plus-minus',
    'mdi-plus-minus-box',
    'mdi-plus-minus-variant',
    'mdi-plus-network',
    'mdi-plus-network-outline',
    'mdi-plus-one',
    'mdi-plus-outline',
    'mdi-plus-thick',
    'mdi-podcast',
    'mdi-podium',
    'mdi-podium-bronze',
    'mdi-podium-gold',
    'mdi-podium-silver',
    'mdi-point-of-sale',
    'mdi-pokeball',
    'mdi-pokemon-go',
    'mdi-poker-chip',
    'mdi-polaroid',
    'mdi-police-badge',
    'mdi-police-badge-outline',
    'mdi-poll',
    'mdi-poll-box',
    'mdi-poll-box-outline',
    'mdi-polo',
    'mdi-polymer',
    'mdi-pool',
    'mdi-popcorn',
    'mdi-post',
    'mdi-post-outline',
    'mdi-postage-stamp',
    'mdi-pot',
    'mdi-pot-mix',
    'mdi-pot-mix-outline',
    'mdi-pot-outline',
    'mdi-pot-steam',
    'mdi-pot-steam-outline',
    'mdi-pound',
    'mdi-pound-box',
    'mdi-pound-box-outline',
    'mdi-power',
    'mdi-power-cycle',
    'mdi-power-off',
    'mdi-power-on',
    'mdi-power-plug',
    'mdi-power-plug-off',
    'mdi-power-plug-off-outline',
    'mdi-power-plug-outline',
    'mdi-power-settings',
    'mdi-power-sleep',
    'mdi-power-socke',
    'mdi-power-socket-au',
    'mdi-power-socket-de',
    'mdi-power-socket-eu',
    'mdi-power-socket-fr',
    'mdi-power-socket-jp',
    'mdi-power-socket-uk',
    'mdi-power-socket-us',
    'mdi-power-standby',
    'mdi-powershell',
    'mdi-prescription',
    'mdi-presentation',
    'mdi-presentation-play',
    'mdi-printer',
    'mdi-printer-3d',
    'mdi-printer-3d-nozzle',
    'mdi-printer-3d-nozzle-alert',
    'mdi-printer-3d-nozzle-alert-outline',
    'mdi-printer-3d-nozzle-outline',
    'mdi-printer-alert',
    'mdi-printer-check',
    'mdi-printer-eye',
    'mdi-printer-off',
    'mdi-printer-pos',
    'mdi-printer-search',
    'mdi-printer-settings',
    'mdi-printer-wireless',
    'mdi-priority-high',
    'mdi-priority-low',
    'mdi-professional-hexagon',
    'mdi-progress-alert',
    'mdi-progress-check',
    'mdi-progress-clock',
    'mdi-progress-close',
    'mdi-progress-download',
    'mdi-progress-upload',
    'mdi-progress-wrench',
    'mdi-projector',
    'mdi-projector-screen',
    'mdi-propane-tank',
    'mdi-propane-tank-outline',
    'mdi-protocol',
    'mdi-publish',
    'mdi-puls',
    'mdi-pump',
    'mdi-pumpkin',
    'mdi-purse',
    'mdi-purse-outline',
    'mdi-puzzle',
    'mdi-puzzle-check',
    'mdi-puzzle-check-outline',
    'mdi-puzzle-edit',
    'mdi-puzzle-edit-outline',
    'mdi-puzzle-heart',
    'mdi-puzzle-heart-outline',
    'mdi-puzzle-minus',
    'mdi-puzzle-minus-outline',
    'mdi-puzzle-outline',
    'mdi-puzzle-plus',
    'mdi-puzzle-plus-outline',
    'mdi-puzzle-remove',
    'mdi-puzzle-remove-outline',
    'mdi-puzzle-star',
    'mdi-puzzle-star-outline',
    'mdi-qi',
    'mdi-qqchat',
    'mdi-qrcode',
    'mdi-qrcode-edit',
    'mdi-qrcode-minus',
    'mdi-qrcode-plus',
    'mdi-qrcode-remove',
    'mdi-qrcode-scan',
    'mdi-quadcopter',
    'mdi-quality-high',
    'mdi-quality-low',
    'mdi-quality-medium',
    'mdi-quora',
    'mdi-rabbit',
    'mdi-racing-helmet',
    'mdi-racquetball',
    'mdi-radar',
    'mdi-radiator',
    'mdi-radiator-disabled',
    'mdi-radiator-off',
    'mdi-radio',
    'mdi-radio-am',
    'mdi-radio-fm',
    'mdi-radio-handheld',
    'mdi-radio-off',
    'mdi-radio-tower',
    'mdi-radioactive',
    'mdi-radioactive-off',
    'mdi-radiobox-blank',
    'mdi-radiobox-marked',
    'mdi-radiology-box',
    'mdi-radiology-box-outline',
    'mdi-radius',
    'mdi-radius-outline',
    'mdi-railroad-light',
    'mdi-raspberry-pi',
    'mdi-ray-end',
    'mdi-ray-end-arrow',
    'mdi-ray-start',
    'mdi-ray-start-arrow',
    'mdi-ray-start-end',
    'mdi-ray-vertex',
    'mdi-react',
    'mdi-read',
    'mdi-receipt',
    'mdi-record',
    'mdi-record-circle',
    'mdi-record-circle-outline',
    'mdi-record-player',
    'mdi-record-rec',
    'mdi-rectangle',
    'mdi-rectangle-outline',
    'mdi-recycle',
    'mdi-recycle-variant',
    'mdi-reddit',
    'mdi-redhat',
    'mdi-redo',
    'mdi-redo-variant',
    'mdi-reflect-horizontal',
    'mdi-reflect-vertical',
    'mdi-refresh',
    'mdi-refresh-circle',
    'mdi-regex',
    'mdi-registered-trademark',
    'mdi-relation-many-to-many',
    'mdi-relation-many-to-one',
    'mdi-relation-many-to-one-or-many',
    'mdi-relation-many-t-only-one',
    'mdi-relation-many-to-zero-or-many',
    'mdi-relation-many-to-zero-or-one',
    'mdi-relation-one-or-many-to-many',
    'mdi-relation-one-or-many-to-one',
    'mdi-relation-one-or-many-to-one-or-many',
    'mdi-relation-one-or-many-to-only-one',
    'mdi-relation-one-or-many-to-zero-or-many',
    'mdi-relation-one-or-many-to-zero-or-one',
    'mdi-relation-one-to-many',
    'mdi-relation-one-to-one',
    'mdi-relation-one-to-one-or-many',
    'mdi-relation-one-to-only-one',
    'mdi-relation-one-to-zero-or-many',
    'mdi-relation-one-to-zero-or-one',
    'mdi-relation-only-one-to-many',
    'mdi-relation-only-one-to-one',
    'mdi-relation-only-one-to-one-or-many',
    'mdi-relation-only-one-to-only-one',
    'mdi-relation-only-one to-zero-or-many',
    'mdi-relation-only-one-to-zero-or-one',
    'mdi-relation-zero-or-many-to-many',
    'mdi-relation-zero-or-many-to-one',
    'mdi-relation-zero-or-many-to-one-or-many',
    'mdi-relation-zero-or-many-to-only-one',
    'mdi-relation-zero-or-many-to-zero-or-many',
    'mdi-relation-zero-or-many-to-zero-or-one',
    'mdi-relation-zero-or-one-to-many',
    'mdi-relation-zero-or-one-to-one',
    'mdi-relation-zero-or-one-to-one-or-many',
    'mdi-relation-zero-or-one-to-only-one',
    'mdi-relation-zero-or-one-to-zero-or-many',
    'mdi-relation-zero-or-one-to-zero-or-one',
    'mdi-relative-scale',
    'mdi-reload',
    'mdi-reload-alert',
    'mdi-reminder',
    'mdi-remote',
    'mdi-remote-desktop',
    'mdi-remote-off',
    'mdi-remote-tv',
    'mdi-remote-tv-off',
    'mdi-rename-box',
    'mdi-reorder-horizontal',
    'mdi-reorder-vertical',
    'mdi-repeat',
    'mdi-repeat-off',
    'mdi-repeat-once',
    'mdi-replay',
    'mdi-reply',
    'mdi-reply-all',
    'mdi-reply-all-outline',
    'mdi-reply-circle',
    'mdi-reply-outline',
    'mdi-reproduction',
    'mdi-resistor',
    'mdi-resistor-nodes',
    'mdi-resize',
    'mdi-resize-bottom-right',
    'mdi-responsive',
    'mdi-restart',
    'mdi-restart-alert',
    'mdi-restart-off',
    'mdi-restore',
    'mdi-restore-alert',
    'mdi-rewind',
    'mdi-rewind-10',
    'mdi-rewind-30',
    'mdi-rewind-5',
    'mdi-rewin-outline',
    'mdi-rhombus',
    'mdi-rhombus-medium',
    'mdi-rhombus-medium-outline',
    'mdi-rhombus-outline',
    'mdi-rhombus-split',
    'mdi-rhombus-split-outline',
    'mdi-ribbon',
    'mdi-rice',
    'mdi-ring',
    'mdi-rivet',
    'mdi-road',
    'mdi-road-variant',
    'mdi-robber',
    'mdi-robot',
    'mdi-robot-industrial',
    'mdi-robot-mower',
    'mdi-robot-mower-outline',
    'mdi-robot-vacuum',
    'mdi-robot-vacuum-variant',
    'mdi-rocket',
    'mdi-rocket-launch',
    'mdi-rocket-launch-outline',
    'mdi-rocket-outline',
    'mdi-rodent',
    'mdi-roller-skate',
    'mdi-roller-skate-off',
    'mdi-rollerblade',
    'mdi-rollerblade-off',
    'mdi-rollupjs',
    'mdi-roman-numeral-1',
    'mdi-roman-numeral-10',
    'mdi-roman-numeral-2',
    'mdi-roman-numeral-3',
    'mdi-roman-numeral-4',
    'mdi-roman-numeral-5',
    'mdi-roman-numeral-6',
    'mdi-roman-numeral-7',
    'mdi-roman-numeral-8',
    'mdi-roman-numeral-9',
    'mdi-room-service',
    'mdi-room-service-outline',
    'mdi-rotate-3d',
    'mdi-rotate-3d-variant',
    'mdi-rotate-left',
    'mdi-rotate-left-variant',
    'mdi-rotate-orbit',
    'mdi-rotate-right',
    'mdi-rotate-right-variant',
    'mdi-rounded-corner',
    'mdi-router',
    'mdi-router-network',
    'mdi-router-wireless',
    'mdi-router-wireless-settings',
    'mdi-routes',
    'mdi-routes-clock',
    'mdi-rowing',
    'mdi-rss',
    'mdi-rss-box',
    'mdi-rss-off',
    'mdi-rug',
    'mdi-rugby',
    'mdi-ruler',
    'mdi-ruler-square',
    'mdi-ruler-square-compass',
    'mdi-run',
    'mdi-run-fast',
    'mdi-rv-truck',
    'mdi-sack',
    'mdi-sack-percent',
    'mdi-safe',
    'mdi-safe-square',
    'mdi-safe-square-outline',
    'mdi-safety-goggles',
    'mdi-sail-boat',
    'mdi-sale',
    'mdi-salesforce',
    'mdi-sass',
    'mdi-satellite',
    'mdi-satellite-uplink',
    'mdi-satellite-variant',
    'mdi-sausage',
    'mdi-saw-blade',
    'mdi-sawtooth-wave',
    'mdi-saxophone',
    'mdi-scale',
    'mdi-scale-balance',
    'mdi-scale-bathroom',
    'mdi-scale-off',
    'mdi-scan-helper',
    'mdi-scanner',
    'mdi-scanner-off',
    'mdi-scatter-plot',
    'mdi-scatter-plot-outline',
    'mdi-school',
    'mdi-school-outline',
    'mdi-scissors-cutting',
    'mdi-scooter',
    'mdi-scoreboard',
    'mdi-scoreboard-outline',
    'mdi-screen-rotation',
    'mdi-screen-rotation-lock',
    'mdi-screw-flat-top',
    'mdi-screw-lag',
    'mdi-screw-machine-flat-top',
    'mdi-screw-machine-round-top',
    'mdi-screw-round-top',
    'mdi-screwdriver',
    'mdi-script',
    'mdi-script-outline',
    'mdi-script-text',
    'mdi-script-text-outline',
    'mdi-sd',
    'mdi-seal',
    'mdi-seal-variant',
    'mdi-search-web',
    'mdi-seat',
    'mdi-seat-flat',
    'mdi-seat-flat-angled',
    'mdi-seat-individual-suite',
    'mdi-seat-legroom-extra',
    'mdi-seat-legroom-normal',
    'mdi-seat-legroom-reduced',
    'mdi-seat-outline',
    'mdi-seat-passenger',
    'mdi-seat-recline-extra',
    'mdi-seat-recline-normal',
    'mdi-seatbelt',
    'mdi-security',
    'mdi-security-network',
    'mdi-seed',
    'mdi-seed-off',
    'mdi-seed-off-outline',
    'mdi-seed-outline',
    'mdi-segment',
    'mdi-select',
    'mdi-select-all',
    'mdi-select-color',
    'mdi-select-compare',
    'mdi-select-drag',
    'mdi-select-group',
    'mdi-select-inverse',
    'mdi-select-marker',
    'mdi-select-multiple',
    'mdi-select-multiple-marker',
    'mdi-select-off',
    'mdi-select-place',
    'mdi-select-search',
    'mdi-selection',
    'mdi-selection-drag',
    'mdi-selection-ellipse',
    'mdi-selection-ellipse-arrow-inside',
    'mdi-selection-marker',
    'mdi-selection-multiple',
    'mdi-selection-multiple-marke',
    'mdi-selection-off',
    'mdi-selection-search',
    'mdi-semantic-web',
    'mdi-send',
    'mdi-send-check',
    'mdi-send-check-outline',
    'mdi-send-circle',
    'mdi-send-circle-outline',
    'mdi-send-clock',
    'mdi-send-clock-outline',
    'mdi-send-lock',
    'mdi-send-lock-outline',
    'mdi-send-outline',
    'mdi-serial-port',
    'mdi-server',
    'mdi-server-minus',
    'mdi-server-network',
    'mdi-server-network-off',
    'mdi-server-off',
    'mdi-server-plus',
    'mdi-server-remove',
    'mdi-server-security',
    'mdi-set-all',
    'mdi-set-center',
    'mdi-set-center-right',
    'mdi-set-left',
    'mdi-set-left-center',
    'mdi-set-left-right',
    'mdi-set-merge',
    'mdi-set-none',
    'mdi-set-right',
    'mdi-set-split',
    'mdi-set-square',
    'mdi-set-top-box',
    'mdi-settings-helper',
    'mdi-shaker',
    'mdi-shaker-outline',
    'mdi-shape',
    'mdi-shape-circle-plus',
    'mdi-shape-outline',
    'mdi-shape-oval-plus',
    'mdi-shape-plus',
    'mdi-shape-polygon-plus',
    'mdi-shape-rectangle-plus',
    'mdi-shape-square-plus',
    'mdi-share',
    'mdi-share-all',
    'mdi-share-all-outline',
    'mdi-share-circle',
    'mdi-share-off',
    'mdi-share-off-outline',
    'mdi-share-outline',
    'mdi-share-variant',
    'mdi-sheep',
    'mdi-shield',
    'mdi-shield-account',
    'mdi-shield-account-outline',
    'mdi-shield-airplane',
    'mdi-shield-airplane-outline',
    'mdi-shield-alert',
    'mdi-shield-alert-outline',
    'mdi-shield-bug',
    'mdi-shield-bug-outline',
    'mdi-shield-car',
    'mdi-shield-check',
    'mdi-shield-check-outline',
    'mdi-shield-cross',
    'mdi-shield-cross-outline',
    'mdi-shield-edit',
    'mdi-shield-edit-outline',
    'mdi-shield-half',
    'mdi-shield-half-full',
    'mdi-shield-home',
    'mdi-shield-hom-outline',
    'mdi-shield-key',
    'mdi-shield-key-outline',
    'mdi-shield-link-variant',
    'mdi-shield-link-variant-outline',
    'mdi-shield-lock',
    'mdi-shield-lock-outline',
    'mdi-shield-off',
    'mdi-shield-off-outline',
    'mdi-shield-outline',
    'mdi-shield-plus',
    'mdi-shield-plus-outline',
    'mdi-shield-refresh',
    'mdi-shield-refresh-outline',
    'mdi-shield-remove',
    'mdi-shield-remove-outline',
    'mdi-shield-search',
    'mdi-shield-star',
    'mdi-shield-star-outline',
    'mdi-shield-sun',
    'mdi-shield-sun-outline',
    'mdi-shield-sync',
    'mdi-shield-sync-outline',
    'mdi-ship-wheel',
    'mdi-shoe-formal',
    'mdi-shoe-heel',
    'mdi-shoe-print',
    'mdi-shopping',
    'mdi-shopping-music',
    'mdi-shopping-outline',
    'mdi-shopping-search',
    'mdi-shovel',
    'mdi-shovel-off',
    'mdi-shower',
    'mdi-shower-head',
    'mdi-shredder',
    'mdi-shuffle',
    'mdi-shuffle-disabled',
    'mdi-shuffle-variant',
    'mdi-shuriken',
    'mdi-sigma',
    'mdi-sigma-lower',
    'mdi-sign-caution',
    'mdi-sign-direction',
    'mdi-sign-direction-minus',
    'mdi-sign-direction-plus',
    'mdi-sign-direction-remove',
    'mdi-sign-real-estate',
    'mdi-sign-text',
    'mdi-signal',
    'mdi-signal-2g',
    'mdi-signal-3g',
    'mdi-signal-4g',
    'mdi-signal-5g',
    'mdi-signal-cellular-1',
    'mdi-signal-cellular-2',
    'mdi-signal-cellular-3',
    'mdi-signal-cellular-outline',
    'mdi-signal-distance-variant',
    'mdi-signal-hspa',
    'mdi-signal-hspa-plus',
    'mdi-signal-off',
    'mdi-signal-variant',
    'mdi-signature',
    'mdi-signature-freehand',
    'mdi-signature-image',
    'mdi-signature-text',
    'mdi-silo',
    'mdi-silverware',
    'mdi-silverware-clean',
    'mdi-silverware-fork',
    'mdi-silverware-fork-knife',
    'mdi-silverware-spoon',
    'mdi-silverware-variant',
    'mdi-sim',
    'mdi-sim-alert',
    'mdi-sim-off',
    'mdi-simple-icons',
    'mdi-sina-weibo',
    'mdi-sine-wave',
    'mdi-sitemap',
    'mdi-size-l',
    'mdi-size-m',
    'mdi-size-s',
    'mdi-size-xl',
    'mdi-size-xs',
    'mdi-size-xxl',
    'mdi-size-xxs',
    'mdi-size-xxxl',
    'mdi-skate',
    'mdi-skateboard',
    'mdi-skew-less',
    'mdi-skew-more',
    'mdi-ski',
    'mdi-ski-cross-country',
    'mdi-ski-water',
    'mdi-skip-backward',
    'mdi-skip-backward-outline',
    'mdi-skip-forward',
    'mdi-skip-forward-outline',
    'mdi-skip-next',
    'mdi-skip-next-circle',
    'mdi-skip-next-circle-outline',
    'mdi-skip-next-outline',
    'mdi-skip-previous',
    'mdi-skip-previous-circle',
    'mdi-skip-previous-circle-outline',
    'mdi-skip-previous-outline',
    'mdi-skull',
    'mdi-skull-crossbones',
    'mdi-skull-crossbones-outline',
    'mdi-skull-outline',
    'mdi-skull-scan',
    'mdi-skull-scan-outline',
    'mdi-skype',
    'mdi-skype-business',
    'mdi-slack',
    'mdi-slash-forward',
    'mdi-slash-forward-box',
    'mdi-sleep',
    'mdi-sleep-off',
    'mdi-slope-downhill',
    'mdi-slope-uphill',
    'mdi-slot-machine',
    'mdi-slot-machine-outline',
    'mdi-smart-card',
    'mdi-smart-card-outline',
    'mdi-smart-card-reader',
    'mdi-smart-card-reader-outline',
    'mdi-smog',
    'mdi-smoke-detector',
    'mdi-smoking',
    'mdi-smoking-off',
    'mdi-smoking-pipe',
    'mdi-smoking-pipe-off',
    'mdi-snapchat',
    'mdi-snowboard',
    'mdi-snowflake',
    'mdi-snowflake-alert',
    'mdi-snowflake-melt',
    'mdi-snowflake-variant',
    'mdi-snowman',
    'mdi-soccer',
    'mdi-soccer-field',
    'mdi-sofa',
    'mdi-solar-panel',
    'mdi-solar-panel-large',
    'mdi-solar-power',
    'mdi-soldering-iron',
    'mdi-solid',
    'mdi-sony-playstation',
    'mdi-sort',
    'mdi-sort-alphabetical-ascending',
    'mdi-sort-alphabetical-ascending-variant',
    'mdi-sort-alphabetical-descending',
    'mdi-sort-alphabetical-descending-variant',
    'mdi-sort-alphabetical-variant',
    'mdi-sort-ascending',
    'mdi-sort-bool-ascending',
    'mdi-sort-bool-ascending-variant',
    'mdi-sort-bool-descending',
    'mdi-sort-bool-descending-variant',
    'mdi-sort-descending',
    'mdi-sort-numeric-ascending',
    'mdi-sort-numeric-ascending-variant',
    'mdi-sort-numeric-descending',
    'mdi-sort-numeric-descending-variant',
    'mdi-sort-numeric-variant',
    'mdi-sort-reverse-variant',
    'mdi-sort-variant',
    'mdi-sort-variant-lock',
    'mdi-sort-variant-lock-open',
    'mdi-sort-variant-remove',
    'mdi-soundcloud',
    'mdi-source-branch',
    'mdi-source-branch-check',
    'mdi-source-branch-minus',
    'mdi-source-branch-plus',
    'mdi-source-branch-refresh',
    'mdi-source-branch-remove',
    'mdi-source-branch-sync',
    'mdi-source-commit',
    'mdi-source-commit-end',
    'mdi-source-commit-end-local',
    'mdi-source-commit-local',
    'mdi-source-commit-next-local',
    'mdi-source-commit-start',
    'mdi-source-commit-start-next-local',
    'mdi-source-fork',
    'mdi-source-merge',
    'mdi-source-pull',
    'mdi-source-repository',
    'mdi-source-repository-multiple',
    'mdi-soy-sauce',
    'mdi-soy-sauce-off',
    'mdi-spa',
    'mdi-spa-outline',
    'mdi-space-invaders',
    'mdi-space-station',
    'mdi-spade',
    'mdi-speaker',
    'mdi-speaker-bluetooth',
    'mdi-speaker-multiple',
    'mdi-speaker-off',
    'mdi-speaker-wireless',
    'mdi-speedometer',
    'mdi-speedometer-medium',
    'mdi-speedometer-slow',
    'mdi-spellcheck',
    'mdi-spider',
    'mdi-spider-thread',
    'mdi-spider-web',
    'mdi-spoon-sugar',
    'mdi-spotify',
    'mdi-spotlight',
    'mdi-spotlight-beam',
    'mdi-spray',
    'mdi-spray-bottle',
    'mdi-sprinkler',
    'mdi-sprinkler-variant',
    'mdi-sprout',
    'mdi-sprout-outline',
    'mdi-square',
    'mdi-square-edit-outline',
    'mdi-square-medium',
    'mdi-square-medium-outline',
    'mdi-square-off',
    'mdi-square-off-outline',
    'mdi-square-outline',
    'mdi-square-root',
    'mdi-square-root-box',
    'mdi-square-small',
    'mdi-square-wave',
    'mdi-squeegee',
    'mdi-ssh',
    'mdi-stack-exchange',
    'mdi-stack-overflow',
    'mdi-stackpath',
    'mdi-stadium',
    'mdi-stadium-variant',
    'mdi-stair',
    'mdi-stairs-box',
    'mdi-stairs-down',
    'mdi-stairs-up',
    'mdi-stamper',
    'mdi-standard-definition',
    'mdi-star',
    'mdi-star-box',
    'mdi-star-box-multiple',
    'mdi-star-box-multiple-outline',
    'mdi-star-box-outlin',
    'mdi-star-circle',
    'mdi-star-circle-outline',
    'mdi-star-face',
    'mdi-star-four-points',
    'mdi-star-four-points-outline',
    'mdi-star-half',
    'mdi-star-half-full',
    'mdi-star-off',
    'mdi-star-outline',
    'mdi-star-three-points',
    'mdi-star-three-points-outline',
    'mdi-state-machine',
    'mdi-steam',
    'mdi-steering',
    'mdi-steering-off',
    'mdi-step-backward',
    'mdi-step-backward-2',
    'mdi-step-forward',
    'mdi-step-forward-2',
    'mdi-stethoscope',
    'mdi-sticker',
    'mdi-sticker-alert',
    'mdi-sticker-alert-outline',
    'mdi-sticker-check',
    'mdi-sticker-check-outline',
    'mdi-sticker-circle-outline',
    'mdi-sticker-emoji',
    'mdi-sticker-minus',
    'mdi-sticker-minus-outline',
    'mdi-sticker-outline',
    'mdi-sticker-plus',
    'mdi-sticker-plus-outline',
    'mdi-sticker-remove',
    'mdi-sticker-remove-outline',
    'mdi-stocking',
    'mdi-stomach',
    'mdi-stop',
    'mdi-stop-circle',
    'mdi-stop-circle-outline',
    'mdi-store',
    'mdi-store-24-hour',
    'mdi-store-outline',
    'mdi-storefront',
    'mdi-storefront-outline',
    'mdi-stove',
    'mdi-strategy',
    'mdi-stretch-to-page',
    'mdi-stretch-to-page-outline',
    'mdi-string-lights',
    'mdi-string-lights-off',
    'mdi-subdirectory-arrow-left',
    'mdi-subdirectory-arrow-right',
    'mdi-subtitles',
    'mdi-subtitles-outline',
    'mdi-subway',
    'mdi-subway-alert-variant',
    'mdi-subway-variant',
    'mdi-summit',
    'mdi-sunglasses',
    'mdi-surround-sound',
    'mdi-surround-sound-2-0',
    'mdi-surround-sound-3-1',
    'mdi-surround-sound-5-1',
    'mdi-surround-sound-7-1',
    'mdi-svg',
    'mdi-swap-horizontal',
    'mdi-swap-horizontal-bold',
    'mdi-swap-horizontal-circle',
    'mdi-swap-horizontal-circle-outline',
    'mdi-swap-horizontal-variant',
    'mdi-swap-vertical',
    'mdi-swap-vertical-bold',
    'mdi-swap-vertical-circle',
    'mdi-swap-vertical-circle-outline',
    'mdi-swap-vertical-variant',
    'mdi-swim',
    'mdi-switch',
    'mdi-sword',
    'mdi-sword-cross',
    'mdi-syllabary-hangul',
    'mdi-syllabary-hiragana',
    'mdi-syllabary-katakana',
    'mdi-syllabary-katakana-halfwidth',
    'mdi-symfony',
    'mdi-sync',
    'mdi-sync-alert',
    'mdi-sync-circle',
    'mdi-sync-off',
    'mdi-tab',
    'mdi-tab-minus',
    'mdi-tab-plus',
    'mdi-tab-remove',
    'mdi-tab-unselected',
    'mdi-table',
    'mdi-table-account',
    'mdi-table-alert',
    'mdi-table-arrow-down',
    'mdi-table-arrow-left',
    'mdi-table-arrow-right',
    'mdi-table-arrow-up',
    'mdi-table-border',
    'mdi-table-cancel',
    'mdi-table-chair',
    'mdi-table-check',
    'mdi-table-clock',
    'mdi-table-cog',
    'mdi-table-column',
    'mdi-table-column-plus-after',
    'mdi-table-column-plus-before',
    'mdi-table-column-remove',
    'mdi-table-column-width',
    'mdi-table-edit',
    'mdi-table-eye',
    'mdi-table-eye-off',
    'mdi-table-furniture',
    'mdi-table-headers-eye',
    'mdi-table-headers-eye-off',
    'mdi-table-heart',
    'mdi-table-key',
    'mdi-table-large',
    'mdi-table-large-plus',
    'mdi-table-large-remove',
    'mdi-table-lock',
    'mdi-table-merge-cells',
    'mdi-table-minus',
    'mdi-table-multiple',
    'mdi-table-network',
    'mdi-table-of-contents',
    'mdi-table-off',
    'mdi-table-plus',
    'mdi-table-refresh',
    'mdi-table-remove',
    'mdi-table-row',
    'mdi-table-row-height',
    'mdi-table-row-plus-after',
    'mdi-table-row-plus-before',
    'mdi-table-row-remove',
    'mdi-table-search',
    'mdi-table-settings',
    'mdi-table-split-cell',
    'mdi-table-star',
    'mdi-table-sync',
    'mdi-table-tennis',
    'mdi-tablet',
    'mdi-tablet-android',
    'mdi-tablet-cellphone',
    'mdi-tablet-dashboard',
    'mdi-tablet-ipad',
    'mdi-taco',
    'mdi-tag',
    'mdi-tag-faces',
    'mdi-tag-heart',
    'mdi-tag-heart-outline',
    'mdi-tag-minus',
    'mdi-tag-minus-outline',
    'mdi-tag-multiple',
    'mdi-tag-multiple-outline',
    'mdi-tag-off',
    'mdi-tag-off-outline',
    'mdi-tag-outline',
    'mdi-tag-plus',
    'mdi-tag-plus-outline',
    'mdi-tag-remove',
    'mdi-tag-remove-outline',
    'mdi-tag-text',
    'mdi-tag-text-outline',
    'mdi-tailwind',
    'mdi-tank',
    'mdi-tanker-truck',
    'mdi-tape-measure',
    'mdi-target',
    'mdi-target-account',
    'mdi-target-variant',
    'mdi-taxi',
    'mdi-tea',
    'mdi-tea-outline',
    'mdi-teach',
    'mdi-teamviewer',
    'mdi-telegram',
    'mdi-telescope',
    'mdi-television',
    'mdi-television-ambient-light',
    'mdi-television-bo',
    'mdi-television-classic',
    'mdi-television-classic-off',
    'mdi-television-clean',
    'mdi-television-guide',
    'mdi-television-off',
    'mdi-television-pause',
    'mdi-television-play',
    'mdi-television-stop',
    'mdi-temperature-celsius',
    'mdi-temperature-fahrenheit',
    'mdi-temperature-kelvin',
    'mdi-tennis',
    'mdi-tennis-ball',
    'mdi-tent',
    'mdi-terraform',
    'mdi-terrain',
    'mdi-test-tube',
    'mdi-test-tube-empty',
    'mdi-test-tube-off',
    'mdi-text',
    'mdi-text-box',
    'mdi-text-box-check',
    'mdi-text-box-check-outline',
    'mdi-text-box-minus',
    'mdi-text-box-minus-outline',
    'mdi-text-box-multiple',
    'mdi-text-box-multiple-outline',
    'mdi-text-box-outline',
    'mdi-text-box-plus',
    'mdi-text-box-plus-outline',
    'mdi-text-box-remove',
    'mdi-text-box-remov-outline',
    'mdi-text-box-search',
    'mdi-text-box-search-outline',
    'mdi-text-recognition',
    'mdi-text-search',
    'mdi-text-shadow',
    'mdi-text-short',
    'mdi-text-subject',
    'mdi-text-to-speech',
    'mdi-text-to-speech-off',
    'mdi-texture',
    'mdi-texture-box',
    'mdi-theater',
    'mdi-theme-light-dark',
    'mdi-thermometer',
    'mdi-thermometer-alert',
    'mdi-thermometer-chevron-down',
    'mdi-thermometer-chevron-up',
    'mdi-thermometer high',
    'mdi-thermometer-lines',
    'mdi-thermometer-low',
    'mdi-thermometer-minus',
    'mdi-thermometer-plus',
    'mdi-thermostat',
    'mdi-thermostat-box',
    'mdi-thought-bubble',
    'mdi-thought-bubble-outline',
    'mdi-thumb-down',
    'mdi-thumb-down-outline',
    'mdi-thumb-up',
    'mdi-thumb-up-outline',
    'mdi-thumbs-up-down',
    'mdi-ticket',
    'mdi-ticket-account',
    'mdi-ticket-confirmation',
    'mdi-ticket-confirmation-outline',
    'mdi-ticket-outline',
    'mdi-ticket-percent',
    'mdi-ticket-percent-outline',
    'mdi-tie',
    'mdi-tilde',
    'mdi-timelapse',
    'mdi-timeline',
    'mdi-timeline-alert',
    'mdi-timeline-alert-outline',
    'mdi-timeline-clock',
    'mdi-timeline-clock-outlin',
    'mdi-timeline-help',
    'mdi-timeline help-outline',
    'mdi-timeline-outlin',
    'mdi-timeline-plus  mdi-timeline-plus-outline',
    'mdi-timeline-text',
    'mdi-timeline-text-outline',
    'mdi-timer',
    'mdi-timer-10',
    'mdi-timer-3',
    'mdi-timer-off',
    'mdi-timer-off-outline',
    'mdi-timer-outline',
    'mdi-timer-sand',
    'mdi-timer-sand-empty',
    'mdi-timer-sand-full',
    'mdi-timetable',
    'mdi-toaster',
    'mdi-toaster-off',
    'mdi-toaster-oven',
    'mdi-toggle-switch',
    'mdi-toggle-switch-off',
    'mdi-toggle-switch-off-outline',
    'mdi-toggle-switch-outline',
    'mdi-toilet',
    'mdi-toolbox',
    'mdi-toolbox-outline',
    'mdi-tools',
    'mdi-tooltip',
    'mdi-tooltip-account',
    'mdi-tooltip-edit',
    'mdi-tooltip-edit-outline',
    'mdi-tooltip-image',
    'mdi-tooltip-image-outline',
    'mdi-tooltip-outline',
    'mdi-tooltip-plus',
    'mdi-tooltip-plus-outline',
    'mdi-tooltip-text',
    'mdi-tooltip-text-outline',
    'mdi-tooth',
    'mdi-tooth-outline',
    'mdi-toothbrush',
    'mdi-toothbrush-electric',
    'mdi-toothbrush-paste',
    'mdi-tortoise',
    'mdi-toslink',
    'mdi-tournament',
    'mdi-tow-truck',
    'mdi-tower-beach',
    'mdi-tower-fire',
    'mdi-toy-brick',
    'mdi-toy-brick-marker',
    'mdi-toy-brick-marker-outline',
    'mdi-toy-brick-minus',
    'mdi-toy-brick-minus-outline',
    'mdi-toy-brick-outline',
    'mdi-toy-brick-plus',
    'mdi-toy-brick-plus-outline',
    'mdi-toy-brick-remove',
    'mdi-toy-brick-remove-outline',
    'mdi-toy-brick-search',
    'mdi-toy-brick-search-outline',
    'mdi-track-light',
    'mdi-trackpad',
    'mdi-trackpad-lock',
    'mdi-tractor',
    'mdi-tractor-variant',
    'mdi-trademark',
    'mdi-traffic-cone',
    'mdi-traffic light',
    'mdi-train',
    'mdi-train-car',
    'mdi-train-variant',
    'mdi-tram',
    'mdi-tram-side',
    'mdi-transcribe',
    'mdi-transcribe-close',
    'mdi-transfer',
    'mdi-transfer-down',
    'mdi-transfer-left',
    'mdi-transfer-right',
    'mdi-transfer-up',
    'mdi-transit-connection',
    'mdi-transit-connection-variant',
    'mdi-transit-detour',
    'mdi-transit-transfer',
    'mdi-transition',
    'mdi-transition-masked',
    'mdi-translate',
    'mdi-translate-off',
    'mdi-transmission-tower',
    'mdi-trash-can',
    'mdi-trash-can-outline',
    'mdi-tray',
    'mdi-tray-alert',
    'mdi-tray-full',
    'mdi-tray-minus',
    'mdi-tray-plus',
    'mdi-tray-remove',
    'mdi-treasure-chest',
    'mdi-tree',
    'mdi-tree-outline',
    'mdi-trello',
    'mdi-trending-down',
    'mdi-trending-neutral',
    'mdi-trending-up',
    'mdi-triangle',
    'mdi-triangle-outline',
    'mdi-triangle-wave',
    'mdi-triforce',
    'mdi-trophy',
    'mdi-trophy-award',
    'mdi-trophy-broken',
    'mdi-trophy-outline',
    'mdi-trophy-variant',
    'mdi-trophy-variant-outline',
    'mdi-truck',
    'mdi-truck-check',
    'mdi-truck-check-outline',
    'mdi-truck-delivery',
    'mdi-truck-delivery-outline',
    'mdi-truck-fast',
    'mdi-truck-fast-outline',
    'mdi-truck-outline',
    'mdi-truck-trailer',
    'mdi-trumpet',
    'mdi-tshirt-crew',
    'mdi-tshirt-crew-outline',
    'mdi-tshirt-v',
    'mdi-tshirt-v-outline',
    'mdi-tumble-dryer',
    'mdi-tumble-dryer-alert',
    'mdi-tumble-dryer-off',
    'mdi-tune',
    'mdi-tune-vertical',
    'mdi-turnstile',
    'mdi-turnstile-outline',
    'mdi-turtle',
    'mdi-twitch',
    'mdi-twitter',
    'mdi-twitter-retweet',
    'mdi-two-factor-authentication',
    'mdi-typewriter',
    'mdi-ubisoft',
    'mdi-ubuntu',
    'mdi-ufo',
    'mdi-ufo-outline',
    'mdi-ultra-high-definition',
    'mdi-umbraco',
    'mdi-umbrella',
    'mdi-umbrella-closed',
    'mdi-umbrella-closed-outline',
    'mdi-umbrella-closed-variant',
    'mdi-umbrella-outline',
    'mdi-undo',
    'mdi-undo-variant',
    'mdi-unfold-less-horizontal',
    'mdi-unfold-less-vertical',
    'mdi-unfold-more-horizontal',
    'mdi-unfold-more-vertical',
    'mdi-ungroup',
    'mdi-unicode',
    'mdi-unity',
    'mdi-unreal',
    'mdi-untappd',
    'mdi-update',
    'mdi-upload',
    'mdi-upload-lock',
    'mdi-upload-lock-outline',
    'mdi-upload-multiple',
    'mdi-upload-network',
    'mdi-upload-networ-outline',
    'mdi-upload-off',
    'mdi-upload-off-outline',
    'mdi-upload-outline',
    'mdi-usb',
    'mdi-usb-flash-drive',
    'mdi-usb-flash-drive-outline',
    'mdi-usb-port',
    'mdi-valve',
    'mdi-valve-closed',
    'mdi-valve-open',
    'mdi-van-passenger',
    'mdi-van-utility',
    'mdi-vanish',
    'mdi-vanity-light',
    'mdi-variable',
    'mdi-variable-box',
    'mdi-vector-arrange-above',
    'mdi-vector-arrange-below',
    'mdi-vector-bezier',
    'mdi-vector-circle',
    'mdi-vector-circle-variant',
    'mdi-vector-combine',
    'mdi-vector-curve',
    'mdi-vector-difference',
    'mdi-vector-differenc-ab',
    'mdi-vector-difference-ba',
    'mdi-vector-ellipse',
    'mdi-vector-intersection',
    'mdi-vector-line',
    'mdi-vector-link',
    'mdi-vector-point',
    'mdi-vector-polygon',
    'mdi-vector-polyline',
    'mdi-vector-polyline-edit',
    'mdi-vector-polyline-minus',
    'mdi-vector-polyline-plus',
    'mdi-vector-polyline-remove',
    'mdi-vector-radius',
    'mdi-vector-rectangle',
    'mdi-vector-selection',
    'mdi-vector-square',
    'mdi-vector-triangle',
    'mdi-vector-union',
    'mdi-vhs',
    'mdi-vibrate',
    'mdi-vibrate-off',
    'mdi-video',
    'mdi-video-3d',
    'mdi-video-3d-off',
    'mdi-video-3d-variant',
    'mdi-video-4k-box',
    'mdi-video-account',
    'mdi-video-box',
    'mdi-video-box-off',
    'mdi-video-check',
    'mdi-video-check-outline',
    'mdi-video-image',
    'mdi-video-input-antenna',
    'mdi-video-input-component',
    'mdi-video-input-hdmi',
    'mdi-video-input-scart',
    'mdi-video-input-svideo',
    'mdi-video-minus',
    'mdi-video-minus-outline',
    'mdi-video-off',
    'mdi-video-off-outline',
    'mdi-video-outline',
    'mdi-video-plus',
    'mdi-video-plus-outline',
    'mdi-video-stabilization',
    'mdi-video-switch',
    'mdi-video-switch-outline',
    'mdi-video-vintage',
    'mdi-video-wireless',
    'mdi-video-wireless-outline',
    'mdi-view-agenda',
    'mdi-view-agenda-outline',
    'mdi-view-array',
    'mdi-view-array-outline',
    'mdi-view-carousel',
    'mdi-view-carousel-outline',
    'mdi-view-column',
    'mdi-view-column-outline',
    'mdi-view-comfy',
    'mdi-view-comfy-outline',
    'mdi-view-compact',
    'mdi-view-compact-outline',
    'mdi-view-dashboard',
    'mdi-view-dashboard-outline',
    'mdi-view-dashboard-variant',
    'mdi-view-dashboard-variant-outline',
    'mdi-view-day',
    'mdi-view-day-outline',
    'mdi-view-grid',
    'mdi-view-grid-outline',
    'mdi-view-grid-plus',
    'mdi-view-grid-plus-outline',
    'mdi-view-headline',
    'mdi-view-list',
    'mdi-view-list-outline',
    'mdi-view-module',
    'mdi-view-module-outline',
    'mdi-view-parallel',
    'mdi-view-parallel-outline',
    'mdi-view-quilt',
    'mdi-view-quilt-outline',
    'mdi-view-sequential',
    'mdi-view-sequential-outline',
    'mdi-view-split-horizontal',
    'mdi-view-split-vertical',
    'mdi-view-stream',
    'mdi-view-stream-outline',
    'mdi-view-week',
    'mdi-view-week-outline',
    'mdi-vimeo',
    'mdi-violin',
    'mdi-virtual-reality',
    'mdi-virus',
    'mdi-virus-outline',
    'mdi-vk',
    'mdi-vlc',
    'mdi-voice-off',
    'mdi-voicemail',
    'mdi-volleyball',
    'mdi-volume-high',
    'mdi-volume-low',
    'mdi-volume-medium',
    'mdi-volume-minus',
    'mdi-volume-mute',
    'mdi-volume-off',
    'mdi-volume-plus',
    'mdi-volume-source',
    'mdi-volume-variant-off',
    'mdi-volume-vibrate',
    'mdi-vote',
    'mdi-vote-outline',
    'mdi-vpn',
    'mdi-vuejs',
    'mdi-vuetify',
    'mdi-walk',
    'mdi-wall',
    'mdi-wall-sconce',
    'mdi-wall-sconce-flat',
    'mdi-wall-sconce-flat-variant',
    'mdi-wall-sconce-round',
    'mdi-wall-sconce-round-variant',
    'mdi-wallet',
    'mdi-wallet-giftcard',
    'mdi-wallet-membership',
    'mdi-wallet-outline',
    'mdi-wallet-plus',
    'mdi-wallet-plus-outline',
    'mdi-wallet-travel',
    'mdi-wallpaper',
    'mdi-wan',
    'mdi-wardrobe',
    'mdi-wardrobe-outline',
    'mdi-warehouse',
    'mdi-washing-machine',
    'mdi-washing-machine-alert',
    'mdi-washing-machine-off',
    'mdi-watch',
    'mdi-watch-export',
    'mdi-watch-export-variant',
    'mdi-watch-import',
    'mdi-watch-import-variant',
    'mdi-watch-variant',
    'mdi-watch-vibrate',
    'mdi-watch-vibrate-off',
    'mdi-water',
    'mdi-water-boiler',
    'mdi-water-boiler-alert',
    'mdi-water-boiler-off',
    'mdi-water-off',
    'mdi-water-outline',
    'mdi-water-percent',
    'mdi-water-polo',
    'mdi-water-pump',
    'mdi-water-pump-off',
    'mdi-water-well',
    'mdi-water-well-outline',
    'mdi-watering-can',
    'mdi-watering-can-outline',
    'mdi-watermark',
    'mdi-wave',
    'mdi-waveform',
    'mdi-waves',
    'mdi-waze',
    'mdi-weather-cloudy',
    'mdi-weather-cloudy-alert',
    'mdi-weather-cloudy-arrow-right',
    'mdi-weather-fog',
    'mdi-weather-hail',
    'mdi-weather-hazy',
    'mdi-weather-hurricane',
    'mdi-weather-lightning',
    'mdi-weather-lightning-rainy',
    'mdi-weather-night',
    'mdi-weather-night-partly-cloudy',
    'mdi-weather-partly-cloudy',
    'mdi-weather-partly-lightning',
    'mdi-weather-partly-rainy',
    'mdi-weather-partly-snowy',
    'mdi-weather-partly-snowy-rainy',
    'mdi-weather-pouring',
    'mdi-weather-rainy',
    'mdi-weather-snowy',
    'mdi-weather-snowy-heavy',
    'mdi-weather-snowy-rainy',
    'mdi-weather-sunny',
    'mdi-weather-sunny-alert',
    'mdi-weather-sunset',
    'mdi-weather-sunset-down',
    'mdi-weather-sunset-up',
    'mdi-weather-tornado',
    'mdi-weather-windy',
    'mdi-weather-windy-variant',
    'mdi-web',
    'mdi-web-box',
    'mdi-web-clock',
    'mdi-webcam',
    'mdi-webhook',
    'mdi-webpack',
    'mdi-webrtc',
    'mdi-wechat',
    'mdi-weight',
    'mdi-weight-gram',
    'mdi-weight-kilogram',
    'mdi-weight-lifter',
    'mdi-weight-pound',
    'mdi-whatsapp',
    'mdi-wheelchair-accessibility',
    'mdi-whistle',
    'mdi-whistle-outline',
    'mdi-white-balance-auto',
    'mdi-white-balance-incandescent',
    'mdi-white-balance-iridescent',
    'mdi-white-balance-sunny',
    'mdi-widgets',
    'mdi-widgets-outline',
    'mdi-wifi',
    'mdi-wifi-off',
    'mdi-wifi-star',
    'mdi-wifi-strength-1',
    'mdi-wifi-strength-1-alert',
    'mdi-wifi-strength-1-lock',
    'mdi-wifi-strength-2',
    'mdi-wifi-strength-2-alert',
    'mdi-wifi-strength-2-lock',
    'mdi-wifi-strength-3',
    'mdi-wifi-strength-3-alert',
    'mdi-wifi-strength-3-lock',
    'mdi-wifi-strength-4',
    'mdi-wifi-strength-4-alert',
    'mdi-wifi-strength-4-lock',
    'mdi-wifi-strength-alert-outline',
    'mdi-wifi-strength-lock-outline',
    'mdi-wifi-strength-off',
    'mdi-wifi-strength-off-outline',
    'mdi-wifi-strength-outline',
    'mdi-wikipedia',
    'mdi-wind-turbine',
    'mdi-window-close',
    'mdi-window-closed',
    'mdi-window-closed-variant',
    'mdi-window-maximize',
    'mdi-window-minimize',
    'mdi-window-open',
    'mdi-window-open-variant',
    'mdi-window-restore',
    'mdi-window-shutter',
    'mdi-window-shutter-alert',
    'mdi-window-shutter-open',
    'mdi-wiper',
    'mdi-wiper-wash',
    'mdi-wizard-hat',
    'mdi-wordpress',
    'mdi-wrap',
    'mdi-wrap-disabled',
    'mdi-wrench',
    'mdi-wrench-outline',
    'mdi-xamarin',
    'mdi-xamarin-outline',
    'mdi-xing',
    'mdi-xml',
    'mdi-xmpp',
    'mdi-y-combinator',
    'mdi-yahoo',
    'mdi-yeast',
    'mdi-yin-yang',
    'mdi-yoga',
    'mdi-youtube',
    'mdi-youtube-gaming',
    'mdi-youtube-studio',
    'mdi-youtube-subscription',
    'mdi-youtube-tv',
    'mdi-z-wave',
    'mdi-zend',
    'mdi-zigbee',
    'mdi-zip-box',
    'mdi-zip-box-outline',
    'mdi-zip-disk',
    'mdi-zodiac-aquarius',
    'mdi-zodiac-aries',
    'mdi-zodiac-cancer',
    'mdi-zodiac-capricorn',
    'mdi-zodiac-gemini',
    'mdi-zodiac-leo',
    'mdi-zodiac-libra',
    'mdi-zodiac-pisces',
    'mdi-zodiac-sagittarius',
    'mdi-zodiac-scorpio',
    'mdi-zodiac-taurus',
    'mdi-zodiac-virgo',
    'mdi-blank'
];

class IconDialogComponent {
    constructor(icon) {
        this.icon = icon;
        this.icons = [];
    }
    ngOnInit() {
        this.icons = ICONS;
    }
}
IconDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: IconDialogComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
IconDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: IconDialogComponent, selector: "ft-icon-dialog", ngImport: i0, template: "<div mat-dialog-title></div>\n<div mat-dialog-content>\n\n    <div fxLayout=\"row wrap\" fxLayoutAlign=\"start start\" fxLayoutGap=\"4px\">\n        <mat-icon (click)=\"selectedIcon = icon\" *ngFor=\"let icon of icons\" [class.selected]=\"icon == selectedIcon\"\n                  [fontIcon]=\"icon\" [matTooltip]=\"icon\" fontSet=\"mdi\"></mat-icon>\n    </div>\n</div>\n<div align=\"end\" mat-dialog-actions>\n    <button [matDialogClose]=\"null\" color=\"accent\" mat-stroked-button>{{'table.cancel' | translate}}</button>\n    <button [matDialogClose]=\"selectedIcon\" color=\"primary\" mat-stroked-button><b>{{'table.apply' | translate}}</b>\n    </button>\n</div>\n", styles: [".mat-icon{padding:5px;cursor:pointer;height:28px!important;width:28px!important;font-size:28px!important;line-height:28px;color:#717171}.mat-icon:hover{background-color:#e5e5e5}.mat-icon.selected{background-color:#e91e6329;color:#d81b60}\n"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i14.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { type: i14.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }], pipes: { "translate": i5$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: IconDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-icon-dialog', template: "<div mat-dialog-title></div>\n<div mat-dialog-content>\n\n    <div fxLayout=\"row wrap\" fxLayoutAlign=\"start start\" fxLayoutGap=\"4px\">\n        <mat-icon (click)=\"selectedIcon = icon\" *ngFor=\"let icon of icons\" [class.selected]=\"icon == selectedIcon\"\n                  [fontIcon]=\"icon\" [matTooltip]=\"icon\" fontSet=\"mdi\"></mat-icon>\n    </div>\n</div>\n<div align=\"end\" mat-dialog-actions>\n    <button [matDialogClose]=\"null\" color=\"accent\" mat-stroked-button>{{'table.cancel' | translate}}</button>\n    <button [matDialogClose]=\"selectedIcon\" color=\"primary\" mat-stroked-button><b>{{'table.apply' | translate}}</b>\n    </button>\n</div>\n", styles: [".mat-icon{padding:5px;cursor:pointer;height:28px!important;width:28px!important;font-size:28px!important;line-height:28px;color:#717171}.mat-icon:hover{background-color:#e5e5e5}.mat-icon.selected{background-color:#e91e6329;color:#d81b60}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    } });

// const moment=moment_
class StyleRulesComponent {
    constructor(dialog, _adapter, _ftService, _snackBar, _translateService) {
        this.dialog = dialog;
        this._adapter = _adapter;
        this._ftService = _ftService;
        this._snackBar = _snackBar;
        this._translateService = _translateService;
        this.viewColumns = [];
        this.textFieldKeys = [];
        this.textFieldValues = [];
        this.availableStyleRules = [];
        this.previewMode = false;
        this.modeEdit = false;
        this.previewCount = 0;
        this.editIndex = null;
        this.firstClickUpdate = false;
        this.styleRulesChange = new EventEmitter();
        this.addStyleRuleChange = new EventEmitter();
        this.initializeFormStyle();
    }
    set handleViewColumns(cols) {
        this.viewColumns = cols ? filter(cols, (col => STYLIZED_COLUMN_TYPE.includes(col.type))) : [];
    }
    set addStyleRule(showAddRuleBtn) {
        this.showStyleRulesList = showAddRuleBtn;
        if (!this.modeEdit)
            this.initializeFormStyle();
    }
    set styleRules(rules) {
        this.availableStyleRules = rules !== null && rules !== void 0 ? rules : [];
    }
    ngOnInit() {
    }
    initializeFormStyle() {
        this.formStyle = {
            type: 'column',
            style: {
                fontWeight: 'normal',
                fontStyle: 'normal',
                color: 'black',
                background: null
            },
            target: null,
            target_value: null,
            condition: null,
            isUnderline: false,
            isStrikethrough: false
        };
    }
    initializeFilters() {
        this.resultFilter = this.selectedCol ? getOperatorsStyle(this.selectedCol.type) : null;
    }
    handleShowAddBtn() {
        this.addStyleRuleChange.emit(this.showStyleRulesList);
    }
    filterColChanged() {
        // clear last filter
        this.selectedFilter = null;
        this.initializeFilters();
    }
    generateTextField(selectedFilter) {
        const numberTextField = selectedFilter.numberTextField;
        this.textFieldKeys = [...Array(numberTextField).keys()];
        this.textFieldValues = new Array(numberTextField).fill(null);
    }
    validate(validateData = true) {
        this.formStyle.target = this.selectedCol.key;
        this.formStyle.condition = this.selectedFilter.key;
        this.previewMode = !validateData;
        if (get(this.selectedCol, 'type') === 'datetime') {
            const date = new Date(this.textFieldValues[0]);
            const time = moment(this.time, INPUT_TIME_FORMAT);
            this.formStyle.target_value = new Date(date.getFullYear(), date.getMonth(), date.getDay(), time.hours(), time.minutes());
        }
        else {
            this.formStyle.target_value = this.textFieldValues.length === 1 ?
                moment.isMoment(this.textFieldValues[0]) ? this.textFieldValues[0].format(NAIVE_DATE_FORMAT) : this.textFieldValues[0]
                : this.selectedCol.type === 'boolean' ? this.selectedFilter.key === 'is_true' : this.textFieldValues;
        }
        if (this.previewCount > 0) {
            this.availableStyleRules.pop();
        }
        this.modeEdit && validateData ? this.availableStyleRules[this.editIndex] = cloneDeep(this.formStyle) :
            this.availableStyleRules.push(cloneDeep(this.formStyle));
        this.handleChange(validateData);
        validateData ? this.clearFilter() : this.handlePreviewMode();
    }
    handlePreviewMode() {
        this.previewCount++;
        this.showStyleRulesList = false;
        this.handleShowAddBtn();
    }
    handleChange(validateData = true) {
        this.styleRulesChange.emit({ validate: validateData, styleRules: this.availableStyleRules });
    }
    setHelpersTextDecoration() {
        var _a, _b;
        this.formStyle.isUnderline = (_a = this.formStyle.style.textDecoration) === null || _a === void 0 ? void 0 : _a.includes('underline');
        this.formStyle.isStrikethrough = (_b = this.formStyle.style.textDecoration) === null || _b === void 0 ? void 0 : _b.includes('line-through');
    }
    getTextDecoration() {
        if (this.modeEdit && this.firstClickUpdate) {
            this.setHelpersTextDecoration();
            this.firstClickUpdate = false;
            return this.formStyle.style.textDecoration;
        }
        else {
            this.formStyle.style.textDecoration = (this.formStyle.isUnderline ? 'underline ' : '') +
                (this.formStyle.isStrikethrough ? 'line-through ' : '');
            return this.formStyle.style.textDecoration;
        }
    }
    updateStyleRule(rule, index) {
        this.formStyle = cloneDeep(rule);
        this.firstClickUpdate = true;
        this.selectedCol = this.getSelectedColumn(rule.target);
        // if displayedViewColumns has changed, test if column exist or removed
        if (this.selectedCol) {
            this.initializeFilters();
            this.selectedFilter = getSelectedFilter(rule.condition, this.selectedCol.type);
            this.textFieldKeys = [...Array(this.selectedFilter.numberTextField).keys()];
            this.textFieldValues = this.selectedFilter.numberTextField === 0 ? [] :
                Array.isArray(rule.target_value) ? rule.target_value : [rule.target_value];
            this.modeEdit = true;
            this.editIndex = index;
            this.showStyleRulesList = false;
            this.handleShowAddBtn();
        }
        else {
            this.openSnackBar(this._translateService.instant('table.update_column_error'));
        }
    }
    deleteStyleRule(index) {
        this.availableStyleRules.splice(index, 1);
        this.handleChange();
    }
    clearFilter() {
        // cancelLastRule if don't save changes
        if (this.previewMode) {
            this.deleteStyleRule(this.availableStyleRules.length - 1);
        }
        this.initializeFormStyle();
        this.selectedCol = null;
        this.selectedFilter = null;
        this.modeEdit = false;
        this.editIndex = null;
        this.textFieldValues = [];
        this.firstClickUpdate = false;
        this.previewCount = 0;
        this.previewMode = false;
        this.showStyleRulesList = true;
        this.handleShowAddBtn();
    }
    getRuleLabel(rule) {
        return get(this.getSelectedColumn(rule.target), 'label');
    }
    getRuleTitle(rule) {
        var _a;
        return (_a = this.getRuleLabel(rule)) !== null && _a !== void 0 ? _a : rule.target;
    }
    getRuleSubTitle(rule) {
        return get(getStyleRuleFilter(rule.condition), 'label');
    }
    getRuleSubTitle2(rule) {
        return rule.condition.includes('empty') || typeof rule.target_value === 'boolean' ?
            null : ' : ' + rule.target_value;
    }
    getSelectedColumn(ruleTarget) {
        return find(this.viewColumns, { key: ruleTarget });
    }
    drop(event) {
        moveItemInArray(this.availableStyleRules, event.previousIndex, event.currentIndex);
        this.handleChange();
    }
    changeDisplayMode(event) {
        var _a;
        this.formStyle.display_mode = event.value;
        if (this.formStyle.display_mode === 'icon') {
            this.formStyle.icon = (_a = this.formStyle.icon) !== null && _a !== void 0 ? _a : 'mdi-checkbox-blank-circle';
        }
    }
    chooseIcon() {
        this.dialog.open(IconDialogComponent, { data: this.formStyle.icon }).afterClosed().subscribe(icon => {
            if (icon) {
                this.formStyle.icon = icon;
            }
        });
    }
    openSnackBar(message) {
        this._snackBar.open(message);
    }
}
StyleRulesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: StyleRulesComponent, deps: [{ token: i1$1.MatDialog }, { token: i2$1.MomentDateAdapter }, { token: i15.GeneralPurposeService }, { token: i4$2.MatSnackBar }, { token: i5$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
StyleRulesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: StyleRulesComponent, selector: "ft-style-rules", inputs: { handleViewColumns: ["viewColumns", "handleViewColumns"], addStyleRule: "addStyleRule", styleRules: "styleRules" }, outputs: { styleRulesChange: "styleRulesChange", addStyleRuleChange: "addStyleRuleChange" }, host: { classAttribute: "ft-style-rules" }, ngImport: i0, template: "<div *ngIf=\"showStyleRulesList\" cdkDropListGroup>\n\n    <mat-selection-list [multiple]=\"false\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n                        *ngIf=\"availableStyleRules.length > 0\" class=\"list-rules\">\n        <mat-list-option *ngFor=\"let rule of availableStyleRules; let i=index\" [value]=\"rule\" class=\"rule-option\"\n                         (click)=\"updateStyleRule(rule, i)\" cdkDragBoundary=\".list-rules\" cdkDrag>\n            <!-- [style.background]=\"'red'\"-->\n\n            <div fxLayout=\"row\" class=\"rule-item\" [ngClass]=\"{'disabled-rule':!getRuleLabel(rule)}\">\n                <div class=\"leading-list\" [ngStyle]=\"rule.style\">\n                    {{rule.type == 'column' ? 'Col' : 'Ln'}}\n                </div>\n                <div class=\"description-list\" fxFlex fxLayout=\"column\">\n                    <span>{{getRuleTitle(rule)|translate}}</span>\n                    <span>{{getRuleSubTitle(rule)|translate}}{{getRuleSubTitle2(rule)}}</span>\n                </div>\n                <button mat-icon-button color=\"warn\" (click)=\"deleteStyleRule(i)\" [disabled]=\"!getRuleLabel(rule)\"\n                        class=\"trailing-list\">\n                    <mat-icon fontIcon=\"mdi-delete\" fontSet=\"mdi\"></mat-icon>\n                </button>\n            </div>\n\n        </mat-list-option>\n    </mat-selection-list>\n\n    <div *ngIf=\"availableStyleRules.length == 0\" class=\"ft-empty-content\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n        <span translate=\"table.no_rule\"></span>\n    </div>\n\n</div>\n\n\n<form #form=\"ngForm\" (submit)=\"validate()\" *ngIf=\"!showStyleRulesList\">\n\n\n    <mat-radio-group class=\"style-type\" [(ngModel)]=\"formStyle.type\" name=\"type\">\n        <mat-radio-button value=\"column\">{{'table.column'|translate}}</mat-radio-button>\n        <mat-radio-button value=\"row\">{{'table.row'|translate}}</mat-radio-button>\n    </mat-radio-group>\n\n    <div><!-- class=\"style-rules\"-->\n        <span class=\"label-style\">{{'table.apply_style'|translate}}</span>\n        <mat-form-field appearance=\"fill\" class=\"style-rules-field\">\n            <mat-select [(ngModel)]=\"selectedCol\" (ngModelChange)=\"filterColChanged()\" [(value)]=\"selectedCol\"\n                        name=\"column\"\n                        required>\n                <mat-option *ngFor=\"let col of viewColumns\" [value]=\"col\">\n                    {{col.label|translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n\n\n        <span class=\"label-style\">{{'table.style_rules_condition'|translate}}</span>\n        <mat-form-field appearance=\"fill\" class=\"style-rules-field\">\n            <mat-select [(ngModel)]=\"selectedFilter\" (ngModelChange)=\"generateTextField(selectedFilter)\"\n                        [(value)]=\"selectedFilter\" name=\"condition\" [disabled]=\"!selectedCol\" required>\n                <mat-option *ngFor=\"let op of resultFilter\" [value]=\"op\">\n                    {{op.label|translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n\n        <!--    create array of numberTextField and generate matformfield  [type]=\"selectedCol.type\"-->\n        <div *ngIf=\"selectedFilter\">\n            <mat-form-field appearance=\"outline\" color=\"primary\" class=\"style-rules-field\" [ngSwitch]=\"selectedCol.type\"\n                            *ngFor=\"let item of textFieldKeys; let i=index\">\n                <input matInput [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\" ftNumber\n                       *ngSwitchCase=\"'number'\" required>\n\n                <input *ngSwitchCase=\"'date'\" matInput required [placeholder]=\"'table.choose_date'|translate\"\n                       [matDatepicker]=\"picker\" ftDate [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\">\n                <mat-datepicker-toggle *ngSwitchCase=\"'date'\" matSuffix [for]=\"picker\">\n                    <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n                <!--<mat-datepicker #picker></mat-datepicker>-->\n\n\n                <input *ngSwitchCase=\"'datetime'\" matInput required [placeholder]=\"'table.choose_date'|translate\"\n                       [matDatepicker]=\"picker\" ftDatetime [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\">\n                <mat-datepicker-toggle *ngSwitchCase=\"'datetime'\" matSuffix [for]=\"picker\">\n                    <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n\n                <mat-datepicker #picker></mat-datepicker>\n\n                <ft-time-input *ngSwitchCase=\"'time'\" [(ngModel)]=\"textFieldValues[i]\"\n                               [name]=\"'data'+i\"></ft-time-input>\n\n\n                <input matInput [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\" *ngSwitchDefault required>\n\n            </mat-form-field>\n\n            <mat-form-field appearance=\"outline\" color=\"primary\" class=\"style-rules-field\"\n                            *ngIf=\"selectedCol['type']=='datetime'\">\n                <ft-time-input [(ngModel)]=\"time\" [name]=\"'time'\"></ft-time-input>\n            </mat-form-field>\n\n        </div>\n\n        <span class=\"label-style\">{{'table.formatting_style'|translate}}</span>\n        <div class=\"formatting-style-card\">\n            <div (click)=\"validate(false)\" class=\"formatting-style-header\"\n                 [style.font-weight]=\"formStyle.style.fontWeight\"\n                 [style.font-style]=\"formStyle.style.fontStyle\"\n                 [style.text-decoration-color]=\"formStyle.style.color\"\n                 [style.text-decoration]=\"getTextDecoration()\"\n                 [style.color]=\"formStyle.style.color\"\n                 [style.background]=\"formStyle.style.background\">\n                <span class=\"label-style\">{{'table.show_style'|translate}}</span>\n            </div>\n            <div class=\"formatting-style-actions\">\n                <button type=\"button\" mat-icon-button name=\"btnFontWeight\"\n                        (click)=\"formStyle.style.fontWeight=formStyle.style.fontWeight=='normal'?'bold':'normal'\">\n                    <mat-icon fontIcon=\"mdi-format-bold\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.fontWeight=='bold'}\"></mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnFontStyle\"\n                        (click)=\"formStyle.style.fontStyle=formStyle.style.fontStyle=='normal'?'italic':'normal'\">\n                    <mat-icon fontIcon=\"mdi-format-italic\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.fontStyle=='italic'}\"></mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnUnderline\"\n                        (click)=\"formStyle.isUnderline= !formStyle.isUnderline\">\n                    <mat-icon fontIcon=\"mdi-format-underline\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.isUnderline}\">\n                    </mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnStrikethrough\"\n                        (click)=\"formStyle.isStrikethrough= !formStyle.isStrikethrough\">\n                    <mat-icon fontIcon=\"mdi-format-strikethrough\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.isStrikethrough}\">\n                    </mat-icon>\n                </button>\n\n\n                <button type=\"button\" mat-icon-button name=\"btnColor\" class=\"ft-color-picker-preview\" ftColorPicker\n                        [(ngModel)]=\"formStyle.style.color\">\n                    <mat-icon fontIcon=\"mdi-format-color-text\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.color && formStyle.style.color!='black'}\">\n                    </mat-icon>\n\n\n                    <button type=\"button\" mat-icon-button name=\"btnColorIcon\" class=\"badge-clear-color\"\n                            *ngIf=\"formStyle.style.color && formStyle.style.color!='black'\"\n                            (click)=\"$event.stopPropagation();formStyle.style.color='black'\"\n                            [hidden]=\"!(formStyle.style.color && formStyle.style.color!='black')\">\n                        <mat-icon fontIcon=\"mdi-close-circle\" fontSet=\"mdi\" color=\"warn\"></mat-icon>\n                    </button>\n\n                </button>\n\n                <button type=\"button\" mat-icon-button name=\"btnBackground\" class=\"ft-color-picker-preview\" ftColorPicker\n                        [(ngModel)]=\"formStyle.style.background\" #colorModel=\"ngModel\"\n                        [ngClass]=\"{'spacer':formStyle.style.color && formStyle.style.color!='black'}\">\n                    <mat-icon fontIcon=\"mdi-format-color-fill\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.background}\"\n                    ></mat-icon>\n\n                    <button type=\"button\" mat-icon-button name=\"btnBackgroundIcon\" *ngIf=\"formStyle.style.background\"\n                            [ftValueUnset]=\"colorModel\" class=\"badge-clear-color\"\n                            (click)=\"$event.stopPropagation(); $event.preventDefault()\">\n                        <mat-icon fontIcon=\"mdi-close-circle\" fontSet=\"mdi\" color=\"warn\"></mat-icon>\n                    </button>\n\n                </button>\n\n\n            </div>\n\n        </div>\n\n        <div *ngIf=\"formStyle.type == 'column' && ['text', 'badge','icon','boolean'].includes(selectedCol?.type)\">\n            <span class=\"label-style\">{{'table.display_mode'|translate}}</span>\n            <div>\n                <mat-button-toggle-group name=\"displayMode\" (change)=\"changeDisplayMode($event)\"\n                                         [(ngModel)]=\"formStyle.display_mode\">\n\n                    <mat-button-toggle value=\"text\" *ngIf=\"['text', 'badge'].includes(selectedCol.type)\">\n                        {{'table.mode_text'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"badge\" *ngIf=\"['text', 'badge'].includes(selectedCol.type)\">\n                        {{'table.mode_badge'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"icon\" *ngIf=\"['icon','boolean'].includes(selectedCol.type)\">\n                        {{'table.mode_icon'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"boolean\" *ngIf=\"selectedCol.type=='boolean'\"\n                    >{{'table.mode_boolean'|translate}}</mat-button-toggle>\n\n                </mat-button-toggle-group>\n            </div>\n            <button type=\"button\" mat-icon-button (click)=\"chooseIcon()\" *ngIf=\"formStyle.display_mode == 'icon'\"\n                    name=\"btnDisplayIcons\" matTooltip=\"{{'table.choose_icon'|translate}}\">\n                <mat-icon [fontIcon]=\"formStyle.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </div>\n\n        <div class=\"style-rules-actions\" align=\"end\">\n            <button mat-stroked-button color=\"primary\" type=\"submit\" [disabled]=\"form.invalid\">\n                <span>{{(modeEdit ? 'table.edit_view' : 'table.apply')|translate}}</span>\n            </button>\n            <button mat-stroked-button color=\"warn\" type=\"reset\" (click)=\"clearFilter()\">\n                <span translate=\"table.cancel\"></span>\n            </button>\n        </div>\n\n    </div>\n</form>\n", components: [{ type: i8.MatSelectionList, selector: "mat-selection-list", inputs: ["disableRipple", "tabIndex", "color", "compareWith", "disabled", "multiple"], outputs: ["selectionChange"], exportAs: ["matSelectionList"] }, { type: i8.MatListOption, selector: "mat-list-option", inputs: ["disableRipple", "checkboxPosition", "color", "value", "disabled", "selected"], outputs: ["selectedChange"], exportAs: ["matListOption"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i9$1.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { type: i9.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i12.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i12.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: i15.TimeInputComponent, selector: "ft-time-input", inputs: ["placeholder", "required", "disabled", "value", "min", "max", "step"] }, { type: i14$1.MatButtonToggle, selector: "mat-button-toggle", inputs: ["disableRipple", "aria-label", "aria-labelledby", "id", "name", "value", "tabIndex", "appearance", "checked", "disabled"], outputs: ["change"], exportAs: ["matButtonToggle"] }], directives: [{ type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i16.CdkDropListGroup, selector: "[cdkDropListGroup]", inputs: ["cdkDropListGroupDisabled"], exportAs: ["cdkDropListGroup"] }, { type: i16.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i16.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i15$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i18$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { type: i15$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i18$1.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i5$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i19.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i19.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i19.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i9$1.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { type: i19.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i19.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i19.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i15$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i15$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i15.InputDirective, selector: "input" }, { type: i18.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i15.NumberDirective, selector: "input[ftNumber]", inputs: ["min", "max", "ftNumber", "empty", "allowZero", "readonly", "fix", "ftStep"] }, { type: i19.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i15.DateDirective, selector: "input[ftDate]" }, { type: i12.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i9.MatSuffix, selector: "[matSuffix]" }, { type: i12.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i15$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { type: i15.ColorPickerDirective, selector: "input[ftColorPicker], button[ftColorPicker]" }, { type: i15.FormValueUnsetDirective, selector: "button[ftValueUnset]", inputs: ["ftValueUnset"] }, { type: i14$1.MatButtonToggleGroup, selector: "mat-button-toggle-group", inputs: ["appearance", "name", "vertical", "value", "multiple", "disabled"], outputs: ["valueChange", "change"], exportAs: ["matButtonToggleGroup"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], pipes: { "translate": i5$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: StyleRulesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-style-rules', host: {
                        class: 'ft-style-rules'
                    }, encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"showStyleRulesList\" cdkDropListGroup>\n\n    <mat-selection-list [multiple]=\"false\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n                        *ngIf=\"availableStyleRules.length > 0\" class=\"list-rules\">\n        <mat-list-option *ngFor=\"let rule of availableStyleRules; let i=index\" [value]=\"rule\" class=\"rule-option\"\n                         (click)=\"updateStyleRule(rule, i)\" cdkDragBoundary=\".list-rules\" cdkDrag>\n            <!-- [style.background]=\"'red'\"-->\n\n            <div fxLayout=\"row\" class=\"rule-item\" [ngClass]=\"{'disabled-rule':!getRuleLabel(rule)}\">\n                <div class=\"leading-list\" [ngStyle]=\"rule.style\">\n                    {{rule.type == 'column' ? 'Col' : 'Ln'}}\n                </div>\n                <div class=\"description-list\" fxFlex fxLayout=\"column\">\n                    <span>{{getRuleTitle(rule)|translate}}</span>\n                    <span>{{getRuleSubTitle(rule)|translate}}{{getRuleSubTitle2(rule)}}</span>\n                </div>\n                <button mat-icon-button color=\"warn\" (click)=\"deleteStyleRule(i)\" [disabled]=\"!getRuleLabel(rule)\"\n                        class=\"trailing-list\">\n                    <mat-icon fontIcon=\"mdi-delete\" fontSet=\"mdi\"></mat-icon>\n                </button>\n            </div>\n\n        </mat-list-option>\n    </mat-selection-list>\n\n    <div *ngIf=\"availableStyleRules.length == 0\" class=\"ft-empty-content\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n        <span translate=\"table.no_rule\"></span>\n    </div>\n\n</div>\n\n\n<form #form=\"ngForm\" (submit)=\"validate()\" *ngIf=\"!showStyleRulesList\">\n\n\n    <mat-radio-group class=\"style-type\" [(ngModel)]=\"formStyle.type\" name=\"type\">\n        <mat-radio-button value=\"column\">{{'table.column'|translate}}</mat-radio-button>\n        <mat-radio-button value=\"row\">{{'table.row'|translate}}</mat-radio-button>\n    </mat-radio-group>\n\n    <div><!-- class=\"style-rules\"-->\n        <span class=\"label-style\">{{'table.apply_style'|translate}}</span>\n        <mat-form-field appearance=\"fill\" class=\"style-rules-field\">\n            <mat-select [(ngModel)]=\"selectedCol\" (ngModelChange)=\"filterColChanged()\" [(value)]=\"selectedCol\"\n                        name=\"column\"\n                        required>\n                <mat-option *ngFor=\"let col of viewColumns\" [value]=\"col\">\n                    {{col.label|translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n\n\n        <span class=\"label-style\">{{'table.style_rules_condition'|translate}}</span>\n        <mat-form-field appearance=\"fill\" class=\"style-rules-field\">\n            <mat-select [(ngModel)]=\"selectedFilter\" (ngModelChange)=\"generateTextField(selectedFilter)\"\n                        [(value)]=\"selectedFilter\" name=\"condition\" [disabled]=\"!selectedCol\" required>\n                <mat-option *ngFor=\"let op of resultFilter\" [value]=\"op\">\n                    {{op.label|translate}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n\n        <!--    create array of numberTextField and generate matformfield  [type]=\"selectedCol.type\"-->\n        <div *ngIf=\"selectedFilter\">\n            <mat-form-field appearance=\"outline\" color=\"primary\" class=\"style-rules-field\" [ngSwitch]=\"selectedCol.type\"\n                            *ngFor=\"let item of textFieldKeys; let i=index\">\n                <input matInput [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\" ftNumber\n                       *ngSwitchCase=\"'number'\" required>\n\n                <input *ngSwitchCase=\"'date'\" matInput required [placeholder]=\"'table.choose_date'|translate\"\n                       [matDatepicker]=\"picker\" ftDate [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\">\n                <mat-datepicker-toggle *ngSwitchCase=\"'date'\" matSuffix [for]=\"picker\">\n                    <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n                <!--<mat-datepicker #picker></mat-datepicker>-->\n\n\n                <input *ngSwitchCase=\"'datetime'\" matInput required [placeholder]=\"'table.choose_date'|translate\"\n                       [matDatepicker]=\"picker\" ftDatetime [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\">\n                <mat-datepicker-toggle *ngSwitchCase=\"'datetime'\" matSuffix [for]=\"picker\">\n                    <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n\n                <mat-datepicker #picker></mat-datepicker>\n\n                <ft-time-input *ngSwitchCase=\"'time'\" [(ngModel)]=\"textFieldValues[i]\"\n                               [name]=\"'data'+i\"></ft-time-input>\n\n\n                <input matInput [(ngModel)]=\"textFieldValues[i]\" [name]=\"'data'+i\" *ngSwitchDefault required>\n\n            </mat-form-field>\n\n            <mat-form-field appearance=\"outline\" color=\"primary\" class=\"style-rules-field\"\n                            *ngIf=\"selectedCol['type']=='datetime'\">\n                <ft-time-input [(ngModel)]=\"time\" [name]=\"'time'\"></ft-time-input>\n            </mat-form-field>\n\n        </div>\n\n        <span class=\"label-style\">{{'table.formatting_style'|translate}}</span>\n        <div class=\"formatting-style-card\">\n            <div (click)=\"validate(false)\" class=\"formatting-style-header\"\n                 [style.font-weight]=\"formStyle.style.fontWeight\"\n                 [style.font-style]=\"formStyle.style.fontStyle\"\n                 [style.text-decoration-color]=\"formStyle.style.color\"\n                 [style.text-decoration]=\"getTextDecoration()\"\n                 [style.color]=\"formStyle.style.color\"\n                 [style.background]=\"formStyle.style.background\">\n                <span class=\"label-style\">{{'table.show_style'|translate}}</span>\n            </div>\n            <div class=\"formatting-style-actions\">\n                <button type=\"button\" mat-icon-button name=\"btnFontWeight\"\n                        (click)=\"formStyle.style.fontWeight=formStyle.style.fontWeight=='normal'?'bold':'normal'\">\n                    <mat-icon fontIcon=\"mdi-format-bold\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.fontWeight=='bold'}\"></mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnFontStyle\"\n                        (click)=\"formStyle.style.fontStyle=formStyle.style.fontStyle=='normal'?'italic':'normal'\">\n                    <mat-icon fontIcon=\"mdi-format-italic\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.fontStyle=='italic'}\"></mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnUnderline\"\n                        (click)=\"formStyle.isUnderline= !formStyle.isUnderline\">\n                    <mat-icon fontIcon=\"mdi-format-underline\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.isUnderline}\">\n                    </mat-icon>\n                </button>\n                <button type=\"button\" mat-icon-button name=\"btnStrikethrough\"\n                        (click)=\"formStyle.isStrikethrough= !formStyle.isStrikethrough\">\n                    <mat-icon fontIcon=\"mdi-format-strikethrough\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.isStrikethrough}\">\n                    </mat-icon>\n                </button>\n\n\n                <button type=\"button\" mat-icon-button name=\"btnColor\" class=\"ft-color-picker-preview\" ftColorPicker\n                        [(ngModel)]=\"formStyle.style.color\">\n                    <mat-icon fontIcon=\"mdi-format-color-text\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.color && formStyle.style.color!='black'}\">\n                    </mat-icon>\n\n\n                    <button type=\"button\" mat-icon-button name=\"btnColorIcon\" class=\"badge-clear-color\"\n                            *ngIf=\"formStyle.style.color && formStyle.style.color!='black'\"\n                            (click)=\"$event.stopPropagation();formStyle.style.color='black'\"\n                            [hidden]=\"!(formStyle.style.color && formStyle.style.color!='black')\">\n                        <mat-icon fontIcon=\"mdi-close-circle\" fontSet=\"mdi\" color=\"warn\"></mat-icon>\n                    </button>\n\n                </button>\n\n                <button type=\"button\" mat-icon-button name=\"btnBackground\" class=\"ft-color-picker-preview\" ftColorPicker\n                        [(ngModel)]=\"formStyle.style.background\" #colorModel=\"ngModel\"\n                        [ngClass]=\"{'spacer':formStyle.style.color && formStyle.style.color!='black'}\">\n                    <mat-icon fontIcon=\"mdi-format-color-fill\" fontSet=\"mdi\"\n                              [ngClass]=\"{'active-style':formStyle.style.background}\"\n                    ></mat-icon>\n\n                    <button type=\"button\" mat-icon-button name=\"btnBackgroundIcon\" *ngIf=\"formStyle.style.background\"\n                            [ftValueUnset]=\"colorModel\" class=\"badge-clear-color\"\n                            (click)=\"$event.stopPropagation(); $event.preventDefault()\">\n                        <mat-icon fontIcon=\"mdi-close-circle\" fontSet=\"mdi\" color=\"warn\"></mat-icon>\n                    </button>\n\n                </button>\n\n\n            </div>\n\n        </div>\n\n        <div *ngIf=\"formStyle.type == 'column' && ['text', 'badge','icon','boolean'].includes(selectedCol?.type)\">\n            <span class=\"label-style\">{{'table.display_mode'|translate}}</span>\n            <div>\n                <mat-button-toggle-group name=\"displayMode\" (change)=\"changeDisplayMode($event)\"\n                                         [(ngModel)]=\"formStyle.display_mode\">\n\n                    <mat-button-toggle value=\"text\" *ngIf=\"['text', 'badge'].includes(selectedCol.type)\">\n                        {{'table.mode_text'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"badge\" *ngIf=\"['text', 'badge'].includes(selectedCol.type)\">\n                        {{'table.mode_badge'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"icon\" *ngIf=\"['icon','boolean'].includes(selectedCol.type)\">\n                        {{'table.mode_icon'|translate}}</mat-button-toggle>\n                    <mat-button-toggle value=\"boolean\" *ngIf=\"selectedCol.type=='boolean'\"\n                    >{{'table.mode_boolean'|translate}}</mat-button-toggle>\n\n                </mat-button-toggle-group>\n            </div>\n            <button type=\"button\" mat-icon-button (click)=\"chooseIcon()\" *ngIf=\"formStyle.display_mode == 'icon'\"\n                    name=\"btnDisplayIcons\" matTooltip=\"{{'table.choose_icon'|translate}}\">\n                <mat-icon [fontIcon]=\"formStyle.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </div>\n\n        <div class=\"style-rules-actions\" align=\"end\">\n            <button mat-stroked-button color=\"primary\" type=\"submit\" [disabled]=\"form.invalid\">\n                <span>{{(modeEdit ? 'table.edit_view' : 'table.apply')|translate}}</span>\n            </button>\n            <button mat-stroked-button color=\"warn\" type=\"reset\" (click)=\"clearFilter()\">\n                <span translate=\"table.cancel\"></span>\n            </button>\n        </div>\n\n    </div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2$1.MomentDateAdapter }, { type: i15.GeneralPurposeService }, { type: i4$2.MatSnackBar }, { type: i5$1.TranslateService }]; }, propDecorators: { handleViewColumns: [{
                type: Input,
                args: ['viewColumns']
            }], addStyleRule: [{
                type: Input
            }], styleRules: [{
                type: Input
            }], styleRulesChange: [{
                type: Output
            }], addStyleRuleChange: [{
                type: Output
            }] } });

// const moment=moment_
class GenericViewComponent {
    constructor(translateService, dialog, ftViewService) {
        this.translateService = translateService;
        this.dialog = dialog;
        this.ftViewService = ftViewService;
        this.expandedStyleRule = false;
        this.expandedFilter = false;
        this.viewTrackByFn = trackByFn('id');
        this.initialQuery = null;
        this.displayedColumns = [];
        this.viewChange = new EventEmitter();
        this.queryChange = new EventEmitter();
        this.currentStyleRulesChange = new EventEmitter();
        this.isFocused = false;
        this.key = '';
        this.filterColumns = [];
        this.views = [];
        this.viewColumns = [];
        this.currentViewColumns = [];
        this.systemColumns = [];
        this.showViewColumns = false;
        this.tableConfig = null;
        this.compareOperatorsHandler = compareOperators;
        this.getOperatorsHandler = getOperators;
        this.query = [];
        this.configFilters = [];
        this.currentFilter = null;
        this.selectedIdx = null;
        this.compareWithView = (o1, o2) => {
            return o1.id === o2.id;
        };
    }
    set handleViewDefinition(settings) {
        this.viewDefinition = settings;
        this.initView();
    }
    set handleCurrentView(value) {
        if (value) {
            this.currentView = value;
        }
    }
    set handleDisplayedColumns(value) {
        if (value) {
            this.displayedColumns = value;
        }
    }
    set currentQuery(values) {
        this.initialQuery = values;
        forEach(this.initialQuery, (e) => {
            const idx = findIndex(this.filterColumns, (q) => {
                return q.key === e.key;
            });
            if (idx > -1) {
                this.filterColumns[idx] = assignIn(this.filterColumns[idx], e, { showFilter: true, isFilter: true });
            }
        });
        this.applyFilter();
    }
    get currentQuery() {
        return this.initialQuery;
    }
    set currentStyleRules(rules) {
        var _a;
        this.styleRules = rules !== null && rules !== void 0 ? rules : [];
        this.showAddRuleBtn = (_a = this.showAddRuleBtn) !== null && _a !== void 0 ? _a : rules.length > 0;
    }
    ngOnInit() {
    }
    initView() {
        this.currentViewColumns = this.viewColumns = get(this.viewDefinition, 'viewColumns');
        this.initFilterColumns();
        this.ftViewService.getConfig(this.viewDefinition.model).subscribe(data => {
            if (data) {
                this.initConfig(data);
            }
        });
    }
    initConfig(data) {
        this.tableConfig = data;
        this.views = data.views;
        this.configFilters = this.tableConfig.filters;
    }
    initFilterColumns() {
        this.filterColumns = chain(this.viewDefinition.viewColumns)
            .concat(this.viewDefinition.systemColumns)
            .cloneDeep()
            .reject((e) => {
            return get(e, 'unsearchable') || get(e, 'key') === 'actions';
        })
            .map((e) => {
            return assignIn(e, {
                value: null,
                operator: first(this.getOperatorsHandler(e.type)),
                isFilter: false,
                showFilter: true,
                logical_operator: 'and'
            });
        })
            .value();
    }
    onSearch(key) {
        this.filterColumns = map(this.filterColumns, (e) => {
            return !chain(this.translateService.instant(e.label))
                .lowerCase()
                .startsWith(lowerCase(key))
                .value() ? assignIn(e, { showFilter: false }) : assignIn(e, { showFilter: true });
        });
    }
    handleNoFilter() {
        return every(this.filterColumns, ['showFilter', false]);
    }
    handleView(obj) {
        this.dialog.open(ViewDialogComponent, assignIn(LARGE_DIALOG, {
            data: {
                viewColumns: this.viewDefinition.viewColumns,
                namespace: this.viewNamespace,
                model: this.viewDefinition.model,
                tableConfig: this.tableConfig,
                viewId: get(obj, 'id')
            }
        }))
            .afterClosed().subscribe((data) => {
            if (data) {
                this.currentViewChange({ value: data });
                let idx;
                idx = chain(get(this.tableConfig, 'views'))
                    .findIndex({ name: get(data, 'name') })
                    .value();
                idx === -1 ? this.views.push(data) : this.views[idx] = data;
            }
        });
    }
    currentViewChange(ev) {
        if (!isNil(ev.value)) {
            this.currentView = ev.value;
            this.viewChange.emit(this.currentView);
        }
    }
    handleColumnLabel(key) {
        return get(find(this.viewColumns, { key: key }), 'label');
    }
    drop(event) {
        moveItemInArray(this.currentView.columns, event.previousIndex, event.currentIndex);
        this.handleViewUpdate();
    }
    handleColumnShown(c, ev) {
        let ns_showIn = findIndex(c.show_in, { name: this.viewNamespace });
        if (ns_showIn > -1) {
            update(c, `show_in[${findIndex(c.show_in, { name: this.viewNamespace })}].allow`, (e) => {
                return ev.checked;
            });
        }
        else {
            c.show_in.push({ name: this.viewNamespace, allow: ev.checked });
        }
        this.handleViewUpdate();
    }
    checkShowState(c) {
        return chain(find(get(c, 'show_in'), { name: this.viewNamespace })).get('allow', true).value();
    }
    handleViewUpdate() {
        this.ftViewService.handleView(this.currentView).subscribe(data => this.viewChange.emit(data));
    }
    applyFilter(queryFilter) {
        if (queryFilter) {
            this.currentFilter = queryFilter;
            forEach(queryFilter.query, (q) => {
                let idx;
                idx = findIndex(this.filterColumns, { key: q.key });
                if (idx > -1) {
                    update(this.filterColumns, `[${idx}]`, (e) => {
                        return assignIn(e, {
                            isFilter: true,
                            showFilter: true,
                            logical_operator: q.logical_operator,
                            operator: q.operator,
                            value: q.value
                        });
                    });
                }
            });
        }
        this.query = filter(this.filterColumns, (e) => {
            return e.isFilter && !isNil(e.value);
        });
        if (!isEmpty(this.query)) {
            this.queryChange.emit(this.query);
        }
    }
    saveFilter(e, isNew = false) {
        e.stopPropagation();
        if (isNew) {
            this.dialog.open(FilterDialogComponent, assignIn(SMALL_DIALOG, { data: { names: map(this.tableConfig.filters, 'name') } }))
                .afterClosed().subscribe(data => {
                if (this.query && data) {
                    this.tableConfig.filters.push({ name: data, query: this.query });
                    this.ftViewService.updateConfig({
                        id: this.tableConfig.id,
                        filters: this.tableConfig.filters
                    }).subscribe(() => {
                        noop();
                    });
                }
            });
        }
        else {
            update(this.tableConfig.filters, `[${findIndex(this.tableConfig.filters, { name: this.currentFilter.name })}].query`, (f) => {
                return this.query;
            });
            this.ftViewService.updateConfig({
                id: this.tableConfig.id,
                filters: this.tableConfig.filters
            }).subscribe(data => {
                noop();
            });
        }
    }
    clearFilter() {
        this.initFilterColumns();
        this.query = [];
        this.currentFilter = null;
        this.queryChange.emit([]);
    }
    allowFilter() {
        return !chain(this.filterColumns).filter((e) => {
            return e.isFilter && (!isNil(e.value) && e.type !== 'boolean');
        }).isEmpty().value();
    }
    handleStyleChange(e) {
        this.currentStyleRulesChange.emit(e);
    }
    handleAddRuleChange(showAddBtn) {
        this.showAddRuleBtn = showAddBtn;
    }
    addStyleRule() {
        this.showAddRuleBtn = false;
    }
    handleBetweenDate(column, v, ev) {
        if (ev) {
            column[v] = moment(ev).format('Y-MM-DD');
            column.value = column.operator == '$between' ? `${column.value_1 || ''}_${column.value_2 || ''}` : column.value_1;
        }
    }
}
GenericViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericViewComponent, deps: [{ token: i5$1.TranslateService }, { token: i1$1.MatDialog }, { token: FtViewService }], target: i0.ɵɵFactoryTarget.Component });
GenericViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: GenericViewComponent, selector: "ft-generic-view", inputs: { viewNamespace: ["namespace", "viewNamespace"], currentView: ["view", "currentView"], handleViewDefinition: ["viewSettings", "handleViewDefinition"], handleCurrentView: ["currentView", "handleCurrentView"], handleDisplayedColumns: ["columns", "handleDisplayedColumns"], currentQuery: "currentQuery", currentStyleRules: "currentStyleRules" }, outputs: { viewChange: "viewChange", queryChange: "queryChange", currentStyleRulesChange: "currentStyleRulesChange" }, ngImport: i0, template: "<div fxLayout=\"row\" class=\"ft-view-header\">\n    <mat-select fxFlex=\"nogrow\" [(ngModel)]=\"currentView\" (selectionChange)=\"currentViewChange($event)\"\n                [compareWith]=\"compareWithView\">\n        <mat-select-trigger>\n            {{currentView.name}}\n            <span fxFlex></span>\n\n            <button type=\"button\" mat-icon-button (click)=\"$event.stopPropagation();handleView()\"\n                    [matTooltip]=\"'table.create_new_view' | translate\" class=\"btn-expansion\">\n                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-table\"></mat-icon>\n            </button>\n            <button type=\"button\" color=\"primary\" mat-icon-button\n                    (click)=\"$event.stopPropagation();handleView(currentView)\"\n                    [disabled]=\"!currentView || currentView['is_system']\"\n                    [matTooltip]=\"'table.edit_view' | translate\" class=\"btn-expansion\">\n                <mat-icon style=\"height: 21px;  line-height: 24.5px;\" fontSet=\"mdi\"\n                          fontIcon=\"mdi-table-edit\"></mat-icon>\n            </button>\n\n        </mat-select-trigger>\n        <mat-option *ngFor=\"let view of views \" [value]=\"view\">\n            {{view.name}}\n        </mat-option>\n    </mat-select>\n</div>\n<div fxLayout=\"column\" fxFlex class=\"ft-view-container ft-content no-padding\" [class.ft-content-margin]=\"false\">\n    <div fxLayout=\"column\" fxFlex>\n        <mat-accordion displayMode=\"flat\" [multi]=\"true\">\n            <mat-expansion-panel class=\"mat-elevation-z0\" expanded=\"false\" (opened)=\"expandedFilter=true\"\n                                 (closed)=\"expandedFilter=false\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.filterBy'|translate}}</span>\n                    </mat-panel-title>\n                    <mat-panel-description *ngIf=\"expandedFilter && allowFilter()\">\n                        <button type=\"button\" [disabled]=\"!currentFilter\" color=\"primary\" mat-icon-button\n                                (click)=\"saveFilter($event)\" class=\"btn-expansion\"\n                                [matTooltip]=\"'table.update_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-find-replace\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"!allowFilter()\" color=\"primary\" mat-icon-button\n                                (click)=\"saveFilter($event, true)\" class=\"btn-expansion\"\n                                [matTooltip]=\"'table.save_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify-plus\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"query.length<=0\" class=\"btn-expansion\" color=\"warn\"\n                                mat-icon-button\n                                (click)=\"$event.stopPropagation();clearFilter(); selectedIdx=null\"\n                                [matTooltip]=\"'table.clear_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-remove-outline\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"!allowFilter()\" class=\"btn-expansion\" color=\"primary\"\n                                mat-icon-button\n                                (click)=\"$event.stopPropagation();applyFilter()\"\n                                [matTooltip]=\"'table.apply_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-outline\"></mat-icon>\n                        </button>\n                    </mat-panel-description>\n\n                </mat-expansion-panel-header>\n                <mat-list *ngIf=\"!showViewColumns\" fxFlex>\n                    <mat-list-item *ngIf=\"handleNoFilter()\">\n                        <h4 matSubheader color=\"error\">{{'table.no_item_found'|translate}}</h4>\n                    </mat-list-item>\n                    <ng-container *ngFor=\"let column of filterColumns; let last=last;\">\n                        <ng-template [ngIf]=\"column.showFilter\">\n                            <mat-checkbox mat-subheader color=\"primary\" [(ngModel)]=\"column.isFilter\">{{column.label\n                                |translate}}\n                            </mat-checkbox>\n                            <mat-list-item *ngIf=\"column.isFilter && column.type!='boolean'\">\n                                <mat-form-field mat-line floatLabel=\"never\">\n                                    <mat-select [(ngModel)]=\"column.operator\"\n                                                [compareWith]=\"compareOperatorsHandler\">\n                                        <mat-option\n                                                *ngFor=\"let operator of getOperatorsHandler(column.type)\"\n                                                [value]=\"operator\">\n                                            {{'table.' + column.type + '_' + operator|translate}}\n                                        </mat-option>\n                                    </mat-select>\n                                </mat-form-field>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.isFilter && column.type!='boolean'\">\n                                <ng-container [ngSwitch]=\"column.type\">\n                                    <mat-form-field *ngSwitchCase=\"'text'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput placeholder=\"{{'table.write_here'|translate}}\"\n                                               [(ngModel)]=\"column.value\">\n                                    </mat-form-field>\n                                    <mat-form-field *ngSwitchCase=\"'number'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput ftNumber=\"'float'\"\n                                               [(ngModel)]=\"column.value\">\n                                    </mat-form-field>\n\n                                    <mat-form-field *ngSwitchCase=\"'date'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput ftDate [matDatepicker]=\"column_date\"\n                                               [placeholder]=\"column.operator=='$between'? ('table.from_date' |translate):''\"\n                                               [ngModel]=\"column.value_1\"\n                                               (ngModelChange)=\"handleBetweenDate(column,'value_1',$event)\">\n                                        <mat-datepicker-toggle matSuffix [for]=\"column_date\">\n                                            <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                      fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                        </mat-datepicker-toggle>\n                                        <mat-datepicker #column_date></mat-datepicker>\n                                    </mat-form-field>\n\n                                </ng-container>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.type=='date' && column.operator=='$between'\">\n                                <ng-container>\n                                    <mat-form-field floatLabel=\"never\" mat-line class=\"to_date\">\n                                        <input matInput ftDate [matDatepicker]=\"column_date2\"\n                                               [placeholder]=\"'table.to_date'|translate\"\n                                               (ngModelChange)=\"handleBetweenDate(column,'value_2',$event)\"\n                                               [ngModel]=\"column.value_2\">\n                                        <mat-datepicker-toggle matSuffix [for]=\"column_date2\">\n                                            <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                      fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                        </mat-datepicker-toggle>\n                                        <mat-datepicker #column_date2></mat-datepicker>\n                                    </mat-form-field>\n                                </ng-container>\n                            </mat-list-item>\n                            <div class=\"ft-filter-separator\" *ngIf=\"!last && column.isFilter\">\n                                <hr class=\"hr-separator\">\n                                <div class=\"operator-separator\">\n                                    <button type=\"button\" mat-raised-button class=\"mat-primary\"\n                                            (click)=\"column.logical_operator=='or' ? column.logical_operator='and': column.logical_operator='or' \">\n                                        <span>{{'table.' + column.logical_operator|translate}}</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </ng-template>\n                    </ng-container>\n                </mat-list>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.saved_filters'|translate}}</span>\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <mat-action-list *ngIf=\"configFilters.length>0\">\n                    <button type=\"button\" *ngFor=\"let filter of configFilters; let idx=index;\" mat-list-item\n                            [ngClass]=\"{'selected-item':selectedIdx==idx}\"\n                            (click)=\"applyFilter(filter); selectedIdx=idx; \">\n                        <span fxFlex>{{filter.name}}</span>\n                        <span fxFlex></span>\n                        <mat-icon *ngIf=\"selectedIdx==idx\" color=\"primary\" fontSet=\"mdi\"\n                                  fontIcon=\"mdi-check-circle-outline\"></mat-icon>\n                    </button>\n                </mat-action-list>\n                <span *ngIf=\"configFilters.length==0\" matSubheader\n                      class=\"ft-error\">{{'table.no_filter_saved'|translate}}</span>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\" (opened)=\"expandedStyleRule=true\"\n                                 (closed)=\"expandedStyleRule=false\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.style_rules'|translate}}</span>\n                    </mat-panel-title>\n                    <mat-panel-description>\n                        <button type=\"button\" mat-icon-button color=\"primary\" class=\"btn-expansion\"\n                                *ngIf=\"expandedStyleRule && showAddRuleBtn\"\n                                (click)=\"$event.stopPropagation();addStyleRule();\"\n                                [matTooltip]=\"'table.add_rule' | translate\">\n                            <mat-icon fontIcon=\"mdi-plus\" fontSet=\"mdi\"></mat-icon>\n                        </button>\n                    </mat-panel-description>\n                </mat-expansion-panel-header>\n                <ft-style-rules [viewColumns]=\"displayedColumns\"\n                                [styleRules]=\"styleRules\" (styleRulesChange)=\"handleStyleChange($event)\"\n                                [addStyleRule]=\"showAddRuleBtn\"\n                                (addStyleRuleChange)=\"handleAddRuleChange($event)\"></ft-style-rules>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.update_columns'|translate}}</span>\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div cdkDropList (cdkDropListDropped)=\"drop($event)\" class=\"drag-list\">\n                    <mat-checkbox mat-subheader [checked]=\"checkShowState(column)\" class=\"drag-box\"\n                                  (change)=\"handleColumnShown(column, $event)\"\n                                  *ngFor=\"let column of currentView?.columns \" cdkDrag>\n                        {{handleColumnLabel(column.key) |translate}}\n                    </mat-checkbox>\n                </div>\n            </mat-expansion-panel>\n        </mat-accordion>\n    </div>\n</div>\n\n", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}.ft-view-header{flex:none;transition:all .25s cubic-bezier(.4,0,.2,1);border-bottom:1px solid #eceff1;background-color:#eceff11a}.ft-view-header.focused{background:rgba(236,239,241,.3)}.ft-view-header>.mat-icon,.ft-view-header>.mat-icon-button{width:29px;height:29px;margin:3px 0}.ft-view-header>.mat-icon{text-align:center;line-height:29px}.ft-view-header .mat-icon{transition:color .28s cubic-bezier(.4,0,.2,1)}.ft-view-header>mat-select{border:none;outline:none;font-size:15px;font-weight:500;background:inherit;margin:10px 6px}.mat-list{width:100%}.mat-list>span{font-size:15px}.mat-list .mat-list-item{height:36px}.mat-list .mat-list-item .to_date{flex:1 1 100%}.mat-list>button.mat-list-item{margin-left:0}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.drag-box:last-child{border:none}.drag-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.drag-list .mat-checkbox{padding:8px 16px}.mat-accordion .mat-expansion-panel:last-of-type{border-bottom-right-radius:0;border-bottom-left-radius:0;box-shadow:none}.mat-accordion .mat-expansion-panel{border-bottom:1px solid #cfd8dc}.mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-body{padding:0}.ft-error{color:red;justify-content:center}.mat-expansion-panel-header{padding:0 12px}.ft-filter-separator{margin:8px 0 0;position:relative;text-align:center;z-index:0;display:flex;flex-direction:column}.ft-filter-separator .hr-separator{border-top:none;border-bottom:1px solid #eceff1;margin:0;position:relative;top:.88em;z-index:5}.ft-filter-separator .operator-separator{color:#3d3c40;display:inline-block;position:relative;z-index:5}.ft-filter-separator .operator-separator .mat-raised-button{margin:0;height:26px;min-height:26px;min-width:20px;line-height:26px;padding:0 8px}.mat-action-list>button.selected-item{background:rgba(0,0,0,.07)}.mat-action-list>button.mat-list-item:nth-child(odd){background:rgba(0,0,0,.03)}.btn-expansion{width:24px;height:24px;font-size:24px;line-height:24px}.mat-expansion-panel-header-title{overflow:hidden}.mat-expansion-panel-header-title span{overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis;font-weight:500}.mat-expansion-panel-header-title,.mat-expansion-panel-header-description,mat-select-trigger{align-items:center;margin-right:unset}.mat-expansion-panel-header-description{width:64px}\n"], components: [{ type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i11.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i8$1.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { type: i8$1.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { type: i8.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { type: i8.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { type: i5$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { type: i9.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i12.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i12.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: StyleRulesComponent, selector: "ft-style-rules", inputs: ["viewColumns", "addStyleRule", "styleRules"], outputs: ["styleRulesChange", "addStyleRuleChange"] }], directives: [{ type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i19.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i19.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i4$1.MatSelectTrigger, selector: "mat-select-trigger" }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i8$1.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { type: i8$1.MatExpansionPanelTitle, selector: "mat-panel-title" }, { type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i8$1.MatExpansionPanelDescription, selector: "mat-panel-description" }, { type: i8.MatListSubheaderCssMatStyler, selector: "[mat-subheader], [matSubheader]" }, { type: i11.MatLine, selector: "[mat-line], [matLine]" }, { type: i15$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i15$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i15.InputDirective, selector: "input" }, { type: i18.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i19.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i15.NumberDirective, selector: "input[ftNumber]", inputs: ["min", "max", "ftNumber", "empty", "allowZero", "readonly", "fix", "ftStep"] }, { type: i15.DateDirective, selector: "input[ftDate]" }, { type: i12.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i9.MatSuffix, selector: "[matSuffix]" }, { type: i12.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i15$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i18$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { type: i16.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i16.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }], pipes: { "translate": i5$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-generic-view', template: "<div fxLayout=\"row\" class=\"ft-view-header\">\n    <mat-select fxFlex=\"nogrow\" [(ngModel)]=\"currentView\" (selectionChange)=\"currentViewChange($event)\"\n                [compareWith]=\"compareWithView\">\n        <mat-select-trigger>\n            {{currentView.name}}\n            <span fxFlex></span>\n\n            <button type=\"button\" mat-icon-button (click)=\"$event.stopPropagation();handleView()\"\n                    [matTooltip]=\"'table.create_new_view' | translate\" class=\"btn-expansion\">\n                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-table\"></mat-icon>\n            </button>\n            <button type=\"button\" color=\"primary\" mat-icon-button\n                    (click)=\"$event.stopPropagation();handleView(currentView)\"\n                    [disabled]=\"!currentView || currentView['is_system']\"\n                    [matTooltip]=\"'table.edit_view' | translate\" class=\"btn-expansion\">\n                <mat-icon style=\"height: 21px;  line-height: 24.5px;\" fontSet=\"mdi\"\n                          fontIcon=\"mdi-table-edit\"></mat-icon>\n            </button>\n\n        </mat-select-trigger>\n        <mat-option *ngFor=\"let view of views \" [value]=\"view\">\n            {{view.name}}\n        </mat-option>\n    </mat-select>\n</div>\n<div fxLayout=\"column\" fxFlex class=\"ft-view-container ft-content no-padding\" [class.ft-content-margin]=\"false\">\n    <div fxLayout=\"column\" fxFlex>\n        <mat-accordion displayMode=\"flat\" [multi]=\"true\">\n            <mat-expansion-panel class=\"mat-elevation-z0\" expanded=\"false\" (opened)=\"expandedFilter=true\"\n                                 (closed)=\"expandedFilter=false\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.filterBy'|translate}}</span>\n                    </mat-panel-title>\n                    <mat-panel-description *ngIf=\"expandedFilter && allowFilter()\">\n                        <button type=\"button\" [disabled]=\"!currentFilter\" color=\"primary\" mat-icon-button\n                                (click)=\"saveFilter($event)\" class=\"btn-expansion\"\n                                [matTooltip]=\"'table.update_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-find-replace\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"!allowFilter()\" color=\"primary\" mat-icon-button\n                                (click)=\"saveFilter($event, true)\" class=\"btn-expansion\"\n                                [matTooltip]=\"'table.save_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify-plus\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"query.length<=0\" class=\"btn-expansion\" color=\"warn\"\n                                mat-icon-button\n                                (click)=\"$event.stopPropagation();clearFilter(); selectedIdx=null\"\n                                [matTooltip]=\"'table.clear_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-remove-outline\"></mat-icon>\n                        </button>\n                        <button type=\"button\" [disabled]=\"!allowFilter()\" class=\"btn-expansion\" color=\"primary\"\n                                mat-icon-button\n                                (click)=\"$event.stopPropagation();applyFilter()\"\n                                [matTooltip]=\"'table.apply_filter' | translate\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-filter-outline\"></mat-icon>\n                        </button>\n                    </mat-panel-description>\n\n                </mat-expansion-panel-header>\n                <mat-list *ngIf=\"!showViewColumns\" fxFlex>\n                    <mat-list-item *ngIf=\"handleNoFilter()\">\n                        <h4 matSubheader color=\"error\">{{'table.no_item_found'|translate}}</h4>\n                    </mat-list-item>\n                    <ng-container *ngFor=\"let column of filterColumns; let last=last;\">\n                        <ng-template [ngIf]=\"column.showFilter\">\n                            <mat-checkbox mat-subheader color=\"primary\" [(ngModel)]=\"column.isFilter\">{{column.label\n                                |translate}}\n                            </mat-checkbox>\n                            <mat-list-item *ngIf=\"column.isFilter && column.type!='boolean'\">\n                                <mat-form-field mat-line floatLabel=\"never\">\n                                    <mat-select [(ngModel)]=\"column.operator\"\n                                                [compareWith]=\"compareOperatorsHandler\">\n                                        <mat-option\n                                                *ngFor=\"let operator of getOperatorsHandler(column.type)\"\n                                                [value]=\"operator\">\n                                            {{'table.' + column.type + '_' + operator|translate}}\n                                        </mat-option>\n                                    </mat-select>\n                                </mat-form-field>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.isFilter && column.type!='boolean'\">\n                                <ng-container [ngSwitch]=\"column.type\">\n                                    <mat-form-field *ngSwitchCase=\"'text'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput placeholder=\"{{'table.write_here'|translate}}\"\n                                               [(ngModel)]=\"column.value\">\n                                    </mat-form-field>\n                                    <mat-form-field *ngSwitchCase=\"'number'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput ftNumber=\"'float'\"\n                                               [(ngModel)]=\"column.value\">\n                                    </mat-form-field>\n\n                                    <mat-form-field *ngSwitchCase=\"'date'\" mat-line floatLabel=\"never\"\n                                                    fxFlex>\n                                        <input matInput ftDate [matDatepicker]=\"column_date\"\n                                               [placeholder]=\"column.operator=='$between'? ('table.from_date' |translate):''\"\n                                               [ngModel]=\"column.value_1\"\n                                               (ngModelChange)=\"handleBetweenDate(column,'value_1',$event)\">\n                                        <mat-datepicker-toggle matSuffix [for]=\"column_date\">\n                                            <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                      fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                        </mat-datepicker-toggle>\n                                        <mat-datepicker #column_date></mat-datepicker>\n                                    </mat-form-field>\n\n                                </ng-container>\n                            </mat-list-item>\n                            <mat-list-item *ngIf=\"column.type=='date' && column.operator=='$between'\">\n                                <ng-container>\n                                    <mat-form-field floatLabel=\"never\" mat-line class=\"to_date\">\n                                        <input matInput ftDate [matDatepicker]=\"column_date2\"\n                                               [placeholder]=\"'table.to_date'|translate\"\n                                               (ngModelChange)=\"handleBetweenDate(column,'value_2',$event)\"\n                                               [ngModel]=\"column.value_2\">\n                                        <mat-datepicker-toggle matSuffix [for]=\"column_date2\">\n                                            <mat-icon matDatepickerToggleIcon fontSet=\"mdi\"\n                                                      fontIcon=\"mdi-calendar-today\"></mat-icon>\n                                        </mat-datepicker-toggle>\n                                        <mat-datepicker #column_date2></mat-datepicker>\n                                    </mat-form-field>\n                                </ng-container>\n                            </mat-list-item>\n                            <div class=\"ft-filter-separator\" *ngIf=\"!last && column.isFilter\">\n                                <hr class=\"hr-separator\">\n                                <div class=\"operator-separator\">\n                                    <button type=\"button\" mat-raised-button class=\"mat-primary\"\n                                            (click)=\"column.logical_operator=='or' ? column.logical_operator='and': column.logical_operator='or' \">\n                                        <span>{{'table.' + column.logical_operator|translate}}</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </ng-template>\n                    </ng-container>\n                </mat-list>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.saved_filters'|translate}}</span>\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <mat-action-list *ngIf=\"configFilters.length>0\">\n                    <button type=\"button\" *ngFor=\"let filter of configFilters; let idx=index;\" mat-list-item\n                            [ngClass]=\"{'selected-item':selectedIdx==idx}\"\n                            (click)=\"applyFilter(filter); selectedIdx=idx; \">\n                        <span fxFlex>{{filter.name}}</span>\n                        <span fxFlex></span>\n                        <mat-icon *ngIf=\"selectedIdx==idx\" color=\"primary\" fontSet=\"mdi\"\n                                  fontIcon=\"mdi-check-circle-outline\"></mat-icon>\n                    </button>\n                </mat-action-list>\n                <span *ngIf=\"configFilters.length==0\" matSubheader\n                      class=\"ft-error\">{{'table.no_filter_saved'|translate}}</span>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\" (opened)=\"expandedStyleRule=true\"\n                                 (closed)=\"expandedStyleRule=false\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.style_rules'|translate}}</span>\n                    </mat-panel-title>\n                    <mat-panel-description>\n                        <button type=\"button\" mat-icon-button color=\"primary\" class=\"btn-expansion\"\n                                *ngIf=\"expandedStyleRule && showAddRuleBtn\"\n                                (click)=\"$event.stopPropagation();addStyleRule();\"\n                                [matTooltip]=\"'table.add_rule' | translate\">\n                            <mat-icon fontIcon=\"mdi-plus\" fontSet=\"mdi\"></mat-icon>\n                        </button>\n                    </mat-panel-description>\n                </mat-expansion-panel-header>\n                <ft-style-rules [viewColumns]=\"displayedColumns\"\n                                [styleRules]=\"styleRules\" (styleRulesChange)=\"handleStyleChange($event)\"\n                                [addStyleRule]=\"showAddRuleBtn\"\n                                (addStyleRuleChange)=\"handleAddRuleChange($event)\"></ft-style-rules>\n            </mat-expansion-panel>\n            <mat-expansion-panel class=\"mat-elevation-z0\">\n                <mat-expansion-panel-header collapsedHeight=\"48px\" expandedHeight=\"48px\">\n                    <mat-panel-title>\n                        <span>{{'table.update_columns'|translate}}</span>\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div cdkDropList (cdkDropListDropped)=\"drop($event)\" class=\"drag-list\">\n                    <mat-checkbox mat-subheader [checked]=\"checkShowState(column)\" class=\"drag-box\"\n                                  (change)=\"handleColumnShown(column, $event)\"\n                                  *ngFor=\"let column of currentView?.columns \" cdkDrag>\n                        {{handleColumnLabel(column.key) |translate}}\n                    </mat-checkbox>\n                </div>\n            </mat-expansion-panel>\n        </mat-accordion>\n    </div>\n</div>\n\n", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}.ft-view-header{flex:none;transition:all .25s cubic-bezier(.4,0,.2,1);border-bottom:1px solid #eceff1;background-color:#eceff11a}.ft-view-header.focused{background:rgba(236,239,241,.3)}.ft-view-header>.mat-icon,.ft-view-header>.mat-icon-button{width:29px;height:29px;margin:3px 0}.ft-view-header>.mat-icon{text-align:center;line-height:29px}.ft-view-header .mat-icon{transition:color .28s cubic-bezier(.4,0,.2,1)}.ft-view-header>mat-select{border:none;outline:none;font-size:15px;font-weight:500;background:inherit;margin:10px 6px}.mat-list{width:100%}.mat-list>span{font-size:15px}.mat-list .mat-list-item{height:36px}.mat-list .mat-list-item .to_date{flex:1 1 100%}.mat-list>button.mat-list-item{margin-left:0}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.drag-box:last-child{border:none}.drag-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.drag-list .mat-checkbox{padding:8px 16px}.mat-accordion .mat-expansion-panel:last-of-type{border-bottom-right-radius:0;border-bottom-left-radius:0;box-shadow:none}.mat-accordion .mat-expansion-panel{border-bottom:1px solid #cfd8dc}.mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-body{padding:0}.ft-error{color:red;justify-content:center}.mat-expansion-panel-header{padding:0 12px}.ft-filter-separator{margin:8px 0 0;position:relative;text-align:center;z-index:0;display:flex;flex-direction:column}.ft-filter-separator .hr-separator{border-top:none;border-bottom:1px solid #eceff1;margin:0;position:relative;top:.88em;z-index:5}.ft-filter-separator .operator-separator{color:#3d3c40;display:inline-block;position:relative;z-index:5}.ft-filter-separator .operator-separator .mat-raised-button{margin:0;height:26px;min-height:26px;min-width:20px;line-height:26px;padding:0 8px}.mat-action-list>button.selected-item{background:rgba(0,0,0,.07)}.mat-action-list>button.mat-list-item:nth-child(odd){background:rgba(0,0,0,.03)}.btn-expansion{width:24px;height:24px;font-size:24px;line-height:24px}.mat-expansion-panel-header-title{overflow:hidden}.mat-expansion-panel-header-title span{overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis;font-weight:500}.mat-expansion-panel-header-title,.mat-expansion-panel-header-description,mat-select-trigger{align-items:center;margin-right:unset}.mat-expansion-panel-header-description{width:64px}\n"] }]
        }], ctorParameters: function () { return [{ type: i5$1.TranslateService }, { type: i1$1.MatDialog }, { type: FtViewService }]; }, propDecorators: { viewNamespace: [{
                type: Input,
                args: ['namespace']
            }], currentView: [{
                type: Input,
                args: ['view']
            }], viewChange: [{
                type: Output
            }], queryChange: [{
                type: Output
            }], handleViewDefinition: [{
                type: Input,
                args: ['viewSettings']
            }], handleCurrentView: [{
                type: Input,
                args: ['currentView']
            }], handleDisplayedColumns: [{
                type: Input,
                args: ['columns']
            }], currentQuery: [{
                type: Input
            }], currentStyleRules: [{
                type: Input
            }], currentStyleRulesChange: [{
                type: Output
            }] } });

// const moment=moment_
function handleFormattingStyle(conditionKey, value, targetValue) {
    if (isUndefined(value) || isNil(value))
        return;
    switch (conditionKey) {
        case 'is_empty':
            return isEmpty(value);
        case 'is_not_empty':
            return !isEmpty(value);
        // ----------- text -----------
        case 'is_contains':
            return value.includes(targetValue);
        case 'not_contains':
            return !value.includes(targetValue);
        case 'start_with':
            return value.startsWith(targetValue);
        case 'end_with':
            return value.endsWith(targetValue);
        case 'exactly':
            return value === targetValue;
        case 'is_true':
            return value === true;
        case 'is_false':
            return value === false;
        // ----------- number -----------
        case 'greater':
            return value > targetValue;
        case 'greaterE':
            return value >= targetValue;
        case 'little':
            return value < targetValue;
        case 'littleE':
            return value <= targetValue;
        case 'equal':
            return value === targetValue;
        case 'n_equal':
            return value !== targetValue;
        case 'is_between':
            return value <= targetValue[1] && value >= targetValue[0];
        case 'not_between':
            return !(value <= targetValue[1] && value >= targetValue[0]);
        // ----------- Date & DateTime -----------
        case 'date_is':
            return moment(value).isSame(moment(targetValue));
        case 'is_before':
            return moment(value).isBefore(moment(targetValue));
        case 'is_after':
            return moment(value).isAfter(moment(targetValue));
        // ----------- Time -----------
        case 'time_is':
            return minutesOfDay(moment(value)) === minutesOfDay(moment(targetValue, INPUT_TIME_FORMAT));
        case 'time_is_before':
            return minutesOfDay(moment(value)) < minutesOfDay(moment(targetValue, INPUT_TIME_FORMAT));
        case 'time_is_after':
            return minutesOfDay(moment(value)) > minutesOfDay(moment(targetValue, INPUT_TIME_FORMAT));
        default:
            return null;
    }
}
function getFormattingRuleColumn(styleRules, element, column) {
    if (styleRules) {
        const groupedType = get(groupBy(styleRules, 'type'), 'column');
        const groupedTarget = groupBy(groupedType, 'target');
        const formattingStyleRules = Object.values(groupedTarget).map((rules) => {
            return Object.values(rules).map((rule) => {
                if (!element)
                    return;
                const value = handleCustomValue(element, column, rule.target);
                if (rule.target === column.key && !isUndefined(value))
                    return getConditionalFormattingRule(rule, value);
            });
        });
        return last(compact(flatten(formattingStyleRules)));
    }
}
function handleCustomValue(element, column, target) {
    return get(column, 'callBack') ? column.callBack(element) : chain(get(element, target)).thru(value => isFunction(value) ? value(element, column) : value).value();
}
function getConditionalFormattingRule(rule, value) {
    const prepareCondition = handleFormattingStyle(rule.condition, value, rule.target_value);
    if (prepareCondition)
        return rule;
}
function getStyleRuleColumn(styleRules, element, column) {
    return get(getFormattingRuleColumn(styleRules, element, column), 'style');
}
function getStyleRuleRow(styleRules, row) {
    if (styleRules) {
        const groupedType = get(groupBy(styleRules, 'type'), 'row');
        if (groupedType) {
            const styles = Object.values(groupedType).map((rule) => {
                if (!row)
                    return;
                const value = get(row, rule.target);
                return get(getConditionalFormattingRule(rule, value), 'style');
            });
            return last(compact(styles));
        }
    }
}

class BaseTableComponent extends DebounceSearch {
    constructor(sanitizer, ref) {
        super();
        this.sanitizer = sanitizer;
        this.ref = ref;
        this.dataSource = new MatTableDataSource([]);
        this.dataLength = 0;
        this.hasScroll = false;
        this.isFocused = false;
        this.selection = new SelectionModel(true, []);
        this.columnTrackByFn = trackByFn('key');
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 15, 20];
        this.hasSearch = true;
        this.hasFooter = false;
        this.footerData = {};
        this.trackByKey = 'id';
        this.selectable = false;
        this.hasPagination = false;
        this.lineClass = '';
        this.actions = [];
        this.selectedChange = new EventEmitter();
        this.lineClick = new EventEmitter();
        this.searchChange = new EventEmitter();
    }
    set handleHasSearch(value) {
        this.hasSearch = value;
    }
    set handleFooter(value) {
        this.hasFooter = value;
    }
    set handlePageSize(value) {
        this.pageSize = value;
    }
    set handlePageSizeOptions(value) {
        this.pageSizeOptions = value;
    }
    set selected(values) {
        let toSelect;
        toSelect = filter(values, (element) => {
            return !this.selection.isSelected(element);
        });
        if (!isEmpty(toSelect)) {
            this.selection.select(toSelect);
        }
    }
    set handleRemote(remote) {
        if (this.subscription) {
            this.dataSource.sort = null;
            this.subscription.unsubscribe();
        }
        if (remote) {
            merge(this.paginator.page, this.sort.sortChange, this.inputImmediateChange())
                .pipe(startWith({}), tap(data => isString(data) && this.paginator ? this.paginator.firstPage() : null), map$1(() => assign({ search: this.key }, this.getSortChange(), this.getPageChange())), distinctUntilChanged(), debounceTime(250))
                .subscribe(data => {
                console.log('search change');
                this.searchChange.emit(data);
            });
        }
        else {
            this.dataSource.sort = this.sort;
            this.subscription = this.searchSubscription();
        }
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    startSearch(key) {
        this.dataSource.filter = key.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.filterPredicate = (data, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) !== -1;
        };
        this.getScrollStatus();
    }
    hasItems() {
        return (this.dataSource.data.length > 0 && !this.dataSource.filter) || (this.dataSource.filter && this.dataSource.filteredData.length > 0);
    }
    getScrollStatus() {
        setTimeout(() => {
            this.hasScroll = this.innerTable.nativeElement.scrollHeight > this.innerTable.nativeElement.clientHeight;
            this.ref.markForCheck();
        });
    }
    handleValue(element, column) {
        return column.callBack ? column.callBack(element) : chain(get(element, column.key)).thru(value => isFunction(value) ? value(element, column) : value).value();
    }
    handleIconValue(element, column, styleRules = []) {
        if (!isEmpty(styleRules)) {
            const rule = getFormattingRuleColumn(styleRules, element, column);
            return (rule === null || rule === void 0 ? void 0 : rule.icon) || this.handleValue(element, column);
        }
        else {
            this.handleValue(element, column);
        }
    }
    handleHtmlValue(element, column) {
        const value = this.handleValue(element, column);
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    handleHeaderClass(column) {
        if (this.handleEditableColumn(null, column) && column.type === 'date') {
            return `ft-${column.type}-input-cell${column.actions ? '-' + column.actions.length : ''}`;
        }
        else {
            return `ft-${column.type}-cell${column.actions ? '-' + column.actions.length : ''}`;
        }
    }
    handleElementClass(element, column) {
        if (column.class) {
            return isFunction(column.class) ? get(column, 'class')(element) : column.class;
        }
        else {
            return '';
        }
    }
    handleCellClass(element, column) {
        return flatten([
            this.handleHeaderClass(column), this.handleElementClass(element, column)
        ]);
    }
    handleColumnStyle(element, column) {
        return isFunction(column.style) ? get(column, 'style')(element) : cloneDeep(column.style);
    }
    handleColumnTooltip(element, column) {
        return isFunction(column.tooltip) ? get(column, 'tooltip')(element) : column.tooltip;
    }
    trackByFnHandler() {
        return trackByFn(this.trackByKey);
    }
    handleActionClick(element, action, index, ev) {
        ev.stopPropagation();
        action.method(element, index, ev);
    }
    handleMultiActionClick(action, ev) {
        ev.stopPropagation();
        action.method(this.selection.selected, ev);
    }
    hasClickItem() {
        return this.lineClick.observers.length > 0;
    }
    handleRowClick(element) {
        if (this.selectable) {
            this.selection.toggle(element);
            this.selectedChange.emit(this.selection.selected);
        }
        else
            this.lineClick.emit(element);
    }
    isClickAbleClass(element) {
        return [
            this.selectable ? 'ft-selectable-row' : '',
            this.hasClickItem() ? 'ft-click-able-row' : '',
            this.selection.isSelected(element) ? 'ft-row-selected' : '',
        ];
    }
    getRowClass(element) {
        if (!isNil(this.lineClass)) {
            return isFunction(this.lineClass) ? get(this, 'lineClass')(element) : this.lineClass;
        }
        else {
            return '';
        }
    }
    handleRowClass(element) {
        return this.isClickAbleClass(element).concat(this.getRowClass(element));
    }
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(row));
        this.selectedChange.emit(this.selection.selected);
    }
    getSortChange() {
        if (isEmpty(this.sort.direction))
            return {};
        else {
            return {
                sortBy: this.sort.active,
                sortDirection: this.sort.direction,
            };
        }
    }
    getPageChange() {
        return {
            page: this.paginator.pageIndex,
            limit: this.paginator.pageSize ? this.paginator.pageSize : this.pageSize,
        };
    }
    handleEditableColumn(element, column) {
        return isFunction(column.editable) ? get(column, 'editable')(element) : column.editable;
    }
    handleActionBehaviour(element, action) {
        return isFunction(action.disabled) ? get(action, 'disabled')(element) : get(action, 'disabled', false);
    }
    handleActionHidden(element, action) {
        return isFunction(action.hidden) ? get(action, 'hidden')(element) : get(action, 'hidden', false);
    }
    handleFooterValue(element, column) {
        if (column.footer) {
            return isFunction(column.footer) ? get(column, 'footer')(element) : column.footer;
        }
        else if (!isEmpty(this.footerData)) {
            return get(this.footerData, `${get(column, 'key')}`);
        }
    }
}
BaseTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: BaseTableComponent, deps: [{ token: i1$2.DomSanitizer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BaseTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: BaseTableComponent, selector: "ft-base-table", inputs: { trackByKey: "trackByKey", selectable: "selectable", hasPagination: "hasPagination", lineClass: "lineClass", sortByKey: ["sortBy", "sortByKey"], actions: ["multiActions", "actions"], handleHasSearch: ["hasSearch", "handleHasSearch"], handleFooter: ["hasFooter", "handleFooter"], handlePageSize: ["pageSize", "handlePageSize"], handlePageSizeOptions: ["pageSizeOptions", "handlePageSizeOptions"], selected: "selected", handleRemote: ["remote", "handleRemote"] }, outputs: { selectedChange: "selectedChange", lineClick: "lineClick", searchChange: "searchChange" }, host: { properties: { "class.has-scroll": "hasScroll", "class.has-pagination": "hasPagination" }, classAttribute: "table-container" }, viewQueries: [{ propertyName: "sort", first: true, predicate: MatSort, descendants: true, static: true }, { propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true, static: true }, { propertyName: "innerTable", first: true, predicate: ["innerTable"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, animations: [
        SCALE_ANIMATION
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: BaseTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-base-table', template: '', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        SCALE_ANIMATION
                    ], host: {
                        class: 'table-container',
                        '[class.has-scroll]': 'hasScroll',
                        '[class.has-pagination]': 'hasPagination',
                    }, styles: [] }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { sort: [{
                type: ViewChild,
                args: [MatSort, { static: true }]
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator, { static: true }]
            }], innerTable: [{
                type: ViewChild,
                args: ['innerTable', { static: true }]
            }], trackByKey: [{
                type: Input
            }], selectable: [{
                type: Input
            }], hasPagination: [{
                type: Input
            }], lineClass: [{
                type: Input
            }], sortByKey: [{
                type: Input,
                args: ['sortBy']
            }], actions: [{
                type: Input,
                args: ['multiActions']
            }], handleHasSearch: [{
                type: Input,
                args: ['hasSearch']
            }], handleFooter: [{
                type: Input,
                args: ['hasFooter']
            }], handlePageSize: [{
                type: Input,
                args: ['pageSize']
            }], handlePageSizeOptions: [{
                type: Input,
                args: ['pageSizeOptions']
            }], selected: [{
                type: Input
            }], handleRemote: [{
                type: Input,
                args: ['remote']
            }], selectedChange: [{
                type: Output
            }], lineClick: [{
                type: Output
            }], searchChange: [{
                type: Output
            }] } });

class GenericBodyTableComponent extends BaseTableComponent {
    constructor(_sanitizer, _ref) {
        super(_sanitizer, _ref);
        this.selectionChange = new EventEmitter();
        this.extendedHandler = (i, e) => false;
    }
    set handleColumns(columns) {
        this.displayedColumns = columns;
        this.columnsItems = chain(columns).map('key').tap(columns => this.selectable ? columns.unshift('ft-multi-selection') : null).value();
        this.expandedColumnsItems = chain(columns).filter((e) => {
            return e.extended || e.key === 'actions';
        }).map('key').tap(columns => this.selectable ? columns.unshift('ft-multi-selection') : null).value();
    }
    set handleSource(observable) {
        this.subscription = observable.subscribe(data => {
            if (data) {
                if (isArray(data)) {
                    this.dataSource.data = data;
                }
                else {
                    this.dataSource.data = has(data, 'items') ? data.items : data;
                }
                this.dataLength = data.length;
                this.getScrollStatus();
            }
        });
    }
    ngOnInit() {
        this.dataSource.paginator = this.paginator;
    }
    compareWithHandler(o1, o2) {
        return isObject(o1) && isObject(o2) ? isEqual(get(o1, 'id', o1), get(o2, 'id', o2)) : o1 === o2;
    }
    handleColumnClick(element, column) {
        return isFunction(column.click) ? get(column, 'click')(element) : noop();
    }
    handleColumnDbClick(element, column) {
        return isFunction(column.dbClick) ? get(column, 'dbClick')(element) : noop();
    }
    handleColumnMax(element, column) {
        return isFunction(column.max) ? get(column, 'max')(element) : column.max;
    }
    handleColumnMin(element, column) {
        return isFunction(column.min) ? get(column, 'min')(element) : column.min;
    }
    handleActionClass(element, action) {
        return isFunction(action.class) ? get(action, 'class')(element) : get(action, 'class', '');
    }
    handleInputChange(element, column, value) {
        // fix ft_core Promise.resolve()
        if (!isNil(value))
            set(element, column['key'], value);
    }
    handleFooterActions(element, column) {
        return isFunction(column.footer) ? get(column, 'footer')(element) : column.footer || [];
    }
}
GenericBodyTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericBodyTableComponent, deps: [{ token: i1$2.DomSanitizer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
GenericBodyTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: GenericBodyTableComponent, selector: "ft-generic-body-table", inputs: { handleColumns: ["columns", "handleColumns"], handleSource: ["source", "handleSource"], extendedHandler: "extendedHandler" }, outputs: { selectionChange: "selectionChange" }, host: { properties: { "class.has-scroll": "hasScroll", "class.has-pagination": "hasPagination" }, classAttribute: "table-container" }, usesInheritance: true, ngImport: i0, template: "<div [ngBusy]=\"subscription\"></div>\n<div fxLayout=\"row\" class=\"ft-table-search-bar\" [class.focused]=\"isFocused\" *ngIf=\"hasSearch\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\" [class.mat-primary]=\"isFocused\"></mat-icon>\n\n    <input type=\"text\" fxFlex [value]='key' [ftAutoFocus]=\"false\" [placeholder]=\"'table.search' | translate\"\n           (focus)=\"isFocused = true\" (blur)=\"isFocused = false\" (input)=\"onSearch($event.target.value)\"/>\n\n    <button type=\"button\" mat-icon-button (click)=\"cancelSearch()\" color=\"warn\" *ngIf=\"key.length > 0\"\n            [@scaleAnimation]>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n    <ng-container *ngFor=\"let action of actions\">\n        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n            <button type=\"button\" mat-icon-button (click)=\"handleMultiActionClick(action, $event)\"\n                    *ngIf=\"!handleActionHidden(selection.selected, action)\"\n                    [ngClass]=\"action.class\"\n                    [disabled]=\"handleActionBehaviour(selection.selected, action) || (!selection.hasValue() && action.isMultipleSelection)\"\n                    [matTooltip]=\"action?.tooltip | translate\">\n                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </ng-template>\n    </ng-container>\n</div>\n<div class=\"inner-table-container\" #innerTable>\n    <mat-table [dataSource]=\"dataSource\" [trackBy]=\"trackByFnHandler()\" matSort [matSortActive]=\"sortByKey\"\n               [class.empty-table]=\"!hasItems()\">\n        <ng-container matColumnDef=\"ft-multi-selection\" *ngIf=\"selectable\">\n            <mat-header-cell *matHeaderCellDef class=\"ft-multi-selection\">\n                <mat-checkbox (change)=\"$event ? masterToggle() : null\"\n                              [checked]=\"selection.hasValue() && isAllSelected()\"\n                              [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-header-cell>\n            <mat-cell *matCellDef=\"let element\" class=\"ft-multi-selection\">\n                <mat-checkbox (click)=\"$event.stopPropagation()\"\n                              [checked]=\"selection.isSelected(element)\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-cell>\n        </ng-container>\n        <ng-container *ngFor=\"let column of displayedColumns;trackBy: columnTrackByFn\" [matColumnDef]=\"column.key\">\n            <mat-header-cell [ngClass]=\"handleCellClass(null, column)\" *matHeaderCellDef\n                             [mat-sort-header]=\"column?.sortBy\" [title]=\"column.label | translate\"\n                             [disabled]=\"!column?.sortBy\">\n                {{ column.label | translate}}\n            </mat-header-cell>\n            <mat-cell *matCellDef=\"let element; let i = index;\" [ngClass]=\"handleCellClass(element, column)\"\n                      [ngSwitch]=\"column.type\">\n                <ng-template [ngSwitchCase]=\"'text'\">\n                    <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           type=\"text\"\n                           [value]=\"handleValue(element, column)\"\n                           (change)=\"handleInputChange(element, column, $event.target.value)\"\n                           [required]=\"column?.required\"\n                           [placeholder]=\"'table.write_here'|translate\"/>\n                </ng-template>\n\n                <ng-template [ngSwitchCase]=\"'number'\">\n                        <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                    <!--[ftNumber]=\"column?.numberConfig\"           type=\"number\"-->\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           [ftNumber]=\"column?.numberConfig\"\n                           [ngModel]=\"handleValue(element, column)\"\n                           (ngModelChange)=\"handleInputChange(element, column, $event)\"\n                           (click)=\"handleColumnClick(element, column)\"\n                           (dblclick)=\"handleColumnDbClick(element, column)\"\n                           [max]=\"handleColumnMax(element,column)\"\n                           [min]=\"handleColumnMin(element,column)\"\n                           [required]=\"column?.required\"\n                           [placeholder]=\"'table.write_here'|translate\"/>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'date'\">\n                    <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDate}}</span>\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           (click)=\"handleColumnClick(element, column)\"\n                           (dblclick)=\"handleColumnDbClick(element, column)\"\n                           [matDatepicker]=\"picker\"\n                           [required]=\"column?.required\"\n                           [(ngModel)]=\"element[column['key']]\"\n                           ftDate\n                           [placeholder]=\"'table.choose_date'|translate\">\n                    <mat-datepicker-toggle *ngIf=\"handleEditableColumn(element,column)\" matSuffix\n                                           [for]=\"picker\">\n                        <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-menu-down\"></mat-icon>\n                    </mat-datepicker-toggle>\n                    <mat-datepicker #picker></mat-datepicker>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'time'\">\n                         <span class=\"ft-table-value-container\"\n                               [ngStyle]=\"handleColumnStyle(element, column)\">\n                             {{handleValue(element, column) | ftTime:column?.timeFormats}}\n                         </span>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'select'\">\n                    <mat-select [(ngModel)]=\"element[column['key']]\" [compareWith]=\"compareWithHandler\" [disabled]=\"!handleEditableColumn(element,column)\" [required]=\"column?.required\">\n                        <mat-option *ngFor=\"let v of column.source|async \" [value]=\"v\">\n                            {{v[column.selector]}}\n                        </mat-option>\n                    </mat-select>\n                </ng-template>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleValue(element, column)}}\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'html'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\"\n                      [innerHTML]=\"handleHtmlValue(element, column)\"></span>\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\"\n                          [fontIcon]=\" column?.callBack ? handleValue(element, column): column?.key\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                ></mat-icon>\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\"\n                          [fontIcon]=\"column?.icon? column?.icon:'mdi-checkbox-blank-circle'\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                          [ngClass]=\"{'ft-success': handleValue(element, column), 'mat-warn': !handleValue(element, column)}\">\n                </mat-icon>\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of column?.actions\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"handleActionClass(element, action)\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-cell>\n            <mat-footer-cell *matFooterCellDef=\"let element; let i = index;\" [ngSwitch]=\"column.type\"\n                             [ngClass]=\"handleCellClass(element, column)\">\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'date'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftDate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'time'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                             {{handleFooterValue(element, column) | ftTime:column?.timeFormats}}\n                         </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleFooterValue(element, column)}}\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleFooterValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\"\n                          [fontIcon]=\"handleFooterValue(element, column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                ></mat-icon>\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\"\n                          [fontIcon]=\"handleFooterValue(element, column) ? column?.icon:'mdi-checkbox-blank-circle'\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                          [ngClass]=\"{'ft-success': handleFooterValue(element, column), 'mat-warn': !handleFooterValue(element, column)}\">\n                </mat-icon>\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of handleFooterActions(element, column)\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"handleActionClass(element, action)\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-footer-cell>\n        </ng-container>\n        <mat-header-row *matHeaderRowDef=\"columnsItems; sticky: true\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: columnsItems;\" [ngClass]=\"isClickAbleClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\">\n        </mat-row>\n        <mat-row    *matRowDef=\"let row; columns: expandedColumnsItems; when: extendedHandler\"\n                 [ngClass]=\"isClickAbleClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\">\n        </mat-row>\n        <mat-footer-row *matFooterRowDef=\"columnsItems; sticky:true;\" [ngClass]=\"{'hidden':!hasFooter}\"></mat-footer-row>\n    </mat-table>\n</div>\n<div class=\"empty-table-cell mat-cell\" *ngIf=\"!hasItems()\">\n    {{'table.no_element_to_show' | translate}}\n</div>\n<mat-paginator [hidden]=\"!hasPagination\"\n               [pageSize]=\"pageSize\"\n               [length]=\"dataLength\"\n               [pageSizeOptions]=\"pageSizeOptions\"\n               showFirstLastButtons>\n</mat-paginator>\n", styles: [".mat-paginator[hidden]{display:none}\n"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4$3.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { type: i6$1.MatSortHeader, selector: "[mat-sort-header]", inputs: ["disabled", "mat-sort-header", "arrowPosition", "start", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { type: i12.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i12.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i10.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { type: i4$3.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i4$3.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { type: i4$3.MatFooterRow, selector: "mat-footer-row, tr[mat-footer-row]", exportAs: ["matFooterRow"] }, { type: i11$1.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }], directives: [{ type: i12$1.NgBusyDirective, selector: "[ngBusy]", inputs: ["ngBusy"], outputs: ["busyStart", "busyStop"] }, { type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i15.InputDirective, selector: "input" }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i15.AutoFocusDirective, selector: "[ftAutoFocus]", inputs: ["ftAutoFocus"] }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i15.AclDirective, selector: "[ftAcl]", inputs: ["ftAcl"] }, { type: i15$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i18$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i6$1.MatSort, selector: "[matSort]", inputs: ["matSortDisabled", "matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { type: i4$3.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i4$3.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i4$3.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i4$3.MatCellDef, selector: "[matCellDef]" }, { type: i4$3.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i15$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i15$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i15$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i18$1.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { type: i18.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i15.NumberDirective, selector: "input[ftNumber]", inputs: ["min", "max", "ftNumber", "empty", "allowZero", "readonly", "fix", "ftStep"] }, { type: i19.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i19.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i19.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i19.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i15.DateDirective, selector: "input[ftDate]" }, { type: i12.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i9.MatSuffix, selector: "[matSuffix]" }, { type: i12.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i4$3.MatFooterCellDef, selector: "[matFooterCellDef]" }, { type: i4$3.MatFooterCell, selector: "mat-footer-cell, td[mat-footer-cell]" }, { type: i4$3.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i4$3.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { type: i11.MatRipple, selector: "[mat-ripple], [matRipple]", inputs: ["matRippleColor", "matRippleUnbounded", "matRippleCentered", "matRippleRadius", "matRippleAnimation", "matRippleDisabled", "matRippleTrigger"], exportAs: ["matRipple"] }, { type: i4$3.MatFooterRowDef, selector: "[matFooterRowDef]", inputs: ["matFooterRowDef", "matFooterRowDefSticky"] }], pipes: { "translate": i5$1.TranslatePipe, "ftNumber": i15.NumberPipe, "ftDate": i15.DatePipe, "ftTime": i15.TimePipe, "async": i15$1.AsyncPipe, "ftFileSize": i15.FileSizePipe }, animations: [
        SCALE_ANIMATION
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericBodyTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-generic-body-table', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        SCALE_ANIMATION
                    ], host: {
                        class: 'table-container',
                        '[class.has-scroll]': 'hasScroll',
                        '[class.has-pagination]': 'hasPagination',
                    }, template: "<div [ngBusy]=\"subscription\"></div>\n<div fxLayout=\"row\" class=\"ft-table-search-bar\" [class.focused]=\"isFocused\" *ngIf=\"hasSearch\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\" [class.mat-primary]=\"isFocused\"></mat-icon>\n\n    <input type=\"text\" fxFlex [value]='key' [ftAutoFocus]=\"false\" [placeholder]=\"'table.search' | translate\"\n           (focus)=\"isFocused = true\" (blur)=\"isFocused = false\" (input)=\"onSearch($event.target.value)\"/>\n\n    <button type=\"button\" mat-icon-button (click)=\"cancelSearch()\" color=\"warn\" *ngIf=\"key.length > 0\"\n            [@scaleAnimation]>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n    <ng-container *ngFor=\"let action of actions\">\n        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n            <button type=\"button\" mat-icon-button (click)=\"handleMultiActionClick(action, $event)\"\n                    *ngIf=\"!handleActionHidden(selection.selected, action)\"\n                    [ngClass]=\"action.class\"\n                    [disabled]=\"handleActionBehaviour(selection.selected, action) || (!selection.hasValue() && action.isMultipleSelection)\"\n                    [matTooltip]=\"action?.tooltip | translate\">\n                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </ng-template>\n    </ng-container>\n</div>\n<div class=\"inner-table-container\" #innerTable>\n    <mat-table [dataSource]=\"dataSource\" [trackBy]=\"trackByFnHandler()\" matSort [matSortActive]=\"sortByKey\"\n               [class.empty-table]=\"!hasItems()\">\n        <ng-container matColumnDef=\"ft-multi-selection\" *ngIf=\"selectable\">\n            <mat-header-cell *matHeaderCellDef class=\"ft-multi-selection\">\n                <mat-checkbox (change)=\"$event ? masterToggle() : null\"\n                              [checked]=\"selection.hasValue() && isAllSelected()\"\n                              [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-header-cell>\n            <mat-cell *matCellDef=\"let element\" class=\"ft-multi-selection\">\n                <mat-checkbox (click)=\"$event.stopPropagation()\"\n                              [checked]=\"selection.isSelected(element)\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-cell>\n        </ng-container>\n        <ng-container *ngFor=\"let column of displayedColumns;trackBy: columnTrackByFn\" [matColumnDef]=\"column.key\">\n            <mat-header-cell [ngClass]=\"handleCellClass(null, column)\" *matHeaderCellDef\n                             [mat-sort-header]=\"column?.sortBy\" [title]=\"column.label | translate\"\n                             [disabled]=\"!column?.sortBy\">\n                {{ column.label | translate}}\n            </mat-header-cell>\n            <mat-cell *matCellDef=\"let element; let i = index;\" [ngClass]=\"handleCellClass(element, column)\"\n                      [ngSwitch]=\"column.type\">\n                <ng-template [ngSwitchCase]=\"'text'\">\n                    <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           type=\"text\"\n                           [value]=\"handleValue(element, column)\"\n                           (change)=\"handleInputChange(element, column, $event.target.value)\"\n                           [required]=\"column?.required\"\n                           [placeholder]=\"'table.write_here'|translate\"/>\n                </ng-template>\n\n                <ng-template [ngSwitchCase]=\"'number'\">\n                        <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                    <!--[ftNumber]=\"column?.numberConfig\"           type=\"number\"-->\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           [ftNumber]=\"column?.numberConfig\"\n                           [ngModel]=\"handleValue(element, column)\"\n                           (ngModelChange)=\"handleInputChange(element, column, $event)\"\n                           (click)=\"handleColumnClick(element, column)\"\n                           (dblclick)=\"handleColumnDbClick(element, column)\"\n                           [max]=\"handleColumnMax(element,column)\"\n                           [min]=\"handleColumnMin(element,column)\"\n                           [required]=\"column?.required\"\n                           [placeholder]=\"'table.write_here'|translate\"/>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'date'\">\n                    <span class=\"ft-table-value-container\" *ngIf=\"!handleEditableColumn(element,column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDate}}</span>\n                    <input *ngIf=\"handleEditableColumn(element,column)\" matInput\n                           (click)=\"handleColumnClick(element, column)\"\n                           (dblclick)=\"handleColumnDbClick(element, column)\"\n                           [matDatepicker]=\"picker\"\n                           [required]=\"column?.required\"\n                           [(ngModel)]=\"element[column['key']]\"\n                           ftDate\n                           [placeholder]=\"'table.choose_date'|translate\">\n                    <mat-datepicker-toggle *ngIf=\"handleEditableColumn(element,column)\" matSuffix\n                                           [for]=\"picker\">\n                        <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-menu-down\"></mat-icon>\n                    </mat-datepicker-toggle>\n                    <mat-datepicker #picker></mat-datepicker>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'time'\">\n                         <span class=\"ft-table-value-container\"\n                               [ngStyle]=\"handleColumnStyle(element, column)\">\n                             {{handleValue(element, column) | ftTime:column?.timeFormats}}\n                         </span>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'select'\">\n                    <mat-select [(ngModel)]=\"element[column['key']]\" [compareWith]=\"compareWithHandler\" [disabled]=\"!handleEditableColumn(element,column)\" [required]=\"column?.required\">\n                        <mat-option *ngFor=\"let v of column.source|async \" [value]=\"v\">\n                            {{v[column.selector]}}\n                        </mat-option>\n                    </mat-select>\n                </ng-template>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleValue(element, column)}}\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'html'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\"\n                      [innerHTML]=\"handleHtmlValue(element, column)\"></span>\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\"\n                          [fontIcon]=\" column?.callBack ? handleValue(element, column): column?.key\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                ></mat-icon>\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\"\n                          [fontIcon]=\"column?.icon? column?.icon:'mdi-checkbox-blank-circle'\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                          [ngClass]=\"{'ft-success': handleValue(element, column), 'mat-warn': !handleValue(element, column)}\">\n                </mat-icon>\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of column?.actions\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"handleActionClass(element, action)\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-cell>\n            <mat-footer-cell *matFooterCellDef=\"let element; let i = index;\" [ngSwitch]=\"column.type\"\n                             [ngClass]=\"handleCellClass(element, column)\">\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'date'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftDate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'time'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                             {{handleFooterValue(element, column) | ftTime:column?.timeFormats}}\n                         </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleFooterValue(element, column)}}\n                </span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleFooterValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\"\n                          [fontIcon]=\"handleFooterValue(element, column)\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                ></mat-icon>\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\"\n                          [fontIcon]=\"handleFooterValue(element, column) ? column?.icon:'mdi-checkbox-blank-circle'\"\n                          [ngStyle]=\"handleColumnStyle(element, column)\"\n                          [ngClass]=\"{'ft-success': handleFooterValue(element, column), 'mat-warn': !handleFooterValue(element, column)}\">\n                </mat-icon>\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of handleFooterActions(element, column)\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"handleActionClass(element, action)\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-footer-cell>\n        </ng-container>\n        <mat-header-row *matHeaderRowDef=\"columnsItems; sticky: true\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: columnsItems;\" [ngClass]=\"isClickAbleClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\">\n        </mat-row>\n        <mat-row    *matRowDef=\"let row; columns: expandedColumnsItems; when: extendedHandler\"\n                 [ngClass]=\"isClickAbleClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\">\n        </mat-row>\n        <mat-footer-row *matFooterRowDef=\"columnsItems; sticky:true;\" [ngClass]=\"{'hidden':!hasFooter}\"></mat-footer-row>\n    </mat-table>\n</div>\n<div class=\"empty-table-cell mat-cell\" *ngIf=\"!hasItems()\">\n    {{'table.no_element_to_show' | translate}}\n</div>\n<mat-paginator [hidden]=\"!hasPagination\"\n               [pageSize]=\"pageSize\"\n               [length]=\"dataLength\"\n               [pageSizeOptions]=\"pageSizeOptions\"\n               showFirstLastButtons>\n</mat-paginator>\n", styles: [".mat-paginator[hidden]{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { handleColumns: [{
                type: Input,
                args: ['columns']
            }], handleSource: [{
                type: Input,
                args: ['source']
            }], selectionChange: [{
                type: Output
            }], extendedHandler: [{
                type: Input
            }] } });

class PaginatorI18n {
    constructor(translate) {
        this.translate = translate;
    }
    getPaginatorIntl() {
        const paginatorConfig = new MatPaginatorIntl();
        paginatorConfig.itemsPerPageLabel = this.translate.instant('table.table_items_per_page_label');
        paginatorConfig.nextPageLabel = this.translate.instant('table.table_next_page_label');
        paginatorConfig.previousPageLabel = this.translate.instant('table.table_previous_page_label');
        paginatorConfig.firstPageLabel = this.translate.instant('table.table_first_page_label');
        paginatorConfig.lastPageLabel = this.translate.instant('table.table_last_page_label');
        paginatorConfig.getRangeLabel = this.getRangeLabel.bind(this);
        return paginatorConfig;
    }
    getRangeLabel(page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return this.translate.instant('table.range_page_label_1', { length });
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return this.translate.instant('table.range_page_label_2', {
            startIndex: startIndex + 1, endIndex, length
        });
    }
}

class BasicGenericViewTableComponent extends BaseTableComponent {
    constructor(_sanitizer, _ref) {
        super(_sanitizer, _ref);
        this.sheetToggle = null;
        this.exportExcel = null;
        this.paginateHandler = (ev) => noop();
        this.exportExcelHandler = new EventEmitter();
    }
    set handleColumns(columns) {
        this.displayedColumns = columns;
        this.columnsItems = chain(columns).map('key').tap(items => this.selectable ? items.unshift('ft-multi-selection') : null).value();
    }
    set handleSource(observable) {
        if (observable) {
            this.subscription = observable.subscribe(data => {
                if (data) {
                    if (isArray(data)) {
                        this.dataSource.data = data;
                    }
                    else {
                        this.dataSource.data = data.list;
                        this.footerData = get(data, 'footer');
                    }
                    this.dataLength = data.length;
                    this.getScrollStatus();
                }
                this.subscription.unsubscribe();
            });
        }
    }
    set handleStyleRules(rules) {
        this.styleRules = rules;
    }
    ngOnInit() {
    }
    handleSheetToggle() {
        if (!this.sheetToggle) {
            return;
        }
        else {
            this.sheetToggle.next(!this.sheetToggle.value);
        }
    }
    handlePaginate(ev) {
        return this.paginateHandler(ev);
    }
    handleExcelExport() {
        this.exportExcelHandler.emit(true);
    }
    getStyleRulesColumn(element, column) {
        return getStyleRuleColumn(this.styleRules, element, column);
    }
    getStyleRulesRow(row) {
        return getStyleRuleRow(this.styleRules, row);
    }
    getColumnType(column, element) {
        const rule = getFormattingRuleColumn(this.styleRules, element, column);
        return rule ? rule.display_mode : column.type;
    }
    handleHeaderStyleClass(column, element) {
        if (this.handleEditableColumn(null, column) && column.type === 'date') {
            return `ft-${column.type}-input-cell${column.actions ? '-' + column.actions.length : ''}`;
        }
        else {
            return `ft-${this.getColumnType(column, element)}-cell${column.actions ? '-' + column.actions.length : ''}`;
        }
    }
    handleCellClass(element, column) {
        return flatten([
            this.handleHeaderStyleClass(column, element), this.handleElementClass(element, column)
        ]);
    }
    handleCustomStyle(element, column) {
        const columnStyle = this.handleColumnStyle(element, column);
        // isFunction(column.style) ? get(column, 'style')(element) : column.style;
        const styleRule = this.getStyleRulesColumn(element, column);
        return merge$1(columnStyle, styleRule);
    }
}
BasicGenericViewTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: BasicGenericViewTableComponent, deps: [{ token: i1$2.DomSanitizer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BasicGenericViewTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: BasicGenericViewTableComponent, selector: "ft-basic-generic-view-table", inputs: { sheetToggle: "sheetToggle", exportExcel: "exportExcel", paginateHandler: "paginateHandler", handleColumns: ["columns", "handleColumns"], handleSource: ["source", "handleSource"], handleStyleRules: ["styleRules", "handleStyleRules"] }, outputs: { exportExcelHandler: "exportExcelHandler" }, host: { properties: { "class.has-scroll": "hasScroll", "class.has-pagination": "hasPagination" }, classAttribute: "table-container" }, usesInheritance: true, ngImport: i0, template: "<div [ngBusy]=\"subscription\"></div>\n<div fxLayout=\"row\" class=\"ft-table-search-bar\" [class.focused]=\"isFocused\" *ngIf=\"hasSearch\">\n    <ng-template [ngIf]=\"sheetToggle\">\n        <button type=\"button\" mat-icon-button (click)=\"handleSheetToggle()\" [class.mat-primary]=\"sheetToggle | async\">\n            <mat-icon fontIcon=\"mdi-filter-variant\" fontSet=\"mdi\"></mat-icon>\n        </button>\n    </ng-template>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\" [class.mat-primary]=\"isFocused\"></mat-icon>\n\n    <input type=\"text\" fxFlex [value]='key' [ftAutoFocus]=\"true\" [placeholder]=\"'table.search' | translate\"\n           (focus)=\"isFocused = true\" (blur)=\"isFocused = false\" (input)=\"onSearch($event.target.value)\"/>\n\n    <button type=\"button\" mat-icon-button (click)=\"cancelSearch()\" color=\"warn\" *ngIf=\"key.length > 0\"\n            [@scaleAnimation]>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n    <ng-container *ngFor=\"let action of actions\">\n        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n            <button type=\"button\" mat-icon-button (click)=\"handleMultiActionClick(action, $event)\"\n                    *ngIf=\"!handleActionHidden(selection.selected, action)\"\n                    [ngClass]=\"action.class\"\n                    [disabled]=\"handleActionBehaviour(selection.selected, action) || (!selection.hasValue() && action.isMultipleSelection)\"\n                    [matTooltip]=\"action?.tooltip | translate\">\n                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </ng-template>\n    </ng-container>\n    <ng-template [ngIf]=\"exportExcel\">\n        <button type=\"button\" mat-icon-button (click)=\"handleExcelExport()\">\n            <mat-icon fontIcon=\"mdi-file-excel\" fontSet=\"mdi\"></mat-icon>\n        </button>\n    </ng-template>\n\n</div>\n<div class=\"inner-table-container\" #innerTable>\n    <mat-table [dataSource]=\"dataSource\" [trackBy]=\"trackByFnHandler()\" matSort [matSortActive]=\"sortByKey\"\n               [class.empty-table]=\"!hasItems()\">\n        <ng-container matColumnDef=\"ft-multi-selection\" *ngIf=\"selectable\">\n            <mat-header-cell *matHeaderCellDef class=\"ft-multi-selection\">\n                <mat-checkbox (change)=\"$event ? masterToggle() : null\"\n                              [checked]=\"selection.hasValue() && isAllSelected()\"\n                              [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-header-cell>\n            <!--    *****   A REVOIR   *****   -->\n            <mat-cell *matCellDef=\"let element\" class=\"ft-multi-selection\">\n                <mat-checkbox (click)=\"$event.stopPropagation()\"\n                              (change)=\"$event ? handleRowClick(element) : null\"\n                              [checked]=\"selection.isSelected(element)\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-cell>\n            <!--    *****   A REVOIR   *****   -->\n            <mat-footer-cell *matFooterCellDef=\"let element\" class=\"ft-multi-selection\"></mat-footer-cell>\n        </ng-container>\n\n        <ng-container *ngFor=\"let column of displayedColumns;trackBy: columnTrackByFn\" [matColumnDef]=\"column.key\">\n            <mat-header-cell [ngClass]=\"handleHeaderClass(column)\" *matHeaderCellDef [mat-sort-header]=\"column?.sortBy\"\n                             [disabled]=\"!column?.sortBy\" [title]=\"column.label | translate\">\n                {{ column.label | translate}}\n            </mat-header-cell>\n\n            <mat-cell *matCellDef=\"let element; let i = index;\" [ngClass]=\"handleCellClass(element, column)\"\n                      [ngStyle]=\"!(['badge'].includes(getColumnType(column, element)))? getStyleRulesColumn(element, column): {}\"\n                      [ngSwitch]=\"getColumnType(column, element)\">\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'date'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'time'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftTime:column?.timeFormats}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'datetime'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDatetime}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleCustomStyle(element, column)\">{{handleValue(element, column) | translate}} </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleValue(element, column)}}\n                </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'html'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\"\n                      [innerHTML]=\"handleHtmlValue(element, column)\"></span>\n\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\" [fontIcon]=\"handleIconValue(element, column, styleRules)\"\n                          [ngStyle]=\"handleCustomStyle(element, column)\"\n                          [matTooltip]=\"handleColumnTooltip(element, column) | translate\"></mat-icon>\n\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                          [ngStyle]=\"handleCustomStyle(element, column)\"\n                          [matTooltip]=\"handleColumnTooltip(element, column) | translate\"\n                          [ngClass]=\"{'ft-success': handleValue(element, column), 'mat-warn': !handleValue(element, column)}\">\n                </mat-icon>\n\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of column?.actions\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"action.class\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-cell>\n            <mat-footer-cell *matFooterCellDef=\"let element; let i = index;\"\n                             [ngClass]=\"handleCellClass(element, column)\"\n                             [ngSwitch]=\"column.type\">\n                  <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                        [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftNumber: column?.numberConfig}}</span>\n            </mat-footer-cell>\n\n        </ng-container>\n\n        <mat-header-row *matHeaderRowDef=\"columnsItems; sticky: true\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: columnsItems;\" [ngClass]=\"handleRowClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\"\n                 [ngStyle]=\"getStyleRulesRow(row)\">\n        </mat-row>\n        <mat-footer-row *matFooterRowDef=\"columnsItems; sticky:true;\"\n                        [ngClass]=\"{'hidden':!hasFooter || !hasItems() }\"></mat-footer-row>\n    </mat-table>\n</div>\n<div class=\"empty-table-cell mat-cell\" *ngIf=\"!hasItems()\">\n    {{'table.no_element_to_show' | translate}}\n</div>\n\n<mat-paginator [hidden]=\"!hasPagination\" [pageSize]=\"pageSize\"\n               [length]=\"dataLength\" [pageSizeOptions]=\"pageSizeOptions\"\n               (page)=\"handlePaginate($event)\"\n               showFirstLastButtons>\n</mat-paginator>\n", styles: [".mat-paginator[hidden]{display:none}\n"], components: [{ type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4$3.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { type: i6$1.MatSortHeader, selector: "[mat-sort-header]", inputs: ["disabled", "mat-sort-header", "arrowPosition", "start", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { type: i10.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { type: i4$3.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i4$3.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { type: i4$3.MatFooterRow, selector: "mat-footer-row, tr[mat-footer-row]", exportAs: ["matFooterRow"] }, { type: i11$1.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }], directives: [{ type: i12$1.NgBusyDirective, selector: "[ngBusy]", inputs: ["ngBusy"], outputs: ["busyStart", "busyStop"] }, { type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i15.InputDirective, selector: "input" }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i15.AutoFocusDirective, selector: "[ftAutoFocus]", inputs: ["ftAutoFocus"] }, { type: i15$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i15.AclDirective, selector: "[ftAcl]", inputs: ["ftAcl"] }, { type: i15$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i18$1.DefaultClassDirective, selector: "  [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],  [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],  [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]", inputs: ["ngClass", "ngClass.xs", "ngClass.sm", "ngClass.md", "ngClass.lg", "ngClass.xl", "ngClass.lt-sm", "ngClass.lt-md", "ngClass.lt-lg", "ngClass.lt-xl", "ngClass.gt-xs", "ngClass.gt-sm", "ngClass.gt-md", "ngClass.gt-lg"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i6$1.MatSort, selector: "[matSort]", inputs: ["matSortDisabled", "matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { type: i4$3.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i4$3.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i4$3.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i4$3.MatCellDef, selector: "[matCellDef]" }, { type: i4$3.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i4$3.MatFooterCellDef, selector: "[matFooterCellDef]" }, { type: i4$3.MatFooterCell, selector: "mat-footer-cell, td[mat-footer-cell]" }, { type: i15$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i18$1.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { type: i15$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i15$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i4$3.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i4$3.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { type: i11.MatRipple, selector: "[mat-ripple], [matRipple]", inputs: ["matRippleColor", "matRippleUnbounded", "matRippleCentered", "matRippleRadius", "matRippleAnimation", "matRippleDisabled", "matRippleTrigger"], exportAs: ["matRipple"] }, { type: i4$3.MatFooterRowDef, selector: "[matFooterRowDef]", inputs: ["matFooterRowDef", "matFooterRowDefSticky"] }], pipes: { "async": i15$1.AsyncPipe, "translate": i5$1.TranslatePipe, "ftNumber": i15.NumberPipe, "ftDate": i15.DatePipe, "ftTime": i15.TimePipe, "ftDatetime": i15.DatetimePipe, "ftFileSize": i15.FileSizePipe }, animations: [
        SCALE_ANIMATION
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: BasicGenericViewTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-basic-generic-view-table', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        SCALE_ANIMATION
                    ], host: {
                        class: 'table-container',
                        '[class.has-scroll]': 'hasScroll',
                        '[class.has-pagination]': 'hasPagination',
                    }, template: "<div [ngBusy]=\"subscription\"></div>\n<div fxLayout=\"row\" class=\"ft-table-search-bar\" [class.focused]=\"isFocused\" *ngIf=\"hasSearch\">\n    <ng-template [ngIf]=\"sheetToggle\">\n        <button type=\"button\" mat-icon-button (click)=\"handleSheetToggle()\" [class.mat-primary]=\"sheetToggle | async\">\n            <mat-icon fontIcon=\"mdi-filter-variant\" fontSet=\"mdi\"></mat-icon>\n        </button>\n    </ng-template>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\" [class.mat-primary]=\"isFocused\"></mat-icon>\n\n    <input type=\"text\" fxFlex [value]='key' [ftAutoFocus]=\"true\" [placeholder]=\"'table.search' | translate\"\n           (focus)=\"isFocused = true\" (blur)=\"isFocused = false\" (input)=\"onSearch($event.target.value)\"/>\n\n    <button type=\"button\" mat-icon-button (click)=\"cancelSearch()\" color=\"warn\" *ngIf=\"key.length > 0\"\n            [@scaleAnimation]>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n    <ng-container *ngFor=\"let action of actions\">\n        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n            <button type=\"button\" mat-icon-button (click)=\"handleMultiActionClick(action, $event)\"\n                    *ngIf=\"!handleActionHidden(selection.selected, action)\"\n                    [ngClass]=\"action.class\"\n                    [disabled]=\"handleActionBehaviour(selection.selected, action) || (!selection.hasValue() && action.isMultipleSelection)\"\n                    [matTooltip]=\"action?.tooltip | translate\">\n                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n            </button>\n        </ng-template>\n    </ng-container>\n    <ng-template [ngIf]=\"exportExcel\">\n        <button type=\"button\" mat-icon-button (click)=\"handleExcelExport()\">\n            <mat-icon fontIcon=\"mdi-file-excel\" fontSet=\"mdi\"></mat-icon>\n        </button>\n    </ng-template>\n\n</div>\n<div class=\"inner-table-container\" #innerTable>\n    <mat-table [dataSource]=\"dataSource\" [trackBy]=\"trackByFnHandler()\" matSort [matSortActive]=\"sortByKey\"\n               [class.empty-table]=\"!hasItems()\">\n        <ng-container matColumnDef=\"ft-multi-selection\" *ngIf=\"selectable\">\n            <mat-header-cell *matHeaderCellDef class=\"ft-multi-selection\">\n                <mat-checkbox (change)=\"$event ? masterToggle() : null\"\n                              [checked]=\"selection.hasValue() && isAllSelected()\"\n                              [indeterminate]=\"selection.hasValue() && !isAllSelected()\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-header-cell>\n            <!--    *****   A REVOIR   *****   -->\n            <mat-cell *matCellDef=\"let element\" class=\"ft-multi-selection\">\n                <mat-checkbox (click)=\"$event.stopPropagation()\"\n                              (change)=\"$event ? handleRowClick(element) : null\"\n                              [checked]=\"selection.isSelected(element)\" [disableRipple]=\"true\">\n                </mat-checkbox>\n            </mat-cell>\n            <!--    *****   A REVOIR   *****   -->\n            <mat-footer-cell *matFooterCellDef=\"let element\" class=\"ft-multi-selection\"></mat-footer-cell>\n        </ng-container>\n\n        <ng-container *ngFor=\"let column of displayedColumns;trackBy: columnTrackByFn\" [matColumnDef]=\"column.key\">\n            <mat-header-cell [ngClass]=\"handleHeaderClass(column)\" *matHeaderCellDef [mat-sort-header]=\"column?.sortBy\"\n                             [disabled]=\"!column?.sortBy\" [title]=\"column.label | translate\">\n                {{ column.label | translate}}\n            </mat-header-cell>\n\n            <mat-cell *matCellDef=\"let element; let i = index;\" [ngClass]=\"handleCellClass(element, column)\"\n                      [ngStyle]=\"!(['badge'].includes(getColumnType(column, element)))? getStyleRulesColumn(element, column): {}\"\n                      [ngSwitch]=\"getColumnType(column, element)\">\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftNumber: column?.numberConfig}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'date'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'time'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftTime:column?.timeFormats}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'datetime'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftDatetime}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'file-size'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleValue(element, column) | ftFileSize}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'badge'\"\n                      [ngStyle]=\"handleCustomStyle(element, column)\">{{handleValue(element, column) | translate}} </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'color'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                              [ngStyle]=\"handleColumnStyle(element, column)\"\n                              [style.color]=\"handleValue(element, column)\"></mat-icon>\n                    {{handleValue(element, column)}}\n                </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'progress'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">\n                    <span>{{handleValue(element, column) | ftNumber: 'percentage'}}</span>\n                    <mat-progress-bar mode=\"determinate\"\n                                      [value]=\"handleValue(element, column) * 100\"></mat-progress-bar>\n                </span>\n\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'html'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\"\n                      [innerHTML]=\"handleHtmlValue(element, column)\"></span>\n\n                <mat-icon *ngSwitchCase=\"'icon'\" fontSet=\"mdi\" [fontIcon]=\"handleIconValue(element, column, styleRules)\"\n                          [ngStyle]=\"handleCustomStyle(element, column)\"\n                          [matTooltip]=\"handleColumnTooltip(element, column) | translate\"></mat-icon>\n\n                <mat-icon *ngSwitchCase=\"'boolean'\" fontSet=\"mdi\" fontIcon=\"mdi-checkbox-blank-circle\"\n                          [ngStyle]=\"handleCustomStyle(element, column)\"\n                          [matTooltip]=\"handleColumnTooltip(element, column) | translate\"\n                          [ngClass]=\"{'ft-success': handleValue(element, column), 'mat-warn': !handleValue(element, column)}\">\n                </mat-icon>\n\n                <ng-template [ngSwitchCase]=\"'actions'\">\n                    <ng-container *ngFor=\"let action of column?.actions\">\n                        <ng-template [ftAcl]=\"action.acl\" [ignoreEmpty]=\"true\">\n                            <button type=\"button\" mat-icon-button\n                                    *ngIf=\"!handleActionHidden(element, action)\"\n                                    [disabled]=\"handleActionBehaviour(element, action)\"\n                                    (click)=\"handleActionClick(element, action, i, $event)\"\n                                    [ngClass]=\"action.class\"\n                                    [matTooltip]=\"action?.tooltip | translate\">\n                                <mat-icon [fontIcon]=\"action.icon\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                        </ng-template>\n                    </ng-container>\n                </ng-template>\n            </mat-cell>\n            <mat-footer-cell *matFooterCellDef=\"let element; let i = index;\"\n                             [ngClass]=\"handleCellClass(element, column)\"\n                             [ngSwitch]=\"column.type\">\n                  <span class=\"ft-table-value-container\" *ngSwitchCase=\"'text'\"\n                        [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column)}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'translate'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | translate}}</span>\n                <span class=\"ft-table-value-container\" *ngSwitchCase=\"'number'\"\n                      [ngStyle]=\"handleColumnStyle(element, column)\">{{handleFooterValue(element, column) | ftNumber: column?.numberConfig}}</span>\n            </mat-footer-cell>\n\n        </ng-container>\n\n        <mat-header-row *matHeaderRowDef=\"columnsItems; sticky: true\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: columnsItems;\" [ngClass]=\"handleRowClass(row)\"\n                 matRipple matRippleColor='rgba(0,0,0,.1)'\n                 [matRippleDisabled]=\"!selectable && !hasClickItem()\"\n                 (click)=\"handleRowClick(row)\"\n                 [ngStyle]=\"getStyleRulesRow(row)\">\n        </mat-row>\n        <mat-footer-row *matFooterRowDef=\"columnsItems; sticky:true;\"\n                        [ngClass]=\"{'hidden':!hasFooter || !hasItems() }\"></mat-footer-row>\n    </mat-table>\n</div>\n<div class=\"empty-table-cell mat-cell\" *ngIf=\"!hasItems()\">\n    {{'table.no_element_to_show' | translate}}\n</div>\n\n<mat-paginator [hidden]=\"!hasPagination\" [pageSize]=\"pageSize\"\n               [length]=\"dataLength\" [pageSizeOptions]=\"pageSizeOptions\"\n               (page)=\"handlePaginate($event)\"\n               showFirstLastButtons>\n</mat-paginator>\n", styles: [".mat-paginator[hidden]{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { sheetToggle: [{
                type: Input
            }], exportExcel: [{
                type: Input
            }], paginateHandler: [{
                type: Input
            }], exportExcelHandler: [{
                type: Output
            }], handleColumns: [{
                type: Input,
                args: ['columns']
            }], handleSource: [{
                type: Input,
                args: ['source']
            }], handleStyleRules: [{
                type: Input,
                args: ['styleRules']
            }] } });

class GenericViewTableComponent {
    constructor(ftViewService, translateService) {
        this.ftViewService = ftViewService;
        this.translateService = translateService;
        this.columns = new BehaviorSubject([]);
        this.toggle$ = new BehaviorSubject(null);
        this.viewId = null;
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 15, 20];
        this.pagination = null;
        this.currentView = null;
        this.selectedValues = [];
        this.firstLoad = true;
        this.hasFooter = false;
        this.viewColumns = [];
        this.currentQuery = [];
        this.trackByKey = 'id';
        this.hasSearch = true;
        this.selectable = false;
        this.hasPagination = false;
        this.defaultQuery = [];
        this.reloadEvent = new EventEmitter();
        this.exportExcel = null;
        this.lineClick = new EventEmitter();
        this.selectedChange = new EventEmitter();
        this.viewQueryChange = new EventEmitter();
        this.viewQuery = {
            search: [],
            search_all: {},
            page: { sortBy: this.trackByKey, sortDirection: 'desc', page: 0, limit: this.pageSize }
        };
        this.paginateHandler = (ev) => {
            return this.handlePaginateChange(ev);
        };
    }
    set handleFooter(value) {
        this.hasFooter = value;
    }
    set handleViewDefinition(settings) {
        this.tableViewDefinition = settings;
        this.initView();
    }
    set handleActions(actions) {
        this.tableActions = actions;
    }
    set handleReload(observable) {
        observable.subscribe(data => {
            if (data) {
                this.handleSource();
            }
        });
    }
    set handleInitialQuery(value) {
        if (value) {
            this.viewQuery.search = compact(concat(this.defaultQuery, value));
            if (!isEmpty(this.viewQuery.search)) {
                if (!isEmpty(this.currentQuery)) {
                    this.currentQuery = value;
                }
                else {
                    this.handleSource();
                }
            }
        }
    }
    set selected(values) {
        this.selectedValues = values;
        this.selectedChange.emit(this.selectedValues);
    }
    get selected() {
        return this.selectedValues;
    }
    ngOnInit() {
    }
    initView() {
        this.viewQuery.search = !isNil(this.defaultQuery) ? this.defaultQuery : [];
        this.ftViewService.getConfig(this.tableViewDefinition.model).subscribe(data => {
            if (data) {
                this.initTableConfig(data);
            }
            else {
                this.handleConfig();
            }
        });
    }
    initTableConfig(data) {
        this.handleViewChange(find(data.views, ['is_default', true]) || last(data.views));
    }
    handleConfig() {
        let tableView;
        tableView = assignIn({}, {
            name: get(this.tableViewDefinition, 'defaultName'),
            is_default: true,
            is_system: true,
            pagination: [{
                    name: 'default',
                    page_size: default_page_size,
                    page_options: default_page_options
                }],
            columns: chain(this.tableViewDefinition.viewColumns).map((e, idx) => {
                return assign({
                    order_in: [{ name: this.viewNamespace, value: idx }],
                    show_in: [{ name: this.viewNamespace, allow: true }]
                }, new Object({ key: e.key }));
            }).reject({ key: 'actions' }).value()
        });
        this.ftViewService.handleConfig({ views: [tableView], key: this.tableViewDefinition.model }).subscribe(data => {
            if (data) {
                this.initTableConfig(data);
            }
        });
    }
    handleSource() {
        this.viewQueryChange.emit(this.viewQuery);
        this.source$ = this.ftViewService.handleData(this.tableViewDefinition.model, this.viewNamespace, this.viewId, this.viewQuery, get(this.tableViewDefinition, 'resource'), get(this.tableViewDefinition, 'topic'));
    }
    handleViewChange(view) {
        var _a;
        let displayedColumns;
        let actionsColumn;
        this.currentView = view;
        this.styleRules = (_a = this.currentView) === null || _a === void 0 ? void 0 : _a.style_rules;
        let newestColumns = null;
        if (get(this.currentView, 'is_system', false)) {
            newestColumns = chain(this.tableViewDefinition.viewColumns).reject((e) => {
                return !isNil(find(view.columns, { key: e.key })) || e.key === 'actions';
            }).map((e, idx) => {
                return assignIn(pick(e, ['key']), {
                    order_in: [{ name: this.viewNamespace, value: idx }],
                    show_in: [{ name: this.viewNamespace, allow: true }]
                });
            }).value();
            if (!isEmpty(newestColumns)) {
                this.ftViewService.updateView(get(this.currentView, 'id'), { columns: concat(this.currentView.columns, newestColumns) })
                    .subscribe(data => noop());
            }
        }
        actionsColumn = find(this.tableViewDefinition.viewColumns, (e) => {
            return e.type === 'actions';
        }) || null;
        this.viewId = get(view, 'id');
        displayedColumns = chain(get(view, 'columns'))
            .filter((e) => {
            return chain(find(get(e, 'show_in'), { name: this.viewNamespace })).get('allow', true).value();
        })
            .map((c) => {
            return find(this.tableViewDefinition.viewColumns, ['key', c.key]);
        })
            .compact()
            .value();
        this.viewColumns = cloneDeep(displayedColumns);
        if (!find(displayedColumns, { type: 'actions' }) && !isNil(actionsColumn)) {
            displayedColumns.push(actionsColumn);
        }
        this.columns.next(displayedColumns);
        this.viewQuery.search = compact(concat(this.viewQuery.search, view.query, this.defaultQuery || [], this.currentQuery));
        this.initPaginator(view);
        this.viewQuery.page.limit = this.pageSize;
        this.handleSource();
    }
    initPaginator(view) {
        this.pagination = chain(get(view, 'pagination')).find((p) => {
            return p.name === this.viewNamespace;
        }).value() || chain(get(view, 'pagination')).find((p) => {
            return p.name === 'default';
        }).value();
        this.pagination ? this.pageSize = get(this.pagination, 'page_size') : noop();
        this.pagination ? this.pageSizeOptions = get(this.pagination, 'page_options') : noop();
    }
    handleClick(ev) {
        this.lineClick.emit(ev);
    }
    handleSearchChange(ev) {
        if (!this.firstLoad) {
            if (get(ev, 'sortBy')) {
                this.viewQuery.page.sortBy = ev.sortBy;
                this.viewQuery.page.sortDirection = ev.sortDirection;
            }
            else {
                this.viewQuery.page.sortBy = this.trackByKey;
                this.viewQuery.page.sortDirection = 'desc';
            }
            this.viewQuery.search_all = { search: ev.search, columns: this.tableViewDefinition.viewColumns };
            this.handleSource();
        }
        this.firstLoad = false;
    }
    handleQueryChange(query) {
        if (!isNil(query)) {
            this.viewQuery.search = concat(this.defaultQuery || [], query);
            this.handleSource();
        }
    }
    handlePaginateChange(ev) {
        if ((ev.pageSize != get(this.pagination, 'page_size')) && this.currentView) {
            let idx;
            idx = findIndex(this.currentView.pagination, { name: this.viewNamespace });
            if (idx === -1) {
                this.currentView.pagination.push(assignIn(cloneDeep(this.pagination), {
                    name: this.viewNamespace,
                    page_size: ev.pageSize
                }));
            }
            else {
                this.currentView.pagination[idx].page_size = ev.pageSize;
            }
            this.ftViewService.updateView(get(this.currentView, 'id'), { pagination: get(this.currentView, 'pagination') })
                .subscribe(data => noop());
        }
        this.viewQuery.page.page = ev.pageIndex;
        this.viewQuery.page.limit = ev.pageSize;
        this.handleSource();
    }
    handleExcelExport(ev) {
        function reduceFunc(items, item) {
            return set(items, item.key, this.translateService.instant(item.label));
        }
        if (ev) {
            let translatedColumns;
            translatedColumns = reduce(this.viewColumns, reduceFunc.bind(this), {
                file_name: this.translateService.instant(this.tableViewDefinition.model),
                page_name: this.translateService.instant('table.export_excel_page_name')
            });
            let excelColumns;
            excelColumns = map(this.viewColumns, (e) => {
                return pick(e, 'key', 'type');
            });
            this.loading = this.ftViewService.generateExcelFile(this.tableViewDefinition.model, this.viewQuery, excelColumns, translatedColumns, this.currentView.id, this.viewNamespace, get(this.tableViewDefinition, 'resource'))
                .subscribe(data => {
                data.download();
            });
        }
    }
    handleStyleRuleChange(e) {
        this.styleRules = cloneDeep(e.styleRules);
        ////// ***** update....
        if (e.validate) {
            this.ftViewService.updateView(get(this.currentView, 'id'), { style_rules: e.styleRules })
                .subscribe(data => noop());
        }
    }
}
GenericViewTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericViewTableComponent, deps: [{ token: FtViewService }, { token: i5$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
GenericViewTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: GenericViewTableComponent, selector: "ft-generic-view-table", inputs: { trackByKey: "trackByKey", hasSearch: "hasSearch", selectable: "selectable", hasPagination: "hasPagination", lineClass: "lineClass", viewNamespace: ["namespace", "viewNamespace"], defaultQuery: ["query", "defaultQuery"], reloadEvent: "reloadEvent", exportExcel: "exportExcel", handleFooter: ["hasFooter", "handleFooter"], handleViewDefinition: ["viewSettings", "handleViewDefinition"], handleActions: ["actions", "handleActions"], handleReload: ["reloadEvent", "handleReload"], handleInitialQuery: ["InitialQuery", "handleInitialQuery"], selected: "selected" }, outputs: { lineClick: "lineClick", selectedChange: "selectedChange", viewQueryChange: "viewQueryChange" }, ngImport: i0, template: "<mat-drawer-container class=\"ft-app-container no-padding\">\n    <mat-drawer mode=\"side\" [opened]=\"toggle$|async\" position=\"start\">\n        <ft-generic-view *ngIf=\"toggle$|async\" fxLayout=\"column\" fxFlex\n                         [namespace]=\"viewNamespace\"\n                          [viewSettings]=\"tableViewDefinition\"\n                          (viewChange)=\"handleViewChange($event)\"\n                          (queryChange)=\"handleQueryChange($event)\"\n                          [currentView]=\"currentView\"\n                          [(currentQuery)]=\"currentQuery\"\n                          [currentStyleRules]=\"styleRules\"\n                          (currentStyleRulesChange)=\"handleStyleRuleChange($event)\"\n                          [columns]=\"viewColumns\"\n                         >\n        </ft-generic-view>\n    </mat-drawer>\n    <mat-drawer-content fxFlex class=\"ft-content\" [ngBusy]=\"loading\">\n        <ft-basic-generic-view-table fxFlex\n                                     [remote]=\"true\"\n                                     [source]=\"source$\"\n                                     [hasSearch]=\"hasSearch\"\n                                     [selectable]=\"selectable\"\n                                     [hasPagination]=\"hasPagination\"\n                                     [lineClass]=\"lineClass\"\n                                     [columns]=\"columns | async\"\n                                     (lineClick)=\"handleClick($event)\"\n                                     [multiActions]=\"tableActions\"\n                                     (searchChange)=\"handleSearchChange($event)\"\n                                     [sheetToggle]=\"toggle$\"\n                                     [pageSize]=\"pageSize\"\n                                     [pageSizeOptions]=\"pageSizeOptions\"\n                                     [paginateHandler]=\"paginateHandler\"\n                                     [(selected)]=\"selected\"\n                                     [exportExcel]=\"exportExcel\"\n                                     (exportExcelHandler)=\"handleExcelExport($event)\"\n                                     [hasFooter]=\"hasFooter\"\n                                     [styleRules]=\"styleRules\"\n\n        >\n        </ft-basic-generic-view-table>\n    </mat-drawer-content>\n</mat-drawer-container>\n", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}:host{display:flex;height:100%}ft-generic-view{width:inherit;border:1px solid #eceff1}ft-basic-generic-view-table{margin-left:6px}\n"], components: [{ type: i7.MatDrawerContainer, selector: "mat-drawer-container", inputs: ["autosize", "hasBackdrop"], outputs: ["backdropClick"], exportAs: ["matDrawerContainer"] }, { type: i7.MatDrawer, selector: "mat-drawer", inputs: ["position", "mode", "disableClose", "autoFocus", "opened"], outputs: ["openedChange", "opened", "openedStart", "closed", "closedStart", "positionChanged"], exportAs: ["matDrawer"] }, { type: GenericViewComponent, selector: "ft-generic-view", inputs: ["namespace", "view", "viewSettings", "currentView", "columns", "currentQuery", "currentStyleRules"], outputs: ["viewChange", "queryChange", "currentStyleRulesChange"] }, { type: i7.MatDrawerContent, selector: "mat-drawer-content" }, { type: BasicGenericViewTableComponent, selector: "ft-basic-generic-view-table", inputs: ["sheetToggle", "exportExcel", "paginateHandler", "columns", "source", "styleRules"], outputs: ["exportExcelHandler"] }], directives: [{ type: i15$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i14.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { type: i14.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { type: i12$1.NgBusyDirective, selector: "[ngBusy]", inputs: ["ngBusy"], outputs: ["busyStart", "busyStop"] }], pipes: { "async": i15$1.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: GenericViewTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ft-generic-view-table', template: "<mat-drawer-container class=\"ft-app-container no-padding\">\n    <mat-drawer mode=\"side\" [opened]=\"toggle$|async\" position=\"start\">\n        <ft-generic-view *ngIf=\"toggle$|async\" fxLayout=\"column\" fxFlex\n                         [namespace]=\"viewNamespace\"\n                          [viewSettings]=\"tableViewDefinition\"\n                          (viewChange)=\"handleViewChange($event)\"\n                          (queryChange)=\"handleQueryChange($event)\"\n                          [currentView]=\"currentView\"\n                          [(currentQuery)]=\"currentQuery\"\n                          [currentStyleRules]=\"styleRules\"\n                          (currentStyleRulesChange)=\"handleStyleRuleChange($event)\"\n                          [columns]=\"viewColumns\"\n                         >\n        </ft-generic-view>\n    </mat-drawer>\n    <mat-drawer-content fxFlex class=\"ft-content\" [ngBusy]=\"loading\">\n        <ft-basic-generic-view-table fxFlex\n                                     [remote]=\"true\"\n                                     [source]=\"source$\"\n                                     [hasSearch]=\"hasSearch\"\n                                     [selectable]=\"selectable\"\n                                     [hasPagination]=\"hasPagination\"\n                                     [lineClass]=\"lineClass\"\n                                     [columns]=\"columns | async\"\n                                     (lineClick)=\"handleClick($event)\"\n                                     [multiActions]=\"tableActions\"\n                                     (searchChange)=\"handleSearchChange($event)\"\n                                     [sheetToggle]=\"toggle$\"\n                                     [pageSize]=\"pageSize\"\n                                     [pageSizeOptions]=\"pageSizeOptions\"\n                                     [paginateHandler]=\"paginateHandler\"\n                                     [(selected)]=\"selected\"\n                                     [exportExcel]=\"exportExcel\"\n                                     (exportExcelHandler)=\"handleExcelExport($event)\"\n                                     [hasFooter]=\"hasFooter\"\n                                     [styleRules]=\"styleRules\"\n\n        >\n        </ft-basic-generic-view-table>\n    </mat-drawer-content>\n</mat-drawer-container>\n", styles: [".ft-parent-layout{display:flex;flex:1 1 100%;overflow:hidden;flex-direction:column;border-radius:4px}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar{border-radius:0}.ft-parent-layout .mat-tab-nav-bar+.mat-toolbar .mat-tab-link{height:36px}.ft-parent-layout .mat-toolbar{height:35px;position:relative;min-height:35px;padding:0 6px;border-radius:4px 4px 0 0}.ft-parent-layout .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:6px;width:29px;line-height:35px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:29px;height:29px;line-height:29px}.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .mat-toolbar h2{height:35px;line-height:35px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker{display:flex;height:25px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:25px;padding:0 0 0 6px}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:19px;height:19px;line-height:19px;margin:3px 3px 3px 0}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .mat-toolbar .mat-button{height:inherit;line-height:35px;padding:0 6px 0 3px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .mat-toolbar .mat-button.icon-only{width:35px;height:35px;line-height:35px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:35px;line-height:35px;margin-right:6px}.ft-parent-layout .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .mat-toolbar .mat-icon-button{height:29px;width:29px;line-height:29px}.ft-parent-layout .mat-toolbar>.mat-button[disabled],.ft-parent-layout .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{margin:1px 3px 1px 0;width:23px;height:23px;line-height:23px}.ft-parent-layout .mat-toolbar+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout .ft-content{overflow:auto;position:relative;background-color:#fff;border-radius:4px}.ft-parent-layout .ft-content h3{margin:0;height:45px;line-height:45px}.ft-parent-layout .mat-tab-group .mat-tab-header{background-color:#fafafa;border-bottom:solid 1px #eceff1}.ft-parent-layout .mat-tab-group .mat-tab-label{min-width:100px;padding:0 12px;height:36px}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper{flex:1 1 100%}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .mat-tab-body-content{display:flex}.ft-parent-layout .mat-tab-group .mat-tab-body-wrapper .ft-content{padding:6px;border-radius:0 0 4px 4px}.ft-parent-layout .mat-tab-group.with-actions .mat-tab-body-wrapper .ft-content{border-radius:0}.ft-parent-layout .mat-tab-group+.ft-content{border-radius:0 0 4px 4px}.ft-parent-layout>.ft-content{padding:6px}.ft-parent-layout>.ft-content.with-actions{border-radius:0}.ft-parent-layout .ft-actions{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;height:42px;max-height:42px;min-height:42px;background-color:#fafafa;border-top:solid 1px #eceff1}.ft-parent-layout .ft-actions .mat-mini-fab,.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{margin:0 6px;height:30px;border-radius:4px}.ft-parent-layout .ft-actions .mat-raised-button,.ft-parent-layout .ft-actions .mat-button,.ft-parent-layout .ft-actions .mat-stroked-button{font-weight:500;padding:0 8px;line-height:30px;min-width:30px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon,.ft-parent-layout .ft-actions .mat-button.has-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon{padding:0 8px 0 3px}.ft-parent-layout .ft-actions .mat-raised-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-button.has-icon .mat-button-wrapper .mat-icon,.ft-parent-layout .ft-actions .mat-stroked-button.has-icon .mat-button-wrapper .mat-icon{margin-right:4px}.ft-parent-layout .ft-actions .mat-badge{z-index:10}.ft-parent-layout .ft-actions .mat-mini-fab{width:30px}.ft-parent-layout .ft-actions .mat-mini-fab .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .ft-actions .mat-slide-toggle{padding:0 8px}.ft-parent-layout .ft-actions .mat-slide-toggle .mat-slide-toggle-content{font-size:15px}.ft-parent-layout>.ft-actions{border-radius:0 0 4px 4px}.ft-parent-layout .button-action-bar{padding-bottom:6px;border-bottom:2px solid #eceff1;margin:6px 6px 0}.ft-parent-layout .button-action-bar .mat-button{margin:0;padding:0 6px;height:26px;min-width:26px;line-height:26px;border-radius:0;color:#fff;background:#03a9f4;box-shadow:0 3px 0 -6px #0003,0 2px 2px #00000024,0 1px 3px #0000001f}.ft-parent-layout .button-action-bar .mat-button::ng-deep .mat-button-ripple-round{border-radius:inherit}.ft-parent-layout .button-action-bar .mat-button:first-of-type{border-radius:4px 0 0 4px}.ft-parent-layout .button-action-bar .mat-button:last-of-type{border-radius:0 4px 4px 0}.ft-parent-layout .button-action-bar .mat-button.icon-only{padding:0}.ft-parent-layout .ft-content-container{background-color:inherit}.ft-parent-layout .ft-content-container .mat-drawer{padding:6px;border-right:2px #eceff1 solid;width:220px;min-width:220px}.ft-parent-layout .ft-content-container .mat-drawer *::-webkit-scrollbar-thumb{background:rgba(176,190,197,.75)}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar{width:.3em;height:.3em}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-button{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-track-piece{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-scrollbar-corner{display:none}.ft-parent-layout .ft-content-container .mat-drawer ::-webkit-resizer{display:none}@media (max-width: 1280px){.ft-parent-layout .ft-content-container .mat-drawer{width:195px;min-width:195px}}@media (max-width: 1440px) and (min-width: 1281px){.ft-parent-layout .ft-content-container .mat-drawer{width:210px;min-width:210px}}.ft-parent-layout .ft-content-container .mat-drawer .mat-drawer-inner-container{display:flex;flex-direction:column}.ft-parent-layout .ft-content-container .mat-toolbar{height:28px;position:relative;min-height:28px;padding:0 3px;border-radius:4px 4px 0 0}.ft-parent-layout .ft-content-container .mat-toolbar.mat-primary .input-container{background:#4fc3f7}.ft-parent-layout .ft-content-container .mat-toolbar.mat-accent .input-container{background:#90a4ae}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon{display:flex;align-items:center;height:inherit;margin-right:3px;width:25px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{text-align:center;width:25px;height:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon[disabled]{opacity:.75;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar h2{height:28px;line-height:28px;overflow:hidden;white-space:nowrap;max-width:100%;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker{display:flex;height:18px;background:rgba(0,0,0,.1);border-radius:4px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element{margin:0;color:#fff;width:100px;height:inherit;font-size:14px;line-height:18px;padding:0 0 0 6px}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-input-element::placeholder{color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle{display:flex;color:inherit}.ft-parent-layout .ft-content-container .mat-toolbar .ft-toolbar-datepicker .mat-datepicker-toggle .mat-icon-button{width:12px;height:12px;line-height:12px;margin:3px 3px 3px 0}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button{height:inherit;line-height:28px;padding:0 3px 0 1.5px;min-width:40px;font-weight:500;border-radius:unset}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.icon-only,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.icon-only{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button.no-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button.no-icon{min-width:unset;padding:0 3px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-button:not(.icon-only) .mat-icon,.ft-parent-layout .ft-content-container .mat-toolbar .mat-button:not(.icon-only) .mat-icon{height:28px;line-height:28px;margin-right:6px}.ft-parent-layout .ft-content-container .mat-toolbar>.ft-has-icon-buttons>.mat-icon-button,.ft-parent-layout .ft-content-container .mat-toolbar .mat-icon-button{height:25px;width:25px;line-height:25px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-button[disabled],.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button[disabled]{color:#ffffffbf}.ft-parent-layout .ft-content-container .mat-toolbar .ft-module-icon>.mat-icon{width:28px;height:28px;line-height:28px}.ft-parent-layout .ft-content-container .mat-toolbar h2{font-size:16px;line-height:30px}.ft-parent-layout .ft-content-container .mat-toolbar>.mat-icon-button .mat-icon{font-size:20px}.ft-parent-layout .ft-content-container .mat-list-base{flex:1 1 100%;padding-top:0;border:1px solid #eceff1;border-top:none;border-radius:0 0 4px 4px}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader{font-size:14px;overflow:hidden;position:relative;padding:3px;height:28px;background-color:#eceff1}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader:first-child{margin-top:unset}.ft-parent-layout .ft-content-container .mat-list-base .mat-subheader>.mat-button{padding:0;width:100%;height:100%;z-index:100;min-width:unset;border-radius:0;position:absolute;margin:0 0 0 -3px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item{height:28px;border-bottom:1px whitesmoke solid;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line{cursor:pointer;text-align:left;align-items:center}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon{max-width:24px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line .mat-icon:first-of-type{margin-right:6px}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-line span{font-size:13px;font-weight:500;margin-right:3px;overflow:hidden;text-overflow:ellipsis}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content{padding:0}.ft-parent-layout .ft-content-container .mat-list-base .mat-list-item .mat-list-item-content .mat-button{padding:0;border-radius:0;width:28px;height:28px;min-width:28px}.ft-parent-layout .ft-content-container .mat-drawer-content{display:flex}.ft-parent-layout .ft-content-container .mat-drawer-content.ft-content{border-radius:0}.ft-parent-layout nav.mat-tab-nav-bar{border:none;background-color:#fff;border-radius:4px 4px 0 0;border-bottom:3px solid #607d8b}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar{border-bottom:none}.ft-parent-layout nav.mat-tab-nav-bar.with-toolbar .mat-tab-links{height:27px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-links{height:32px}.ft-parent-layout nav.mat-tab-nav-bar .mat-ink-bar{display:none}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button{opacity:1;height:inherit;padding:0 12px;border-radius:0;min-width:unset;background-color:#fff;color:#78909c;box-shadow:0 1px 0 1px #eceff1;transition:.3s all cubic-bezier(.4,0,.2,1)}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link:hover,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button:hover{color:#03a9f4}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-label-active,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-label-active{box-shadow:0 0;color:#fff;background-color:#607d8b}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link[disabled],.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.mat-tab-disabled,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button[disabled]{color:#78909c80}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon{padding:0 12px 0 4px}.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-tab-link.with-icon .mat-button-wrapper .mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon>.mat-icon,.ft-parent-layout nav.mat-tab-nav-bar .mat-tab-link-container .mat-button.with-icon .mat-button-wrapper .mat-icon{margin-right:6px}:host{display:flex;height:100%}ft-generic-view{width:inherit;border:1px solid #eceff1}ft-basic-generic-view-table{margin-left:6px}\n"] }]
        }], ctorParameters: function () { return [{ type: FtViewService }, { type: i5$1.TranslateService }]; }, propDecorators: { trackByKey: [{
                type: Input
            }], hasSearch: [{
                type: Input
            }], selectable: [{
                type: Input
            }], hasPagination: [{
                type: Input
            }], lineClass: [{
                type: Input
            }], viewNamespace: [{
                type: Input,
                args: ['namespace']
            }], defaultQuery: [{
                type: Input,
                args: ['query']
            }], reloadEvent: [{
                type: Input
            }], exportExcel: [{
                type: Input
            }], handleFooter: [{
                type: Input,
                args: ['hasFooter']
            }], handleViewDefinition: [{
                type: Input,
                args: ['viewSettings']
            }], handleActions: [{
                type: Input,
                args: ['actions']
            }], handleReload: [{
                type: Input,
                args: ['reloadEvent']
            }], handleInitialQuery: [{
                type: Input,
                args: ['InitialQuery']
            }], selected: [{
                type: Input
            }], lineClick: [{
                type: Output
            }], selectedChange: [{
                type: Output
            }], viewQueryChange: [{
                type: Output
            }] } });

function paginatorIntl(translateService) {
    return new PaginatorI18n(translateService).getPaginatorIntl();
}
class FtTableModule {
}
FtTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FtTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtTableModule, declarations: [BasicGenericViewTableComponent,
        GenericBodyTableComponent,
        GenericViewComponent,
        ViewDialogComponent,
        IconDialogComponent,
        StyleRulesComponent,
        FilterDialogComponent,
        GenericViewTableComponent,
        BaseTableComponent], imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        TranslateModule,
        MatProgressBarModule,
        CdkTableModule,
        MaterialModule,
        FtCoreModule,
        DragDropModule], exports: [BasicGenericViewTableComponent, GenericViewComponent, GenericViewTableComponent, GenericBodyTableComponent, BaseTableComponent] });
FtTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtTableModule, providers: [
        {
            provide: MatPaginatorIntl, deps: [TranslateService],
            useFactory: paginatorIntl
        },
        FtViewService
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            TranslateModule,
            MatProgressBarModule,
            CdkTableModule,
            MaterialModule,
            FtCoreModule,
            DragDropModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: FtTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        TranslateModule,
                        MatProgressBarModule,
                        CdkTableModule,
                        MaterialModule,
                        FtCoreModule,
                        DragDropModule
                    ],
                    declarations: [
                        BasicGenericViewTableComponent,
                        GenericBodyTableComponent,
                        GenericViewComponent,
                        ViewDialogComponent,
                        IconDialogComponent,
                        StyleRulesComponent,
                        FilterDialogComponent,
                        GenericViewTableComponent,
                        BaseTableComponent
                    ],
                    exports: [
                        BasicGenericViewTableComponent, GenericViewComponent, GenericViewTableComponent, GenericBodyTableComponent, BaseTableComponent
                    ],
                    providers: [
                        {
                            provide: MatPaginatorIntl, deps: [TranslateService],
                            useFactory: paginatorIntl
                        },
                        FtViewService
                    ]
                }]
        }] });

/*
 * Public API Surface of ft-table
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BaseTableComponent, BasicGenericViewTableComponent, FilterDialogComponent, FtTableModule, GenericBodyTableComponent, GenericViewComponent, GenericViewTableComponent, ViewDialogComponent, lang as tableEnLang, lang$1 as tableFrLang };
